import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import * as e from "react";
import t, { useMemo as n, createContext as r, useContext as a, useEffect as o, useLayoutEffect as i, useRef as l, useState as s, forwardRef as c, Fragment as u, isValidElement as d, cloneElement as f, createElement as p, useReducer as m, createRef as g, useCallback as v } from "react";
import { createPortal as h } from "react-dom";
function b(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;
    for (r = Object.getOwnPropertySymbols(e); a < r.length; a++) t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  }
  return n;
}
"function" == typeof SuppressedError && SuppressedError;
const y = {
    success: "text-green-800 bg-green-50 border-green-100",
    info: "text-blue-800 bg-blue-50 border-blue-100",
    warning: "text-yellow-800 bg-yellow-50 border-yellow-100",
    danger: "text-red-900 bg-red-50 border-red-100"
  },
  w = e => {
    var {
        children: n,
        className: r,
        variant: a
      } = e,
      o = b(e, ["children", "className", "variant"]);
    const i = ["p-4 mb-6 border border-solid border-1 break-words", y[a], r].join(" ");
    return t.createElement("div", Object.assign({
      className: i,
      role: "alert"
    }, o), n);
  },
  x = ["relative", "inline-block", "mt-[0.5px]", "border-solid", "border-3", "active:before:w-full", "active:before:h-full", "active:before:absolute", "active:before:inset-0", "active:before:border-3", "active:before:border-transparent", "active:before:bg-gray-900", "active:before:opacity-20", "text-center", "cursor-pointer", "no-underline"],
  k = t.forwardRef((e, n) => {
    var {
        className: r,
        onClick: a,
        disabled: o,
        children: i,
        type: l = "button"
      } = e,
      s = b(e, ["className", "onClick", "disabled", "children", "type"]);
    return t.createElement("button", Object.assign({
      className: r,
      onClick: e => {
        o ? e.preventDefault() : a && a(e);
      },
      "aria-disabled": o,
      ref: n,
      type: l
    }, s), i);
  }),
  E = t.forwardRef((e, n) => {
    var {
        className: r,
        href: a,
        download: o,
        target: i,
        children: l
      } = e,
      s = b(e, ["className", "href", "download", "target", "children"]);
    return t.createElement("a", Object.assign({
      className: r,
      download: o,
      target: i,
      ref: n,
      href: a
    }, s), l);
  }),
  S = t.forwardRef((e, n) => {
    var {
        onClick: r,
        className: a,
        children: o,
        disabled: i,
        href: l,
        download: s,
        target: c
      } = e,
      u = b(e, ["onClick", "className", "children", "disabled", "href", "download", "target"]);
    return l && !i ? t.createElement(E, Object.assign({
      className: a,
      href: l,
      download: s,
      target: c,
      rel: "_blank" === c ? "noopener noreferrer" : "",
      ref: n,
      onClick: r
    }, u), o) : t.createElement(k, Object.assign({
      className: a,
      onClick: r,
      disabled: i,
      ref: n
    }, u), o);
  }),
  O = t.forwardRef((e, r) => {
    var {
        className: a,
        size: o = "medium",
        disabled: i,
        variant: l = "primary",
        block: s
      } = e,
      c = b(e, ["className", "size", "disabled", "variant", "block"]);
    const u = [a, n(() => (_ref => {
      let {
        size: e,
        variant: t,
        disabled: n,
        block: r
      } = _ref;
      const a = [...x];
      switch (r && a.push("block", "w-full"), t) {
        case "danger":
          a.push(...(n ? ["border-gray-450", "bg-background-danger-disabled", "text-foreground-danger-disabled"] : ["border-foreground-danger", "bg-background-danger", "text-foreground-danger", "hover:bg-foreground-danger", "hover:text-background-danger", "hover:border-foreground-danger", "dark:hover:bg-background-danger", "dark:hover:text-foreground-danger"]));
          break;
        case "info":
          a.push("border-foreground-info", "bg-background-info", "text-foreground-info", "hover:bg-foreground-info", "hover:text-background-info", "hover:border-foreground-info", "dark:hover:bg-background-info", "dark:hover:text-foreground-info");
          break;
        default:
          a.push("bg-background-quaternary", "text-foreground-secondary", ...(n ? ["border-gray-450"] : ["border-foreground-secondary", "hover:bg-foreground-primary", "hover:text-background-primary", "hover:border-foreground-secondary", "dark:hover:bg-background-primary", "dark:hover:text-foreground-primary"]));
      }
      switch (n && a.push("active:before:hidden", "aria-disabled:cursor-not-allowed", "aria-disabled:opacity-80"), e) {
        case "large":
          a.push("px-4 py-2.5 text-lg");
          break;
        case "small":
          a.push("px-2.5 py-1 text-sm");
          break;
        default:
          a.push("px-3 py-1.5 text-md");
      }
      return a.join(" ");
    })({
      size: o,
      variant: l,
      disabled: i,
      block: s
    }), [o, l, i, s])].join(" ");
    return t.createElement(S, Object.assign({
      className: u,
      ref: r,
      disabled: i
    }, c));
  });
O.displayName = "Button", S.displayName = "HeadlessButton", k.displayName = "StylessButton", E.displayName = "Link";
const N = {
    success: "text-green-800 bg-green-50 border-green-700",
    info: "text-blue-800 bg-blue-50 border-blue-700",
    warning: "text-yellow-800 bg-yellow-50 border-yellow-700",
    danger: "text-red-900 bg-red-50 border-red-700"
  },
  A = e => {
    var {
        children: n,
        className: r,
        variant: a
      } = e,
      o = b(e, ["children", "className", "variant"]);
    const i = ["p-4 mb-6 border border-solid border-1 break-words", N[a], r].join(" ");
    return t.createElement("div", Object.assign({
      className: i
    }, o), n);
  };
function P(_ref2) {
  let {
    className: e,
    label: n,
    onClick: r
  } = _ref2;
  const a = ["bg-transparent", "border-none", "text-lg", "font-bold", "text-foreground-primary", "focus:opacity-100", "focus:text-opacity-100", "hover:opacity-100", "hover:text-opacity-100", "flex", "justify-center", "items-center", "w-[24px]", "h-[24px]", "opacity-50", e].join(" ");
  return t.createElement("button", {
    className: a,
    onClick: r,
    type: "button"
  }, t.createElement("span", {
    className: "sr-only"
  }, n || "Close"), t.createElement("span", {
    "aria-hidden": !0
  }, "×"));
}
const F = {
    1: "w-1/12",
    2: "w-1/6",
    3: "w-1/4",
    4: "w-1/3",
    5: "w-5/12",
    6: "w-1/2",
    7: "w-7/12",
    8: "w-2/3",
    9: "w-3/4",
    10: "w-5/6",
    11: "w-11/12",
    12: "w-full"
  },
  T = {
    1: "ms-[8.3%]",
    2: "ms-[16.6%]",
    3: "ms-[25%]",
    4: "ms-[33.3%]",
    5: "ms-[41.7%]",
    6: "ms-[50%]",
    7: "ms-[58.3%]",
    8: "ms-[66.7%]",
    9: "ms-[75%]",
    10: "ms-[83.3%]",
    11: "ms-[91.7%]",
    12: "ms-[100%]"
  },
  j = {
    1: "md:w-1/12",
    2: "md:w-1/6",
    3: "md:w-1/4",
    4: "md:w-1/3",
    5: "md:w-5/12",
    6: "md:w-1/2",
    7: "md:w-7/12",
    8: "md:w-2/3",
    9: "md:w-3/4",
    10: "md:w-5/6",
    11: "md:w-11/12",
    12: "md:w-full"
  },
  C = {
    1: "md:ms-[8.3%]",
    2: "md:ms-[16.6%]",
    3: "md:ms-[25%]",
    4: "md:ms-[33.3%]",
    5: "md:ms-[41.7%]",
    6: "md:ms-[50%]",
    7: "md:ms-[58.3%]",
    8: "md:ms-[66.7%]",
    9: "md:ms-[75%]",
    10: "md:ms-[83.3%]",
    11: "md:ms-[91.7%]",
    12: "md:ms-[100%]"
  },
  R = {
    1: "min-[992px]:w-1/12",
    2: "min-[992px]:w-1/6",
    3: "min-[992px]:w-1/4",
    4: "min-[992px]:w-1/3",
    5: "min-[992px]:w-5/12",
    6: "min-[992px]:w-1/2",
    7: "min-[992px]:w-7/12",
    8: "min-[992px]:w-2/3",
    9: "min-[992px]:w-3/4",
    10: "min-[992px]:w-5/6",
    11: "min-[992px]:w-11/12",
    12: "min-[992px]:w-full"
  },
  I = {
    1: "min-[992px]:ms-[8.3%]",
    2: "min-[992px]:ms-[16.6%]",
    3: "min-[992px]:ms-[25%]",
    4: "min-[992px]:ms-[33.3%]",
    5: "min-[992px]:ms-[41.7%]",
    6: "min-[992px]:ms-[50%]",
    7: "min-[992px]:ms-[58.3%]",
    8: "min-[992px]:ms-[66.7%]",
    9: "min-[992px]:ms-[75%]",
    10: "min-[992px]:ms-[83.3%]",
    11: "min-[992px]:ms-[91.7%]",
    12: "min-[992px]:ms-[100%]"
  },
  D = {
    1: "min-[1200px]:w-1/12",
    2: "min-[1200px]:w-1/6",
    3: "min-[1200px]:w-1/4",
    4: "min-[1200px]:w-1/3",
    5: "min-[1200px]:w-5/12",
    6: "min-[1200px]:w-1/2",
    7: "min-[1200px]:w-7/12",
    8: "min-[1200px]:w-2/3",
    9: "min-[1200px]:w-3/4",
    10: "min-[1200px]:w-5/6",
    11: "min-[1200px]:w-11/12",
    12: "min-[1200px]:w-full"
  },
  L = {
    0: "min-[1200px]:ms-0",
    1: "min-[1200px]:ms-[8.3%]",
    2: "min-[1200px]:ms-[16.6%]",
    3: "min-[1200px]:ms-[25%]",
    4: "min-[1200px]:ms-[33.3%]",
    5: "min-[1200px]:ms-[41.7%]",
    6: "min-[1200px]:ms-[50%]",
    7: "min-[1200px]:ms-[58.3%]",
    8: "min-[1200px]:ms-[66.7%]",
    9: "min-[1200px]:ms-[75%]",
    10: "min-[1200px]:ms-[83.3%]",
    11: "min-[1200px]:ms-[91.7%]",
    12: "min-[1200px]:ms-[100%]"
  },
  M = e => {
    var {
        className: n,
        children: r,
        xs: a,
        sm: o,
        md: i,
        lg: l,
        xsOffset: s,
        smOffset: c,
        mdOffset: u,
        lgOffset: d
      } = e,
      f = b(e, ["className", "children", "xs", "sm", "md", "lg", "xsOffset", "smOffset", "mdOffset", "lgOffset"]);
    const p = a ? F[a] : "",
      m = s ? T[s] : "",
      g = o ? j[o] : "",
      v = c ? C[c] : "",
      h = i ? R[i] : "",
      y = u ? I[u] : "",
      w = l ? D[l] : "",
      x = void 0 !== d ? L[d] : "";
    return t.createElement("div", Object.assign({
      className: "".concat(null != n ? n : "", " min-h-[1px] px-[15px] ").concat(p, " ").concat(g, " ").concat(h, " ").concat(w, " ").concat(m, " ").concat(v, " ").concat(y, " ").concat(x, " ")
    }, f), r);
  },
  _ = _ref3 => {
    let {
      children: e,
      className: n,
      fluid: r
    } = _ref3;
    const a = r ? "" : "my-0 md:w-[750px] min-[992px]:w-[970px] min-[1200px]:w-[1170px]";
    return t.createElement("div", {
      className: "mx-auto px-[15px] ".concat(a, " ").concat(null != n ? n : "")
    }, e);
  },
  $ = r({}),
  z = "mb-3.5 relative",
  B = e => {
    var {
        className: n,
        validationState: r,
        controlId: a,
        as: o
      } = e,
      i = b(e, ["className", "validationState", "controlId", "as"]);
    const l = {
        controlId: a,
        validationState: r
      },
      s = o || "div",
      c = [z, n].join(" ");
    return t.createElement($.Provider, {
      value: l
    }, t.createElement(s, Object.assign({
      className: c,
      as: o
    }, i, {
      validationstate: r
    })));
  },
  H = {
    success: "text-background-info",
    warning: "text-background-warning",
    error: "text-background-danger"
  },
  U = e => {
    var {
        className: n,
        htmlFor: r,
        srOnly: o
      } = e,
      i = b(e, ["className", "htmlFor", "srOnly"]);
    const {
        controlId: l,
        validationState: s
      } = a($),
      c = ["font-bold", s ? H[s] : "text-foreground-primary", o ? "sr-only" : void 0, n].join(" ");
    return t.createElement("label", Object.assign({
      className: c,
      htmlFor: r || l
    }, i));
  };
var W = Object.defineProperty,
  q = (e, t, n) => (((e, t, n) => {
    t in e ? W(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  })(e, "symbol" != typeof t ? t + "" : t, n), n);
let V = new class {
    constructor() {
      q(this, "current", this.detect()), q(this, "handoffState", "pending"), q(this, "currentId", 0);
    }
    set(e) {
      this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
      this.set(this.detect());
    }
    nextId() {
      return ++this.currentId;
    }
    get isServer() {
      return "server" === this.current;
    }
    get isClient() {
      return "client" === this.current;
    }
    detect() {
      return "undefined" == typeof window || "undefined" == typeof document ? "server" : "client";
    }
    handoff() {
      "pending" === this.handoffState && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
      return "complete" === this.handoffState;
    }
  }(),
  Y = (e, t) => {
    V.isServer ? o(e, t) : i(e, t);
  };
function G(e) {
  let t = l(e);
  return Y(() => {
    t.current = e;
  }, [e]), t;
}
let K = function (e) {
  let n = G(e);
  return t.useCallback(function () {
    return n.current(...arguments);
  }, [n]);
};
function X(e) {
  "function" == typeof queueMicrotask ? queueMicrotask(e) : Promise.resolve().then(e).catch(e => setTimeout(() => {
    throw e;
  }));
}
function J() {
  let e = [],
    t = {
      addEventListener: (e, n, r, a) => (e.addEventListener(n, r, a), t.add(() => e.removeEventListener(n, r, a))),
      requestAnimationFrame() {
        let n = requestAnimationFrame(...arguments);
        return t.add(() => cancelAnimationFrame(n));
      },
      nextFrame: function () {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        return t.requestAnimationFrame(() => t.requestAnimationFrame(...e));
      },
      setTimeout() {
        let n = setTimeout(...arguments);
        return t.add(() => clearTimeout(n));
      },
      microTask() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        let n = {
          current: !0
        };
        return X(() => {
          n.current && e[0]();
        }), t.add(() => {
          n.current = !1;
        });
      },
      style(e, t, n) {
        let r = e.style.getPropertyValue(t);
        return Object.assign(e.style, {
          [t]: n
        }), this.add(() => {
          Object.assign(e.style, {
            [t]: r
          });
        });
      },
      group(e) {
        let t = J();
        return e(t), this.add(() => t.dispose());
      },
      add: t => (e.push(t), () => {
        let n = e.indexOf(t);
        if (n >= 0) for (let t of e.splice(n, 1)) t();
      }),
      dispose() {
        for (let t of e.splice(0)) t();
      }
    };
  return t;
}
function Q() {
  let [e] = s(J);
  return o(() => () => e.dispose(), [e]), e;
}
function Z() {
  let t = function () {
      let t = "undefined" == typeof document;
      return "useSyncExternalStore" in e && e.useSyncExternalStore(() => () => {}, () => !1, () => !t);
    }(),
    [n, r] = e.useState(V.isHandoffComplete);
  return n && !1 === V.isHandoffComplete && r(!1), e.useEffect(() => {
    !0 !== n && r(!0);
  }, [n]), e.useEffect(() => V.handoff(), []), !t && n;
}
var ee;
let te = null != (ee = t.useId) ? ee : function () {
  let e = Z(),
    [n, r] = t.useState(e ? () => V.nextId() : null);
  return Y(() => {
    null === n && r(V.nextId());
  }, [n]), null != n ? "" + n : void 0;
};
function ne(e, t) {
  if (e in t) {
    let r = t[e];
    for (var _len3 = arguments.length, n = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      n[_key3 - 2] = arguments[_key3];
    }
    return "function" == typeof r ? r(...n) : r;
  }
  let r = new Error("Tried to handle \"".concat(e, "\" but there is no handler defined. Only defined handlers are: ").concat(Object.keys(t).map(e => "\"".concat(e, "\"")).join(", "), "."));
  throw Error.captureStackTrace && Error.captureStackTrace(r, ne), r;
}
function re(e) {
  return V.isServer ? null : e instanceof Node ? e.ownerDocument : null != e && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let ae = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(e => "".concat(e, ":not([tabindex='-1'])")).join(",");
var oe = (e => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(oe || {}),
  ie = (e => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(ie || {}),
  le = (e => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(le || {});
function se() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return null == e ? [] : Array.from(e.querySelectorAll(ae)).sort((e, t) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var ce = (e => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(ce || {});
function ue(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n;
  return e !== (null == (n = re(e)) ? void 0 : n.body) && ne(t, {
    0: () => e.matches(ae),
    1() {
      let t = e;
      for (; null !== t;) {
        if (t.matches(ae)) return !0;
        t = t.parentElement;
      }
      return !1;
    }
  });
}
function de(e) {
  let t = re(e);
  J().nextFrame(() => {
    t && !ue(t.activeElement, 0) && pe(e);
  });
}
var fe = (e => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(fe || {});
function pe(e) {
  null == e || e.focus({
    preventScroll: !0
  });
}
"undefined" != typeof window && "undefined" != typeof document && (document.addEventListener("keydown", e => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", e => {
  1 === e.detail ? delete document.documentElement.dataset.headlessuiFocusVisible : 0 === e.detail && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let me = ["textarea", "input"].join(",");
function ge(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e => e;
  return e.slice().sort((e, n) => {
    let r = t(e),
      a = t(n);
    if (null === r || null === a) return 0;
    let o = r.compareDocumentPosition(a);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function ve(e, t) {
  let {
    sorted: n = !0,
    relativeTo: r = null,
    skipElements: a = []
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
    i = Array.isArray(e) ? n ? ge(e) : e : se(e);
  a.length > 0 && i.length > 1 && (i = i.filter(e => !a.includes(e))), r = null != r ? r : o.activeElement;
  let l,
    s = (() => {
      if (5 & t) return 1;
      if (10 & t) return -1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(),
    c = (() => {
      if (1 & t) return 0;
      if (2 & t) return Math.max(0, i.indexOf(r)) - 1;
      if (4 & t) return Math.max(0, i.indexOf(r)) + 1;
      if (8 & t) return i.length - 1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(),
    u = 32 & t ? {
      preventScroll: !0
    } : {},
    d = 0,
    f = i.length;
  do {
    if (d >= f || d + f <= 0) return 0;
    let e = c + d;
    if (16 & t) e = (e + f) % f;else {
      if (e < 0) return 3;
      if (e >= f) return 1;
    }
    l = i[e], null == l || l.focus(u), d += s;
  } while (l !== o.activeElement);
  return 6 & t && function (e) {
    var t, n;
    return null != (n = null == (t = null == e ? void 0 : e.matches) ? void 0 : t.call(e, me)) && n;
  }(l) && l.select(), 2;
}
function he() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function be() {
  return he() || /Android/gi.test(window.navigator.userAgent);
}
function ye(e, t, n) {
  let r = G(t);
  o(() => {
    function t(e) {
      r.current(e);
    }
    return document.addEventListener(e, t, n), () => document.removeEventListener(e, t, n);
  }, [e, n]);
}
function we(e, t, n) {
  let r = G(t);
  o(() => {
    function t(e) {
      r.current(e);
    }
    return window.addEventListener(e, t, n), () => window.removeEventListener(e, t, n);
  }, [e, n]);
}
function xe(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  let r = l(!1);
  function a(n, a) {
    if (!r.current || n.defaultPrevented) return;
    let o = a(n);
    if (null === o || !o.getRootNode().contains(o) || !o.isConnected) return;
    let i = function e(t) {
      return "function" == typeof t ? e(t()) : Array.isArray(t) || t instanceof Set ? t : [t];
    }(e);
    for (let e of i) {
      if (null === e) continue;
      let t = e instanceof HTMLElement ? e : e.current;
      if (null != t && t.contains(o) || n.composed && n.composedPath().includes(t)) return;
    }
    return !ue(o, ce.Loose) && -1 !== o.tabIndex && n.preventDefault(), t(n, o);
  }
  o(() => {
    requestAnimationFrame(() => {
      r.current = n;
    });
  }, [n]);
  let i = l(null);
  ye("pointerdown", e => {
    var t, n;
    r.current && (i.current = (null == (n = null == (t = e.composedPath) ? void 0 : t.call(e)) ? void 0 : n[0]) || e.target);
  }, !0), ye("mousedown", e => {
    var t, n;
    r.current && (i.current = (null == (n = null == (t = e.composedPath) ? void 0 : t.call(e)) ? void 0 : n[0]) || e.target);
  }, !0), ye("click", e => {
    be() || i.current && (a(e, () => i.current), i.current = null);
  }, !0), ye("touchend", e => a(e, () => e.target instanceof HTMLElement ? e.target : null), !0), we("blur", e => a(e, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function ke() {
  for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    e[_key4] = arguments[_key4];
  }
  return n(() => re(...e), [...e]);
}
function Ee(e) {
  var t;
  if (e.type) return e.type;
  let n = null != (t = e.as) ? t : "button";
  return "string" == typeof n && "button" === n.toLowerCase() ? "button" : void 0;
}
function Se(e, t) {
  let [n, r] = s(() => Ee(e));
  return Y(() => {
    r(Ee(e));
  }, [e.type, e.as]), Y(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}
let Oe = Symbol();
function Ne() {
  for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    e[_key5] = arguments[_key5];
  }
  let t = l(e);
  o(() => {
    t.current = e;
  }, [e]);
  let n = K(e => {
    for (let n of t.current) null != n && ("function" == typeof n ? n(e) : n.current = e);
  });
  return e.every(e => null == e || (null == e ? void 0 : e[Oe])) ? void 0 : n;
}
function Ae(e) {
  return [e.screenX, e.screenY];
}
function Pe(_ref4) {
  let {
    container: e,
    accept: t,
    walk: n,
    enabled: r = !0
  } = _ref4;
  let a = l(t),
    i = l(n);
  o(() => {
    a.current = t, i.current = n;
  }, [t, n]), Y(() => {
    if (!e || !r) return;
    let t = re(e);
    if (!t) return;
    let n = a.current,
      o = i.current,
      l = Object.assign(e => n(e), {
        acceptNode: n
      }),
      s = t.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, l, !1);
    for (; s.nextNode();) o(s.currentNode);
  }, [e, r, a, i]);
}
function Fe(e, t) {
  let n = l([]),
    r = K(e);
  o(() => {
    let e = [...n.current];
    for (let [a, o] of t.entries()) if (n.current[a] !== o) {
      let a = r(t, e);
      return n.current = t, a;
    }
  }, [r, ...t]);
}
function Te() {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }
  return Array.from(new Set(e.flatMap(e => "string" == typeof e ? e.split(" ") : []))).filter(Boolean).join(" ");
}
var je = (e => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(je || {}),
  Ce = (e => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Ce || {});
function Re(_ref5) {
  let {
    ourProps: e,
    theirProps: t,
    slot: n,
    defaultTag: r,
    features: a,
    visible: o = !0,
    name: i,
    mergeRefs: l
  } = _ref5;
  l = null != l ? l : De;
  let s = Le(t, e);
  if (o) return Ie(s, n, r, i, l);
  let c = null != a ? a : 0;
  if (2 & c) {
    let {
      static: e = !1,
      ...t
    } = s;
    if (e) return Ie(t, n, r, i, l);
  }
  if (1 & c) {
    let {
      unmount: e = !0,
      ...t
    } = s;
    return ne(e ? 0 : 1, {
      0: () => null,
      1: () => Ie({
        ...t,
        hidden: !0,
        style: {
          display: "none"
        }
      }, n, r, i, l)
    });
  }
  return Ie(s, n, r, i, l);
}
function Ie(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let n = arguments.length > 2 ? arguments[2] : undefined;
  let r = arguments.length > 3 ? arguments[3] : undefined;
  let a = arguments.length > 4 ? arguments[4] : undefined;
  let {
      as: o = n,
      children: i,
      refName: l = "ref",
      ...s
    } = $e(e, ["unmount", "static"]),
    c = void 0 !== e.ref ? {
      [l]: e.ref
    } : {},
    m = "function" == typeof i ? i(t) : i;
  "className" in s && s.className && "function" == typeof s.className && (s.className = s.className(t));
  let g = {};
  if (t) {
    let e = !1,
      n = [];
    for (let [r, a] of Object.entries(t)) "boolean" == typeof a && (e = !0), !0 === a && n.push(r);
    e && (g["data-headlessui-state"] = n.join(" "));
  }
  if (o === u && Object.keys(_e(s)).length > 0) {
    if (!d(m) || Array.isArray(m) && m.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(r, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(s).map(e => "  - ".concat(e)).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(e => "  - ".concat(e)).join("\n")].join("\n"));
    let e = m.props,
      t = "function" == typeof (null == e ? void 0 : e.className) ? function () {
        return Te(null == e ? void 0 : e.className(...arguments), s.className);
      } : Te(null == e ? void 0 : e.className, s.className),
      n = t ? {
        className: t
      } : {};
    return f(m, Object.assign({}, Le(m.props, _e($e(s, ["ref"]))), g, c, {
      ref: a(m.ref, c.ref)
    }, n));
  }
  return p(o, Object.assign({}, $e(s, ["ref"]), o !== u && c, o !== u && g), m);
}
function De() {
  for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    e[_key7] = arguments[_key7];
  }
  return e.every(e => null == e) ? void 0 : t => {
    for (let n of e) null != n && ("function" == typeof n ? n(t) : n.current = t);
  };
}
function Le() {
  for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    e[_key8] = arguments[_key8];
  }
  if (0 === e.length) return {};
  if (1 === e.length) return e[0];
  let t = {},
    n = {};
  for (let r of e) for (let e in r) e.startsWith("on") && "function" == typeof r[e] ? (null != n[e] || (n[e] = []), n[e].push(r[e])) : t[e] = r[e];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map(e => [e, void 0])));
  for (let e in n) Object.assign(t, {
    [e](t) {
      let a = n[e];
      for (var _len9 = arguments.length, r = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        r[_key9 - 1] = arguments[_key9];
      }
      for (let e of a) {
        if ((t instanceof Event || (null == t ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
        e(t, ...r);
      }
    }
  });
  return t;
}
function Me(e) {
  var t;
  return Object.assign(c(e), {
    displayName: null != (t = e.displayName) ? t : e.name
  });
}
function _e(e) {
  let t = Object.assign({}, e);
  for (let e in t) void 0 === t[e] && delete t[e];
  return t;
}
function $e(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let n = Object.assign({}, e);
  for (let e of t) e in n && delete n[e];
  return n;
}
var ze = (e => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(ze || {});
let Be = Me(function (e, t) {
    var n;
    let {
      features: r = 1,
      ...a
    } = e;
    return Re({
      ourProps: {
        ref: t,
        "aria-hidden": !(2 & ~r) || (null != (n = a["aria-hidden"]) ? n : void 0),
        hidden: !(4 & ~r) || void 0,
        style: {
          position: "fixed",
          top: 1,
          left: 1,
          width: 1,
          height: 0,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          borderWidth: "0",
          ...(!(4 & ~r) && !!(2 & ~r) && {
            display: "none"
          })
        }
      },
      theirProps: a,
      slot: {},
      defaultTag: "div",
      name: "Hidden"
    });
  }),
  He = r(null);
He.displayName = "OpenClosedContext";
var Ue = (e => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Ue || {});
function We() {
  return a(He);
}
function qe(_ref6) {
  let {
    value: e,
    children: n
  } = _ref6;
  return t.createElement(He.Provider, {
    value: e
  }, n);
}
let Ve = [];
function Ye(e) {
  let t = e.parentElement,
    n = null;
  for (; t && !(t instanceof HTMLFieldSetElement);) t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = "" === (null == t ? void 0 : t.getAttribute("disabled"));
  return (!r || !function (e) {
    if (!e) return !1;
    let t = e.previousElementSibling;
    for (; null !== t;) {
      if (t instanceof HTMLLegendElement) return !1;
      t = t.previousElementSibling;
    }
    return !0;
  }(n)) && r;
}
!function (e) {
  function t() {
    "loading" !== document.readyState && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  "undefined" != typeof window && "undefined" != typeof document && (document.addEventListener("DOMContentLoaded", t), t());
}(() => {
  function e(e) {
    e.target instanceof HTMLElement && e.target !== document.body && Ve[0] !== e.target && (Ve.unshift(e.target), Ve = Ve.filter(e => null != e && e.isConnected), Ve.splice(10));
  }
  window.addEventListener("click", e, {
    capture: !0
  }), window.addEventListener("mousedown", e, {
    capture: !0
  }), window.addEventListener("focus", e, {
    capture: !0
  }), document.body.addEventListener("click", e, {
    capture: !0
  }), document.body.addEventListener("mousedown", e, {
    capture: !0
  }), document.body.addEventListener("focus", e, {
    capture: !0
  });
});
var Ge = (e => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Ge || {});
function Ke(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(),
    a = null != r ? r : -1;
  switch (e.focus) {
    case 0:
      for (let e = 0; e < n.length; ++e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 1:
      for (let e = a - 1; e >= 0; --e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 2:
      for (let e = a + 1; e < n.length; ++e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 3:
      for (let e = n.length - 1; e >= 0; --e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 4:
      for (let r = 0; r < n.length; ++r) if (t.resolveId(n[r], r, n) === e.id) return r;
      return r;
    case 5:
      return null;
    default:
      !function (e) {
        throw new Error("Unexpected object: " + e);
      }(e);
  }
}
function Xe() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  for (let [r, a] of Object.entries(e)) Qe(n, Je(t, r), a);
  return n;
}
function Je(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Qe(e, t, n) {
  if (Array.isArray(n)) for (let [r, a] of n.entries()) Qe(e, Je(t, r.toString()), a);else n instanceof Date ? e.push([t, n.toISOString()]) : "boolean" == typeof n ? e.push([t, n ? "1" : "0"]) : "string" == typeof n ? e.push([t, n]) : "number" == typeof n ? e.push([t, "".concat(n)]) : null == n ? e.push([t, ""]) : Xe(n, t, e);
}
var Ze = (e => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Ze || {});
function et(e, t, n, r) {
  let a = G(n);
  o(() => {
    function n(e) {
      a.current(e);
    }
    return (e = null != e ? e : window).addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
  }, [e, t, r]);
}
function tt() {
  let e = l(!1);
  return Y(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function nt(e) {
  let t = K(e),
    n = l(!1);
  o(() => (n.current = !1, () => {
    n.current = !0, X(() => {
      n.current && t();
    });
  }), [t]);
}
var rt = (e => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(rt || {});
function at(e) {
  if (!e) return new Set();
  if ("function" == typeof e) return new Set(e());
  let t = new Set();
  for (let n of e.current) n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
var ot = (e => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(ot || {});
let it = Me(function (e, n) {
    let r = l(null),
      a = Ne(r, n),
      {
        initialFocus: o,
        containers: i,
        features: s = 30,
        ...c
      } = e;
    Z() || (s = 1);
    let u = ke(r);
    !function (_ref7, t) {
      let {
        ownerDocument: e
      } = _ref7;
      let n = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        let t = l(Ve.slice());
        return Fe((_ref8, _ref9) => {
          let [e] = _ref8;
          let [n] = _ref9;
          !0 === n && !1 === e && X(() => {
            t.current.splice(0);
          }), !1 === n && !0 === e && (t.current = Ve.slice());
        }, [e, Ve, t]), K(() => {
          var e;
          return null != (e = t.current.find(e => null != e && e.isConnected)) ? e : null;
        });
      }(t);
      Fe(() => {
        t || (null == e ? void 0 : e.activeElement) === (null == e ? void 0 : e.body) && pe(n());
      }, [t]), nt(() => {
        t && pe(n());
      });
    }({
      ownerDocument: u
    }, Boolean(16 & s));
    let d = function (_ref10, r) {
      let {
        ownerDocument: e,
        container: t,
        initialFocus: n
      } = _ref10;
      let a = l(null),
        o = tt();
      return Fe(() => {
        if (!r) return;
        let i = t.current;
        i && X(() => {
          if (!o.current) return;
          let t = null == e ? void 0 : e.activeElement;
          if (null != n && n.current) {
            if ((null == n ? void 0 : n.current) === t) return void (a.current = t);
          } else if (i.contains(t)) return void (a.current = t);
          null != n && n.current ? pe(n.current) : ve(i, oe.First) === ie.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), a.current = null == e ? void 0 : e.activeElement;
        });
      }, [r]), a;
    }({
      ownerDocument: u,
      container: r,
      initialFocus: o
    }, Boolean(2 & s));
    !function (_ref11, a) {
      let {
        ownerDocument: e,
        container: t,
        containers: n,
        previousActiveElement: r
      } = _ref11;
      let o = tt();
      et(null == e ? void 0 : e.defaultView, "focus", e => {
        if (!a || !o.current) return;
        let i = at(n);
        t.current instanceof HTMLElement && i.add(t.current);
        let l = r.current;
        if (!l) return;
        let s = e.target;
        s && s instanceof HTMLElement ? st(i, s) ? (r.current = s, pe(s)) : (e.preventDefault(), e.stopPropagation(), pe(l)) : pe(r.current);
      }, !0);
    }({
      ownerDocument: u,
      container: r,
      containers: i,
      previousActiveElement: d
    }, Boolean(8 & s));
    let f = function () {
        let e = l(0);
        return we("keydown", t => {
          "Tab" === t.key && (e.current = t.shiftKey ? 1 : 0);
        }, !0), e;
      }(),
      p = K(e => {
        let t = r.current;
        t && ne(f.current, {
          [rt.Forwards]: () => {
            ve(t, oe.First, {
              skipElements: [e.relatedTarget]
            });
          },
          [rt.Backwards]: () => {
            ve(t, oe.Last, {
              skipElements: [e.relatedTarget]
            });
          }
        });
      }),
      m = Q(),
      g = l(!1),
      v = {
        ref: a,
        onKeyDown(e) {
          "Tab" == e.key && (g.current = !0, m.requestAnimationFrame(() => {
            g.current = !1;
          }));
        },
        onBlur(e) {
          let t = at(i);
          r.current instanceof HTMLElement && t.add(r.current);
          let n = e.relatedTarget;
          n instanceof HTMLElement && "true" !== n.dataset.headlessuiFocusGuard && (st(t, n) || (g.current ? ve(r.current, ne(f.current, {
            [rt.Forwards]: () => oe.Next,
            [rt.Backwards]: () => oe.Previous
          }) | oe.WrapAround, {
            relativeTo: e.target
          }) : e.target instanceof HTMLElement && pe(e.target)));
        }
      };
    return t.createElement(t.Fragment, null, Boolean(4 & s) && t.createElement(Be, {
      as: "button",
      type: "button",
      "data-headlessui-focus-guard": !0,
      onFocus: p,
      features: ze.Focusable
    }), Re({
      ourProps: v,
      theirProps: c,
      defaultTag: "div",
      name: "FocusTrap"
    }), Boolean(4 & s) && t.createElement(Be, {
      as: "button",
      type: "button",
      "data-headlessui-focus-guard": !0,
      onFocus: p,
      features: ze.Focusable
    }));
  }),
  lt = Object.assign(it, {
    features: ot
  });
function st(e, t) {
  for (let n of e) if (n.contains(t)) return !0;
  return !1;
}
let ct = r(!1);
function ut(e) {
  return t.createElement(ct.Provider, {
    value: e.force
  }, e.children);
}
function dt(e) {
  let t = a(ct),
    n = a(mt),
    r = ke(e),
    [i, l] = s(() => {
      if (!t && null !== n || V.isServer) return null;
      let e = null == r ? void 0 : r.getElementById("headlessui-portal-root");
      if (e) return e;
      if (null === r) return null;
      let a = r.createElement("div");
      return a.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(a);
    });
  return o(() => {
    null !== i && (null != r && r.body.contains(i) || null == r || r.body.appendChild(i));
  }, [i, r]), o(() => {
    t || null !== n && l(n.current);
  }, [n, l, t]), i;
}
let ft = u;
let pt = u,
  mt = r(null);
let gt = r(null);
let vt = Me(function (e, t) {
    let n = e,
      r = l(null),
      o = Ne(function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        return Object.assign(e, {
          [Oe]: t
        });
      }(e => {
        r.current = e;
      }), t),
      i = ke(r),
      c = dt(r),
      [u] = s(() => {
        var e;
        return V.isServer ? null : null != (e = null == i ? void 0 : i.createElement("div")) ? e : null;
      }),
      d = a(gt),
      f = Z();
    return Y(() => {
      !c || !u || c.contains(u) || (u.setAttribute("data-headlessui-portal", ""), c.appendChild(u));
    }, [c, u]), Y(() => {
      if (u && d) return d.register(u);
    }, [d, u]), nt(() => {
      var e;
      !c || !u || (u instanceof Node && c.contains(u) && c.removeChild(u), c.childNodes.length <= 0 && (null == (e = c.parentElement) || e.removeChild(c)));
    }), f && c && u ? h(Re({
      ourProps: {
        ref: o
      },
      theirProps: n,
      defaultTag: ft,
      name: "Portal"
    }), u) : null;
  }),
  ht = Me(function (e, n) {
    let {
        target: r,
        ...a
      } = e,
      o = {
        ref: Ne(n)
      };
    return t.createElement(mt.Provider, {
      value: r
    }, Re({
      ourProps: o,
      theirProps: a,
      defaultTag: pt,
      name: "Popover.Group"
    }));
  }),
  bt = Object.assign(vt, {
    Group: ht
  });
const yt = "function" == typeof Object.is ? Object.is : function (e, t) {
    return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
  },
  {
    useState: wt,
    useEffect: xt,
    useLayoutEffect: kt,
    useDebugValue: Et
  } = e;
function St(e) {
  const t = e.getSnapshot,
    n = e.value;
  try {
    const e = t();
    return !yt(n, e);
  } catch {
    return !0;
  }
}
const Ot = !("undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement) ? function (e, t, n) {
    return t();
  } : function (e, t, n) {
    const r = t(),
      [{
        inst: a
      }, o] = wt({
        inst: {
          value: r,
          getSnapshot: t
        }
      });
    return kt(() => {
      a.value = r, a.getSnapshot = t, St(a) && o({
        inst: a
      });
    }, [e, r, t]), xt(() => (St(a) && o({
      inst: a
    }), e(() => {
      St(a) && o({
        inst: a
      });
    })), [e]), Et(r), r;
  },
  Nt = "useSyncExternalStore" in e ? e.useSyncExternalStore : Ot;
function At() {
  let e;
  return {
    before(_ref12) {
      let {
        doc: t
      } = _ref12;
      var n;
      let r = t.documentElement;
      e = (null != (n = t.defaultView) ? n : window).innerWidth - r.clientWidth;
    },
    after(_ref13) {
      let {
        doc: t,
        d: n
      } = _ref13;
      let r = t.documentElement,
        a = r.clientWidth - r.offsetWidth,
        o = e - a;
      n.style(r, "paddingRight", "".concat(o, "px"));
    }
  };
}
function Pt(e) {
  let t = {};
  for (let n of e) Object.assign(t, n(t));
  return t;
}
let Ft = function (e, t) {
  let n = e(),
    r = new Set();
  return {
    getSnapshot: () => n,
    subscribe: e => (r.add(e), () => r.delete(e)),
    dispatch(e) {
      for (var _len10 = arguments.length, a = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        a[_key10 - 1] = arguments[_key10];
      }
      let o = t[e].call(n, ...a);
      o && (n = o, r.forEach(e => e()));
    }
  };
}(() => new Map(), {
  PUSH(e, t) {
    var n;
    let r = null != (n = this.get(e)) ? n : {
      doc: e,
      count: 0,
      d: J(),
      meta: new Set()
    };
    return r.count++, r.meta.add(t), this.set(e, r), this;
  },
  POP(e, t) {
    let n = this.get(e);
    return n && (n.count--, n.meta.delete(t)), this;
  },
  SCROLL_PREVENT(_ref14) {
    let {
      doc: e,
      d: t,
      meta: n
    } = _ref14;
    let r = {
        doc: e,
        d: t,
        meta: Pt(n)
      },
      a = [he() ? {
        before(_ref15) {
          let {
            doc: e,
            d: t,
            meta: n
          } = _ref15;
          function r(e) {
            return n.containers.flatMap(e => e()).some(t => t.contains(e));
          }
          t.microTask(() => {
            var n;
            if ("auto" !== window.getComputedStyle(e.documentElement).scrollBehavior) {
              let n = J();
              n.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => n.dispose()));
            }
            let a = null != (n = window.scrollY) ? n : window.pageYOffset,
              o = null;
            t.addEventListener(e, "click", t => {
              if (t.target instanceof HTMLElement) try {
                let n = t.target.closest("a");
                if (!n) return;
                let {
                    hash: a
                  } = new URL(n.href),
                  i = e.querySelector(a);
                i && !r(i) && (o = i);
              } catch {}
            }, !0), t.addEventListener(e, "touchstart", e => {
              if (e.target instanceof HTMLElement) if (r(e.target)) {
                let n = e.target;
                for (; n.parentElement && r(n.parentElement);) n = n.parentElement;
                t.style(n, "overscrollBehavior", "contain");
              } else t.style(e.target, "touchAction", "none");
            }), t.addEventListener(e, "touchmove", e => {
              if (e.target instanceof HTMLElement) if (r(e.target)) {
                let t = e.target;
                for (; t.parentElement && "" !== t.dataset.headlessuiPortal && !(t.scrollHeight > t.clientHeight || t.scrollWidth > t.clientWidth);) t = t.parentElement;
                "" === t.dataset.headlessuiPortal && e.preventDefault();
              } else e.preventDefault();
            }, {
              passive: !1
            }), t.add(() => {
              var e;
              let t = null != (e = window.scrollY) ? e : window.pageYOffset;
              a !== t && window.scrollTo(0, a), o && o.isConnected && (o.scrollIntoView({
                block: "nearest"
              }), o = null);
            });
          });
        }
      } : {}, At(), {
        before(_ref16) {
          let {
            doc: e,
            d: t
          } = _ref16;
          t.style(e.documentElement, "overflow", "hidden");
        }
      }];
    a.forEach(_ref17 => {
      let {
        before: e
      } = _ref17;
      return null == e ? void 0 : e(r);
    }), a.forEach(_ref18 => {
      let {
        after: e
      } = _ref18;
      return null == e ? void 0 : e(r);
    });
  },
  SCROLL_ALLOW(_ref19) {
    let {
      d: e
    } = _ref19;
    e.dispose();
  },
  TEARDOWN(_ref20) {
    let {
      doc: e
    } = _ref20;
    this.delete(e);
  }
});
function Tt(e, t, n) {
  let r = function (e) {
      return Nt(e.subscribe, e.getSnapshot, e.getSnapshot);
    }(Ft),
    a = e ? r.get(e) : void 0,
    o = !!a && a.count > 0;
  return Y(() => {
    if (e && t) return Ft.dispatch("PUSH", e, n), () => Ft.dispatch("POP", e, n);
  }, [t, e]), o;
}
Ft.subscribe(() => {
  let e = Ft.getSnapshot(),
    t = new Map();
  for (let [n] of e) t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let e = "hidden" === t.get(n.doc),
      r = 0 !== n.count;
    (r && !e || !r && e) && Ft.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), 0 === n.count && Ft.dispatch("TEARDOWN", n);
  }
});
let jt = new Map(),
  Ct = new Map();
function Rt(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  Y(() => {
    var n;
    if (!t) return;
    let r = "function" == typeof e ? e() : e.current;
    if (!r) return;
    let a = null != (n = Ct.get(r)) ? n : 0;
    return Ct.set(r, a + 1), 0 !== a || (jt.set(r, {
      "aria-hidden": r.getAttribute("aria-hidden"),
      inert: r.inert
    }), r.setAttribute("aria-hidden", "true"), r.inert = !0), function () {
      var e;
      if (!r) return;
      let t = null != (e = Ct.get(r)) ? e : 1;
      if (1 === t ? Ct.delete(r) : Ct.set(r, t - 1), 1 !== t) return;
      let n = jt.get(r);
      n && (null === n["aria-hidden"] ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", n["aria-hidden"]), r.inert = n.inert, jt.delete(r));
    };
  }, [e, t]);
}
let It = r(() => {});
It.displayName = "StackContext";
var Dt = (e => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(Dt || {});
function Lt(_ref21) {
  let {
    children: e,
    onUpdate: n,
    type: r,
    element: o,
    enabled: i
  } = _ref21;
  let l = a(It),
    s = K(function () {
      null == n || n(...arguments), l(...arguments);
    });
  return Y(() => {
    let e = void 0 === i || !0 === i;
    return e && s(0, r, o), () => {
      e && s(1, r, o);
    };
  }, [s, r, o, i]), t.createElement(It.Provider, {
    value: s
  }, e);
}
let Mt = r(null);
function _t() {
  let e = a(Mt);
  if (null === e) {
    let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, _t), e;
  }
  return e;
}
function $t() {
  let [e, r] = s([]);
  return [e.length > 0 ? e.join(" ") : void 0, n(() => function (e) {
    let a = K(e => (r(t => [...t, e]), () => r(t => {
        let n = t.slice(),
          r = n.indexOf(e);
        return -1 !== r && n.splice(r, 1), n;
      }))),
      o = n(() => ({
        register: a,
        slot: e.slot,
        name: e.name,
        props: e.props
      }), [a, e.slot, e.name, e.props]);
    return t.createElement(Mt.Provider, {
      value: o
    }, e.children);
  }, [r])];
}
let zt = Me(function (e, t) {
    let n = te(),
      {
        id: r = "headlessui-description-".concat(n),
        ...a
      } = e,
      o = _t(),
      i = Ne(t);
    return Y(() => o.register(r), [r, o.register]), Re({
      ourProps: {
        ref: i,
        ...o.props,
        id: r
      },
      theirProps: a,
      slot: o.slot || {},
      defaultTag: "p",
      name: o.name || "Description"
    });
  }),
  Bt = Object.assign(zt, {});
var Ht = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ht || {}),
  Ut = (e => (e[e.SetTitleId = 0] = "SetTitleId", e))(Ut || {});
let Wt = {
    0: (e, t) => e.titleId === t.id ? e : {
      ...e,
      titleId: t.id
    }
  },
  qt = r(null);
function Vt(e) {
  let t = a(qt);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Vt), t;
  }
  return t;
}
function Yt(e, t) {
  return ne(t.type, Wt, e, t);
}
qt.displayName = "DialogContext";
let Gt = je.RenderStrategy | je.Static;
let Kt = Me(function (e, r) {
    let i = te(),
      {
        id: c = "headlessui-dialog-".concat(i),
        open: u,
        onClose: d,
        initialFocus: f,
        role: p = "dialog",
        __demoMode: h = !1,
        ...b
      } = e,
      [y, w] = s(0),
      x = l(!1);
    p = "dialog" === p || "alertdialog" === p ? p : (x.current || (x.current = !0, console.warn("Invalid role [".concat(p, "] passed to <Dialog />. Only `dialog` and and `alertdialog` are supported. Using `dialog` instead."))), "dialog");
    let k = We();
    void 0 === u && null !== k && (u = (k & Ue.Open) === Ue.Open);
    let E = l(null),
      S = Ne(E, r),
      O = ke(E),
      N = e.hasOwnProperty("open") || null !== k,
      A = e.hasOwnProperty("onClose");
    if (!N && !A) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!N) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!A) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if ("boolean" != typeof u) throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(u));
    if ("function" != typeof d) throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(d));
    let P = u ? 0 : 1,
      [F, T] = m(Yt, {
        titleId: null,
        descriptionId: null,
        panelRef: g()
      }),
      j = K(() => d(!1)),
      C = K(e => T({
        type: 0,
        id: e
      })),
      R = !!Z() && !h && 0 === P,
      I = y > 1,
      D = null !== a(qt),
      [L, M] = function () {
        let e = a(gt),
          r = l([]),
          o = K(t => (r.current.push(t), e && e.register(t), () => i(t))),
          i = K(t => {
            let n = r.current.indexOf(t);
            -1 !== n && r.current.splice(n, 1), e && e.unregister(t);
          }),
          s = n(() => ({
            register: o,
            unregister: i,
            portals: r
          }), [o, i, r]);
        return [r, n(() => function (_ref22) {
          let {
            children: e
          } = _ref22;
          return t.createElement(gt.Provider, {
            value: s
          }, e);
        }, [s])];
      }(),
      _ = {
        get current() {
          var e;
          return null != (e = F.panelRef.current) ? e : E.current;
        }
      },
      {
        resolveContainers: $,
        mainTreeNodeRef: z,
        MainTreeNode: B
      } = function () {
        let {
          defaultContainers: e = [],
          portals: r,
          mainTreeNodeRef: a
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var o;
        let i = l(null != (o = null == a ? void 0 : a.current) ? o : null),
          s = ke(i),
          c = K(() => {
            var t, n, a;
            let o = [];
            for (let t of e) null !== t && (t instanceof HTMLElement ? o.push(t) : "current" in t && t.current instanceof HTMLElement && o.push(t.current));
            if (null != r && r.current) for (let e of r.current) o.push(e);
            for (let e of null != (t = null == s ? void 0 : s.querySelectorAll("html > *, body > *")) ? t : []) e !== document.body && e !== document.head && e instanceof HTMLElement && "headlessui-portal-root" !== e.id && (e.contains(i.current) || e.contains(null == (a = null == (n = i.current) ? void 0 : n.getRootNode()) ? void 0 : a.host) || o.some(t => e.contains(t)) || o.push(e));
            return o;
          });
        return {
          resolveContainers: c,
          contains: K(e => c().some(t => t.contains(e))),
          mainTreeNodeRef: i,
          MainTreeNode: n(() => function () {
            return null != a ? null : t.createElement(Be, {
              features: ze.Hidden,
              ref: i
            });
          }, [i, a])
        };
      }({
        portals: L,
        defaultContainers: [_]
      }),
      H = I ? "parent" : "leaf",
      U = null !== k && (k & Ue.Closing) === Ue.Closing,
      W = !D && !U && R,
      q = v(() => {
        var e, t;
        return null != (t = Array.from(null != (e = null == O ? void 0 : O.querySelectorAll("body > *")) ? e : []).find(e => "headlessui-portal-root" !== e.id && e.contains(z.current) && e instanceof HTMLElement)) ? t : null;
      }, [z]);
    Rt(q, W);
    let V = !!I || R,
      Y = v(() => {
        var e, t;
        return null != (t = Array.from(null != (e = null == O ? void 0 : O.querySelectorAll("[data-headlessui-portal]")) ? e : []).find(e => e.contains(z.current) && e instanceof HTMLElement)) ? t : null;
      }, [z]);
    Rt(Y, V), xe($, e => {
      e.preventDefault(), j();
    }, !(!R || I));
    let G = !(I || 0 !== P);
    et(null == O ? void 0 : O.defaultView, "keydown", e => {
      G && (e.defaultPrevented || e.key === Ze.Escape && (e.preventDefault(), e.stopPropagation(), j()));
    }), function (e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => [document.body];
      Tt(e, t, e => {
        var t;
        return {
          containers: [...(null != (t = e.containers) ? t : []), n]
        };
      });
    }(O, !(U || 0 !== P || D), $), o(() => {
      if (0 !== P || !E.current) return;
      let e = new ResizeObserver(e => {
        for (let t of e) {
          let e = t.target.getBoundingClientRect();
          0 === e.x && 0 === e.y && 0 === e.width && 0 === e.height && j();
        }
      });
      return e.observe(E.current), () => e.disconnect();
    }, [P, E, j]);
    let [X, J] = $t(),
      Q = n(() => [{
        dialogState: P,
        close: j,
        setTitleId: C
      }, F], [P, F, j, C]),
      ee = n(() => ({
        open: 0 === P
      }), [P]),
      re = {
        ref: S,
        id: c,
        role: p,
        "aria-modal": 0 === P || void 0,
        "aria-labelledby": F.titleId,
        "aria-describedby": X
      };
    return t.createElement(Lt, {
      type: "Dialog",
      enabled: 0 === P,
      element: E,
      onUpdate: K((e, t) => {
        "Dialog" === t && ne(e, {
          [Dt.Add]: () => w(e => e + 1),
          [Dt.Remove]: () => w(e => e - 1)
        });
      })
    }, t.createElement(ut, {
      force: !0
    }, t.createElement(bt, null, t.createElement(qt.Provider, {
      value: Q
    }, t.createElement(bt.Group, {
      target: E
    }, t.createElement(ut, {
      force: !1
    }, t.createElement(J, {
      slot: ee,
      name: "Dialog.Description"
    }, t.createElement(lt, {
      initialFocus: f,
      containers: $,
      features: R ? ne(H, {
        parent: lt.features.RestoreFocus,
        leaf: lt.features.All & ~lt.features.FocusLock
      }) : lt.features.None
    }, t.createElement(M, null, Re({
      ourProps: re,
      theirProps: b,
      slot: ee,
      defaultTag: "div",
      features: Gt,
      visible: 0 === P,
      name: "Dialog"
    }))))))))), t.createElement(B, null));
  }),
  Xt = Me(function (e, r) {
    let a = te(),
      {
        id: i = "headlessui-dialog-backdrop-".concat(a),
        ...l
      } = e,
      [{
        dialogState: s
      }, c] = Vt("Dialog.Backdrop"),
      u = Ne(r);
    o(() => {
      if (null === c.panelRef.current) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [c.panelRef]);
    let d = n(() => ({
      open: 0 === s
    }), [s]);
    return t.createElement(ut, {
      force: !0
    }, t.createElement(bt, null, Re({
      ourProps: {
        ref: u,
        id: i,
        "aria-hidden": !0
      },
      theirProps: l,
      slot: d,
      defaultTag: "div",
      name: "Dialog.Backdrop"
    })));
  }),
  Jt = Me(function (e, t) {
    let r = te(),
      {
        id: a = "headlessui-dialog-panel-".concat(r),
        ...o
      } = e,
      [{
        dialogState: i
      }, l] = Vt("Dialog.Panel"),
      s = Ne(t, l.panelRef),
      c = n(() => ({
        open: 0 === i
      }), [i]),
      u = K(e => {
        e.stopPropagation();
      });
    return Re({
      ourProps: {
        ref: s,
        id: a,
        onClick: u
      },
      theirProps: o,
      slot: c,
      defaultTag: "div",
      name: "Dialog.Panel"
    });
  }),
  Qt = Me(function (e, t) {
    let r = te(),
      {
        id: a = "headlessui-dialog-overlay-".concat(r),
        ...o
      } = e,
      [{
        dialogState: i,
        close: l
      }] = Vt("Dialog.Overlay"),
      s = Ne(t),
      c = K(e => {
        if (e.target === e.currentTarget) {
          if (Ye(e.currentTarget)) return e.preventDefault();
          e.preventDefault(), e.stopPropagation(), l();
        }
      });
    return Re({
      ourProps: {
        ref: s,
        id: a,
        "aria-hidden": !0,
        onClick: c
      },
      theirProps: o,
      slot: n(() => ({
        open: 0 === i
      }), [i]),
      defaultTag: "div",
      name: "Dialog.Overlay"
    });
  }),
  Zt = Me(function (e, t) {
    let r = te(),
      {
        id: a = "headlessui-dialog-title-".concat(r),
        ...i
      } = e,
      [{
        dialogState: l,
        setTitleId: s
      }] = Vt("Dialog.Title"),
      c = Ne(t);
    o(() => (s(a), () => s(null)), [a, s]);
    let u = n(() => ({
      open: 0 === l
    }), [l]);
    return Re({
      ourProps: {
        ref: c,
        id: a
      },
      theirProps: i,
      slot: u,
      defaultTag: "h2",
      name: "Dialog.Title"
    });
  }),
  en = Object.assign(Kt, {
    Backdrop: Xt,
    Panel: Jt,
    Overlay: Qt,
    Title: Zt,
    Description: Bt
  }),
  tn = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function nn(e) {
  var t, n;
  let r = null != (t = e.innerText) ? t : "",
    a = e.cloneNode(!0);
  if (!(a instanceof HTMLElement)) return r;
  let o = !1;
  for (let e of a.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) e.remove(), o = !0;
  let i = o ? null != (n = a.innerText) ? n : "" : r;
  return tn.test(i) && (i = i.replace(tn, "")), i;
}
function rn(e) {
  let t = l(""),
    n = l("");
  return K(() => {
    let r = e.current;
    if (!r) return "";
    let a = r.innerText;
    if (t.current === a) return n.current;
    let o = function (e) {
      let t = e.getAttribute("aria-label");
      if ("string" == typeof t) return t.trim();
      let n = e.getAttribute("aria-labelledby");
      if (n) {
        let e = n.split(" ").map(e => {
          let t = document.getElementById(e);
          if (t) {
            let e = t.getAttribute("aria-label");
            return "string" == typeof e ? e.trim() : nn(t).trim();
          }
          return null;
        }).filter(Boolean);
        if (e.length > 0) return e.join(", ");
      }
      return nn(e).trim();
    }(r).trim().toLowerCase();
    return t.current = a, n.current = o, o;
  });
}
var an = (e => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(an || {}),
  on = (e => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(on || {}),
  ln = (e => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))(ln || {});
function sn(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e => e;
  let n = null !== e.activeItemIndex ? e.items[e.activeItemIndex] : null,
    r = ge(t(e.items.slice()), e => e.dataRef.current.domRef.current),
    a = n ? r.indexOf(n) : null;
  return -1 === a && (a = null), {
    items: r,
    activeItemIndex: a
  };
}
let cn = {
    1: e => 1 === e.menuState ? e : {
      ...e,
      activeItemIndex: null,
      menuState: 1
    },
    0: e => 0 === e.menuState ? e : {
      ...e,
      __demoMode: !1,
      menuState: 0
    },
    2: (e, t) => {
      var n;
      let r = sn(e),
        a = Ke(t, {
          resolveItems: () => r.items,
          resolveActiveIndex: () => r.activeItemIndex,
          resolveId: e => e.id,
          resolveDisabled: e => e.dataRef.current.disabled
        });
      return {
        ...e,
        ...r,
        searchQuery: "",
        activeItemIndex: a,
        activationTrigger: null != (n = t.trigger) ? n : 1
      };
    },
    3: (e, t) => {
      let n = "" !== e.searchQuery ? 0 : 1,
        r = e.searchQuery + t.value.toLowerCase(),
        a = (null !== e.activeItemIndex ? e.items.slice(e.activeItemIndex + n).concat(e.items.slice(0, e.activeItemIndex + n)) : e.items).find(e => {
          var t;
          return (null == (t = e.dataRef.current.textValue) ? void 0 : t.startsWith(r)) && !e.dataRef.current.disabled;
        }),
        o = a ? e.items.indexOf(a) : -1;
      return -1 === o || o === e.activeItemIndex ? {
        ...e,
        searchQuery: r
      } : {
        ...e,
        searchQuery: r,
        activeItemIndex: o,
        activationTrigger: 1
      };
    },
    4: e => "" === e.searchQuery ? e : {
      ...e,
      searchQuery: "",
      searchActiveItemIndex: null
    },
    5: (e, t) => {
      let n = sn(e, e => [...e, {
        id: t.id,
        dataRef: t.dataRef
      }]);
      return {
        ...e,
        ...n
      };
    },
    6: (e, t) => {
      let n = sn(e, e => {
        let n = e.findIndex(e => e.id === t.id);
        return -1 !== n && e.splice(n, 1), e;
      });
      return {
        ...e,
        ...n,
        activationTrigger: 1
      };
    }
  },
  un = r(null);
function dn(e) {
  let t = a(un);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <Menu /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, dn), t;
  }
  return t;
}
function fn(e, t) {
  return ne(t.type, cn, e, t);
}
un.displayName = "MenuContext";
let pn = u;
let mn = je.RenderStrategy | je.Static;
let gn = u;
let vn = Me(function (e, r) {
    let {
        __demoMode: a = !1,
        ...o
      } = e,
      i = m(fn, {
        __demoMode: a,
        menuState: a ? 0 : 1,
        buttonRef: g(),
        itemsRef: g(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
      }),
      [{
        menuState: l,
        itemsRef: s,
        buttonRef: c
      }, u] = i,
      d = Ne(r);
    xe([c, s], (e, t) => {
      var n;
      u({
        type: 1
      }), ue(t, ce.Loose) || (e.preventDefault(), null == (n = c.current) || n.focus());
    }, 0 === l);
    let f = K(() => {
        u({
          type: 1
        });
      }),
      p = n(() => ({
        open: 0 === l,
        close: f
      }), [l, f]),
      v = {
        ref: d
      };
    return t.createElement(un.Provider, {
      value: i
    }, t.createElement(qe, {
      value: ne(l, {
        0: Ue.Open,
        1: Ue.Closed
      })
    }, Re({
      ourProps: v,
      theirProps: o,
      slot: p,
      defaultTag: pn,
      name: "Menu"
    })));
  }),
  hn = Me(function (e, t) {
    var r;
    let a = te(),
      {
        id: o = "headlessui-menu-button-".concat(a),
        ...i
      } = e,
      [l, s] = dn("Menu.Button"),
      c = Ne(l.buttonRef, t),
      u = Q(),
      d = K(e => {
        switch (e.key) {
          case Ze.Space:
          case Ze.Enter:
          case Ze.ArrowDown:
            e.preventDefault(), e.stopPropagation(), s({
              type: 0
            }), u.nextFrame(() => s({
              type: 2,
              focus: Ge.First
            }));
            break;
          case Ze.ArrowUp:
            e.preventDefault(), e.stopPropagation(), s({
              type: 0
            }), u.nextFrame(() => s({
              type: 2,
              focus: Ge.Last
            }));
        }
      }),
      f = K(e => {
        if (e.key === Ze.Space) e.preventDefault();
      }),
      p = K(t => {
        if (Ye(t.currentTarget)) return t.preventDefault();
        e.disabled || (0 === l.menuState ? (s({
          type: 1
        }), u.nextFrame(() => {
          var e;
          return null == (e = l.buttonRef.current) ? void 0 : e.focus({
            preventScroll: !0
          });
        })) : (t.preventDefault(), s({
          type: 0
        })));
      }),
      m = n(() => ({
        open: 0 === l.menuState
      }), [l]);
    return Re({
      ourProps: {
        ref: c,
        id: o,
        type: Se(e, l.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": null == (r = l.itemsRef.current) ? void 0 : r.id,
        "aria-expanded": 0 === l.menuState,
        onKeyDown: d,
        onKeyUp: f,
        onClick: p
      },
      theirProps: i,
      slot: m,
      defaultTag: "button",
      name: "Menu.Button"
    });
  }),
  bn = Me(function (e, t) {
    var r, a;
    let i = te(),
      {
        id: l = "headlessui-menu-items-".concat(i),
        ...s
      } = e,
      [c, u] = dn("Menu.Items"),
      d = Ne(c.itemsRef, t),
      f = ke(c.itemsRef),
      p = Q(),
      m = We(),
      g = null !== m ? (m & Ue.Open) === Ue.Open : 0 === c.menuState;
    o(() => {
      let e = c.itemsRef.current;
      e && 0 === c.menuState && e !== (null == f ? void 0 : f.activeElement) && e.focus({
        preventScroll: !0
      });
    }, [c.menuState, c.itemsRef, f]), Pe({
      container: c.itemsRef.current,
      enabled: 0 === c.menuState,
      accept: e => "menuitem" === e.getAttribute("role") ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
      walk(e) {
        e.setAttribute("role", "none");
      }
    });
    let v = K(e => {
        var t, n;
        switch (p.dispose(), e.key) {
          case Ze.Space:
            if ("" !== c.searchQuery) return e.preventDefault(), e.stopPropagation(), u({
              type: 3,
              value: e.key
            });
          case Ze.Enter:
            if (e.preventDefault(), e.stopPropagation(), u({
              type: 1
            }), null !== c.activeItemIndex) {
              let {
                dataRef: e
              } = c.items[c.activeItemIndex];
              null == (n = null == (t = e.current) ? void 0 : t.domRef.current) || n.click();
            }
            de(c.buttonRef.current);
            break;
          case Ze.ArrowDown:
            return e.preventDefault(), e.stopPropagation(), u({
              type: 2,
              focus: Ge.Next
            });
          case Ze.ArrowUp:
            return e.preventDefault(), e.stopPropagation(), u({
              type: 2,
              focus: Ge.Previous
            });
          case Ze.Home:
          case Ze.PageUp:
            return e.preventDefault(), e.stopPropagation(), u({
              type: 2,
              focus: Ge.First
            });
          case Ze.End:
          case Ze.PageDown:
            return e.preventDefault(), e.stopPropagation(), u({
              type: 2,
              focus: Ge.Last
            });
          case Ze.Escape:
            e.preventDefault(), e.stopPropagation(), u({
              type: 1
            }), J().nextFrame(() => {
              var e;
              return null == (e = c.buttonRef.current) ? void 0 : e.focus({
                preventScroll: !0
              });
            });
            break;
          case Ze.Tab:
            e.preventDefault(), e.stopPropagation(), u({
              type: 1
            }), J().nextFrame(() => {
              !function (e, t) {
                ve(se(), t, {
                  relativeTo: e
                });
              }(c.buttonRef.current, e.shiftKey ? oe.Previous : oe.Next);
            });
            break;
          default:
            1 === e.key.length && (u({
              type: 3,
              value: e.key
            }), p.setTimeout(() => u({
              type: 4
            }), 350));
        }
      }),
      h = K(e => {
        if (e.key === Ze.Space) e.preventDefault();
      }),
      b = n(() => ({
        open: 0 === c.menuState
      }), [c]);
    return Re({
      ourProps: {
        "aria-activedescendant": null === c.activeItemIndex || null == (r = c.items[c.activeItemIndex]) ? void 0 : r.id,
        "aria-labelledby": null == (a = c.buttonRef.current) ? void 0 : a.id,
        id: l,
        onKeyDown: v,
        onKeyUp: h,
        role: "menu",
        tabIndex: 0,
        ref: d
      },
      theirProps: s,
      slot: b,
      defaultTag: "div",
      features: mn,
      visible: g,
      name: "Menu.Items"
    });
  }),
  yn = Me(function (e, t) {
    let r = te(),
      {
        id: a = "headlessui-menu-item-".concat(r),
        disabled: o = !1,
        ...i
      } = e,
      [s, c] = dn("Menu.Item"),
      u = null !== s.activeItemIndex && s.items[s.activeItemIndex].id === a,
      d = l(null),
      f = Ne(t, d);
    Y(() => {
      if (s.__demoMode || 0 !== s.menuState || !u || 0 === s.activationTrigger) return;
      let e = J();
      return e.requestAnimationFrame(() => {
        var e, t;
        null == (t = null == (e = d.current) ? void 0 : e.scrollIntoView) || t.call(e, {
          block: "nearest"
        });
      }), e.dispose;
    }, [s.__demoMode, d, u, s.menuState, s.activationTrigger, s.activeItemIndex]);
    let p = rn(d),
      m = l({
        disabled: o,
        domRef: d,
        get textValue() {
          return p();
        }
      });
    Y(() => {
      m.current.disabled = o;
    }, [m, o]), Y(() => (c({
      type: 5,
      id: a,
      dataRef: m
    }), () => c({
      type: 6,
      id: a
    })), [m, a]);
    let g = K(() => {
        c({
          type: 1
        });
      }),
      v = K(e => {
        if (o) return e.preventDefault();
        c({
          type: 1
        }), de(s.buttonRef.current);
      }),
      h = K(() => {
        if (o) return c({
          type: 2,
          focus: Ge.Nothing
        });
        c({
          type: 2,
          focus: Ge.Specific,
          id: a
        });
      }),
      b = function () {
        let e = l([-1, -1]);
        return {
          wasMoved(t) {
            let n = Ae(t);
            return (e.current[0] !== n[0] || e.current[1] !== n[1]) && (e.current = n, !0);
          },
          update(t) {
            e.current = Ae(t);
          }
        };
      }(),
      y = K(e => b.update(e)),
      w = K(e => {
        b.wasMoved(e) && (o || u || c({
          type: 2,
          focus: Ge.Specific,
          id: a,
          trigger: 0
        }));
      }),
      x = K(e => {
        b.wasMoved(e) && (o || u && c({
          type: 2,
          focus: Ge.Nothing
        }));
      }),
      k = n(() => ({
        active: u,
        disabled: o,
        close: g
      }), [u, o, g]);
    return Re({
      ourProps: {
        id: a,
        ref: f,
        role: "menuitem",
        tabIndex: !0 === o ? void 0 : -1,
        "aria-disabled": !0 === o || void 0,
        disabled: void 0,
        onClick: v,
        onFocus: h,
        onPointerEnter: y,
        onMouseEnter: y,
        onPointerMove: w,
        onMouseMove: w,
        onPointerLeave: x,
        onMouseLeave: x
      },
      theirProps: i,
      slot: k,
      defaultTag: gn,
      name: "Menu.Item"
    });
  }),
  wn = Object.assign(vn, {
    Button: hn,
    Items: bn,
    Item: yn
  }),
  xn = r(null);
function kn() {
  let e = a(xn);
  if (null === e) {
    let e = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, kn), e;
  }
  return e;
}
function En() {
  let [e, r] = s([]);
  return [e.length > 0 ? e.join(" ") : void 0, n(() => function (e) {
    let a = K(e => (r(t => [...t, e]), () => r(t => {
        let n = t.slice(),
          r = n.indexOf(e);
        return -1 !== r && n.splice(r, 1), n;
      }))),
      o = n(() => ({
        register: a,
        slot: e.slot,
        name: e.name,
        props: e.props
      }), [a, e.slot, e.name, e.props]);
    return t.createElement(xn.Provider, {
      value: o
    }, e.children);
  }, [r])];
}
let Sn = Me(function (e, t) {
    let n = te(),
      {
        id: r = "headlessui-label-".concat(n),
        passive: a = !1,
        ...o
      } = e,
      i = kn(),
      l = Ne(t);
    Y(() => i.register(r), [r, i.register]);
    let s = {
      ref: l,
      ...i.props,
      id: r
    };
    return a && ("onClick" in s && (delete s.htmlFor, delete s.onClick), "onClick" in o && delete o.onClick), Re({
      ourProps: s,
      theirProps: o,
      slot: i.slot || {},
      defaultTag: "label",
      name: i.name || "Label"
    });
  }),
  On = Object.assign(Sn, {});
function Nn() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let [t, n] = s(e),
    r = tt(),
    a = v(e => {
      r.current && n(t => t | e);
    }, [t, r]),
    o = v(e => Boolean(t & e), [t]),
    i = v(e => {
      r.current && n(t => t & ~e);
    }, [n, r]),
    l = v(e => {
      r.current && n(t => t ^ e);
    }, [n]);
  return {
    flags: t,
    addFlag: a,
    hasFlag: o,
    removeFlag: i,
    toggleFlag: l
  };
}
var An = (e => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(An || {});
let Pn = {
    0(e, t) {
      let n = [...e.options, {
        id: t.id,
        element: t.element,
        propsRef: t.propsRef
      }];
      return {
        ...e,
        options: ge(n, e => e.element.current)
      };
    },
    1(e, t) {
      let n = e.options.slice(),
        r = e.options.findIndex(e => e.id === t.id);
      return -1 === r ? e : (n.splice(r, 1), {
        ...e,
        options: n
      });
    }
  },
  Fn = r(null);
function Tn(e) {
  let t = a(Fn);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Tn), t;
  }
  return t;
}
Fn.displayName = "RadioGroupDataContext";
let jn = r(null);
function Cn(e) {
  let t = a(jn);
  if (null === t) {
    let t = new Error("<".concat(e, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Cn), t;
  }
  return t;
}
function Rn(e, t) {
  return ne(t.type, Pn, e, t);
}
jn.displayName = "RadioGroupActionsContext";
var In = (e => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(In || {});
let Dn = Me(function (e, r) {
    let a = te(),
      {
        id: i = "headlessui-radiogroup-".concat(a),
        value: c,
        defaultValue: u,
        form: d,
        name: f,
        onChange: p,
        by: g = (e, t) => e === t,
        disabled: v = !1,
        ...h
      } = e,
      b = K("string" == typeof g ? (e, t) => {
        let n = g;
        return (null == e ? void 0 : e[n]) === (null == t ? void 0 : t[n]);
      } : g),
      [y, w] = m(Rn, {
        options: []
      }),
      x = y.options,
      [k, E] = En(),
      [S, O] = $t(),
      N = l(null),
      A = Ne(N, r),
      [P, F] = function (e, t, n) {
        let [r, a] = s(n),
          o = void 0 !== e,
          i = l(o),
          c = l(!1),
          u = l(!1);
        return !o || i.current || c.current ? !o && i.current && !u.current && (u.current = !0, i.current = o, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")) : (c.current = !0, i.current = o, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")), [o ? e : r, K(e => (o || a(e), null == t ? void 0 : t(e)))];
      }(c, p, u),
      T = n(() => x.find(e => !e.propsRef.current.disabled), [x]),
      j = n(() => x.some(e => b(e.propsRef.current.value, P)), [x, P]),
      C = K(e => {
        var t;
        if (v || b(e, P)) return !1;
        let n = null == (t = x.find(t => b(t.propsRef.current.value, e))) ? void 0 : t.propsRef.current;
        return (null == n || !n.disabled) && (null == F || F(e), !0);
      });
    Pe({
      container: N.current,
      accept: e => "radio" === e.getAttribute("role") ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
      walk(e) {
        e.setAttribute("role", "none");
      }
    });
    let R = K(e => {
        let t = N.current;
        if (!t) return;
        let n = re(t),
          r = x.filter(e => !1 === e.propsRef.current.disabled).map(e => e.element.current);
        switch (e.key) {
          case Ze.Enter:
            !function (e) {
              var t, n;
              let r = null != (t = null == e ? void 0 : e.form) ? t : e.closest("form");
              if (r) {
                for (let t of r.elements) if (t !== e && ("INPUT" === t.tagName && "submit" === t.type || "BUTTON" === t.tagName && "submit" === t.type || "INPUT" === t.nodeName && "image" === t.type)) return void t.click();
                null == (n = r.requestSubmit) || n.call(r);
              }
            }(e.currentTarget);
            break;
          case Ze.ArrowLeft:
          case Ze.ArrowUp:
            if (e.preventDefault(), e.stopPropagation(), ve(r, oe.Previous | oe.WrapAround) === ie.Success) {
              let e = x.find(e => e.element.current === (null == n ? void 0 : n.activeElement));
              e && C(e.propsRef.current.value);
            }
            break;
          case Ze.ArrowRight:
          case Ze.ArrowDown:
            if (e.preventDefault(), e.stopPropagation(), ve(r, oe.Next | oe.WrapAround) === ie.Success) {
              let e = x.find(e => e.element.current === (null == n ? void 0 : n.activeElement));
              e && C(e.propsRef.current.value);
            }
            break;
          case Ze.Space:
            {
              e.preventDefault(), e.stopPropagation();
              let t = x.find(e => e.element.current === (null == n ? void 0 : n.activeElement));
              t && C(t.propsRef.current.value);
            }
        }
      }),
      I = K(e => (w({
        type: 0,
        ...e
      }), () => w({
        type: 1,
        id: e.id
      }))),
      D = n(() => ({
        value: P,
        firstOption: T,
        containsCheckedOption: j,
        disabled: v,
        compare: b,
        ...y
      }), [P, T, j, v, b, y]),
      L = n(() => ({
        registerOption: I,
        change: C
      }), [I, C]),
      M = {
        ref: A,
        id: i,
        role: "radiogroup",
        "aria-labelledby": k,
        "aria-describedby": S,
        onKeyDown: R
      },
      _ = n(() => ({
        value: P
      }), [P]),
      $ = l(null),
      z = Q();
    return o(() => {
      $.current && void 0 !== u && z.addEventListener($.current, "reset", () => {
        C(u);
      });
    }, [$, C]), t.createElement(O, {
      name: "RadioGroup.Description"
    }, t.createElement(E, {
      name: "RadioGroup.Label"
    }, t.createElement(jn.Provider, {
      value: L
    }, t.createElement(Fn.Provider, {
      value: D
    }, null != f && null != P && Xe({
      [f]: P
    }).map((_ref23, r) => {
      let [e, n] = _ref23;
      return t.createElement(Be, {
        features: ze.Hidden,
        ref: 0 === r ? e => {
          var t;
          $.current = null != (t = null == e ? void 0 : e.closest("form")) ? t : null;
        } : void 0,
        ..._e({
          key: e,
          as: "input",
          type: "radio",
          checked: null != n,
          hidden: !0,
          readOnly: !0,
          form: d,
          disabled: v,
          name: e,
          value: n
        })
      });
    }), Re({
      ourProps: M,
      theirProps: h,
      slot: _,
      defaultTag: "div",
      name: "RadioGroup"
    })))));
  }),
  Ln = Me(function (e, r) {
    var a;
    let o = te(),
      {
        id: i = "headlessui-radiogroup-option-".concat(o),
        value: s,
        disabled: c = !1,
        ...u
      } = e,
      d = l(null),
      f = Ne(d, r),
      [p, m] = En(),
      [g, v] = $t(),
      {
        addFlag: h,
        removeFlag: b,
        hasFlag: y
      } = Nn(1),
      w = G({
        value: s,
        disabled: c
      }),
      x = Tn("RadioGroup.Option"),
      k = Cn("RadioGroup.Option");
    Y(() => k.registerOption({
      id: i,
      element: d,
      propsRef: w
    }), [i, k, d, w]);
    let E = K(e => {
        var t;
        if (Ye(e.currentTarget)) return e.preventDefault();
        k.change(s) && (h(2), null == (t = d.current) || t.focus());
      }),
      S = K(e => {
        if (Ye(e.currentTarget)) return e.preventDefault();
        h(2);
      }),
      O = K(() => b(2)),
      N = (null == (a = x.firstOption) ? void 0 : a.id) === i,
      A = x.disabled || c,
      P = x.compare(x.value, s),
      F = {
        ref: f,
        id: i,
        role: "radio",
        "aria-checked": P ? "true" : "false",
        "aria-labelledby": p,
        "aria-describedby": g,
        "aria-disabled": !!A || void 0,
        tabIndex: A ? -1 : P || !x.containsCheckedOption && N ? 0 : -1,
        onClick: A ? void 0 : E,
        onFocus: A ? void 0 : S,
        onBlur: A ? void 0 : O
      },
      T = n(() => ({
        checked: P,
        disabled: A,
        active: y(2)
      }), [P, A, y]);
    return t.createElement(v, {
      name: "RadioGroup.Description"
    }, t.createElement(m, {
      name: "RadioGroup.Label"
    }, Re({
      ourProps: F,
      theirProps: u,
      slot: T,
      defaultTag: "div",
      name: "RadioGroup.Option"
    })));
  }),
  Mn = Object.assign(Dn, {
    Option: Ln,
    Label: On,
    Description: Bt
  });
function _n(e) {
  for (var _len11 = arguments.length, t = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
    t[_key11 - 1] = arguments[_key11];
  }
  e && t.length > 0 && e.classList.add(...t);
}
function $n(e) {
  for (var _len12 = arguments.length, t = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
    t[_key12 - 1] = arguments[_key12];
  }
  e && t.length > 0 && e.classList.remove(...t);
}
function zn(e, t, n, r) {
  let a = n ? "enter" : "leave",
    o = J(),
    i = void 0 !== r ? function (e) {
      let t = {
        called: !1
      };
      return function () {
        if (!t.called) return t.called = !0, e(...arguments);
      };
    }(r) : () => {};
  "enter" === a && (e.removeAttribute("hidden"), e.style.display = "");
  let l = ne(a, {
      enter: () => t.enter,
      leave: () => t.leave
    }),
    s = ne(a, {
      enter: () => t.enterTo,
      leave: () => t.leaveTo
    }),
    c = ne(a, {
      enter: () => t.enterFrom,
      leave: () => t.leaveFrom
    });
  return $n(e, ...t.base, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), _n(e, ...t.base, ...l, ...c), o.nextFrame(() => {
    $n(e, ...t.base, ...l, ...c), _n(e, ...t.base, ...l, ...s), function (e, t) {
      let n = J();
      if (!e) return n.dispose;
      let {
          transitionDuration: r,
          transitionDelay: a
        } = getComputedStyle(e),
        [o, i] = [r, a].map(e => {
          let [t = 0] = e.split(",").filter(Boolean).map(e => e.includes("ms") ? parseFloat(e) : 1e3 * parseFloat(e)).sort((e, t) => t - e);
          return t;
        }),
        l = o + i;
      if (0 !== l) {
        n.group(n => {
          n.setTimeout(() => {
            t(), n.dispose();
          }, l), n.addEventListener(e, "transitionrun", e => {
            e.target === e.currentTarget && n.dispose();
          });
        });
        let r = n.addEventListener(e, "transitionend", e => {
          e.target === e.currentTarget && (t(), r());
        });
      } else t();
      n.add(() => t()), n.dispose;
    }(e, () => ($n(e, ...t.base, ...l), _n(e, ...t.base, ...t.entered), i()));
  }), o.dispose;
}
function Bn() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return e.split(/\s+/).filter(e => e.length > 1);
}
let Hn = r(null);
Hn.displayName = "TransitionContext";
var Un = (e => (e.Visible = "visible", e.Hidden = "hidden", e))(Un || {});
let Wn = r(null);
function qn(e) {
  return "children" in e ? qn(e.children) : e.current.filter(_ref24 => {
    let {
      el: e
    } = _ref24;
    return null !== e.current;
  }).filter(_ref25 => {
    let {
      state: e
    } = _ref25;
    return "visible" === e;
  }).length > 0;
}
function Vn(e, t) {
  let r = G(e),
    a = l([]),
    o = tt(),
    i = Q(),
    s = K(function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ce.Hidden;
      let n = a.current.findIndex(_ref26 => {
        let {
          el: t
        } = _ref26;
        return t === e;
      });
      -1 !== n && (ne(t, {
        [Ce.Unmount]() {
          a.current.splice(n, 1);
        },
        [Ce.Hidden]() {
          a.current[n].state = "hidden";
        }
      }), i.microTask(() => {
        var e;
        !qn(a) && o.current && (null == (e = r.current) || e.call(r));
      }));
    }),
    c = K(e => {
      let t = a.current.find(_ref27 => {
        let {
          el: t
        } = _ref27;
        return t === e;
      });
      return t ? "visible" !== t.state && (t.state = "visible") : a.current.push({
        el: e,
        state: "visible"
      }), () => s(e, Ce.Unmount);
    }),
    u = l([]),
    d = l(Promise.resolve()),
    f = l({
      enter: [],
      leave: [],
      idle: []
    }),
    p = K((e, n, r) => {
      u.current.splice(0), t && (t.chains.current[n] = t.chains.current[n].filter(_ref28 => {
        let [t] = _ref28;
        return t !== e;
      })), null == t || t.chains.current[n].push([e, new Promise(e => {
        u.current.push(e);
      })]), null == t || t.chains.current[n].push([e, new Promise(e => {
        Promise.all(f.current[n].map(_ref29 => {
          let [e, t] = _ref29;
          return t;
        })).then(() => e());
      })]), "enter" === n ? d.current = d.current.then(() => null == t ? void 0 : t.wait.current).then(() => r(n)) : r(n);
    }),
    m = K((e, t, n) => {
      Promise.all(f.current[t].splice(0).map(_ref30 => {
        let [e, t] = _ref30;
        return t;
      })).then(() => {
        var e;
        null == (e = u.current.shift()) || e();
      }).then(() => n(t));
    });
  return n(() => ({
    children: a,
    register: c,
    unregister: s,
    onStart: p,
    onStop: m,
    wait: d,
    chains: f
  }), [c, s, a, p, m, f, d]);
}
function Yn() {}
Wn.displayName = "NestingContext";
let Gn = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function Kn(e) {
  var t;
  let n = {};
  for (let r of Gn) n[r] = null != (t = e[r]) ? t : Yn;
  return n;
}
let Xn = je.RenderStrategy;
let Jn = Me(function (e, r) {
    let {
        show: a,
        appear: i = !1,
        unmount: c = !0,
        ...d
      } = e,
      f = l(null),
      p = Ne(f, r);
    Z();
    let m = We();
    if (void 0 === a && null !== m && (a = (m & Ue.Open) === Ue.Open), ![!0, !1].includes(a)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [g, v] = s(a ? "visible" : "hidden"),
      h = Vn(() => {
        v("hidden");
      }),
      [b, y] = s(!0),
      w = l([a]);
    Y(() => {
      !1 !== b && w.current[w.current.length - 1] !== a && (w.current.push(a), y(!1));
    }, [w, a]);
    let x = n(() => ({
      show: a,
      appear: i,
      initial: b
    }), [a, i, b]);
    o(() => {
      if (a) v("visible");else if (qn(h)) {
        let e = f.current;
        if (!e) return;
        let t = e.getBoundingClientRect();
        0 === t.x && 0 === t.y && 0 === t.width && 0 === t.height && v("hidden");
      } else v("hidden");
    }, [a, h]);
    let k = {
        unmount: c
      },
      E = K(() => {
        var t;
        b && y(!1), null == (t = e.beforeEnter) || t.call(e);
      }),
      S = K(() => {
        var t;
        b && y(!1), null == (t = e.beforeLeave) || t.call(e);
      });
    return t.createElement(Wn.Provider, {
      value: h
    }, t.createElement(Hn.Provider, {
      value: x
    }, Re({
      ourProps: {
        ...k,
        as: u,
        children: t.createElement(Qn, {
          ref: p,
          ...k,
          ...d,
          beforeEnter: E,
          beforeLeave: S
        })
      },
      theirProps: {},
      defaultTag: u,
      features: Xn,
      visible: "visible" === g,
      name: "Transition"
    })));
  }),
  Qn = Me(function (e, n) {
    var r, i;
    let {
        beforeEnter: c,
        afterEnter: u,
        beforeLeave: d,
        afterLeave: f,
        enter: p,
        enterFrom: m,
        enterTo: g,
        entered: v,
        leave: h,
        leaveFrom: b,
        leaveTo: y,
        ...w
      } = e,
      x = l(null),
      k = Ne(x, n),
      E = null == (r = w.unmount) || r ? Ce.Unmount : Ce.Hidden,
      {
        show: S,
        appear: O,
        initial: N
      } = function () {
        let e = a(Hn);
        if (null === e) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
        return e;
      }(),
      [A, P] = s(S ? "visible" : "hidden"),
      F = function () {
        let e = a(Wn);
        if (null === e) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
        return e;
      }(),
      {
        register: T,
        unregister: j
      } = F;
    o(() => T(x), [T, x]), o(() => {
      if (E === Ce.Hidden && x.current) return S && "visible" !== A ? void P("visible") : ne(A, {
        hidden: () => j(x),
        visible: () => T(x)
      });
    }, [A, x, T, j, S, E]);
    let C = G({
        base: Bn(w.className),
        enter: Bn(p),
        enterFrom: Bn(m),
        enterTo: Bn(g),
        entered: Bn(v),
        leave: Bn(h),
        leaveFrom: Bn(b),
        leaveTo: Bn(y)
      }),
      R = function (e) {
        let t = l(Kn(e));
        return o(() => {
          t.current = Kn(e);
        }, [e]), t;
      }({
        beforeEnter: c,
        afterEnter: u,
        beforeLeave: d,
        afterLeave: f
      }),
      I = Z();
    o(() => {
      if (I && "visible" === A && null === x.current) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [x, A, I]);
    let D = O && S && N,
      L = !I || N && !O ? "idle" : S ? "enter" : "leave",
      M = Nn(0),
      _ = K(e => ne(e, {
        enter: () => {
          M.addFlag(Ue.Opening), R.current.beforeEnter();
        },
        leave: () => {
          M.addFlag(Ue.Closing), R.current.beforeLeave();
        },
        idle: () => {}
      })),
      $ = K(e => ne(e, {
        enter: () => {
          M.removeFlag(Ue.Opening), R.current.afterEnter();
        },
        leave: () => {
          M.removeFlag(Ue.Closing), R.current.afterLeave();
        },
        idle: () => {}
      })),
      z = Vn(() => {
        P("hidden"), j(x);
      }, F),
      B = l(!1);
    !function (_ref31) {
      let {
        immediate: e,
        container: t,
        direction: n,
        classes: r,
        onStart: a,
        onStop: o
      } = _ref31;
      let i = tt(),
        l = Q(),
        s = G(n);
      Y(() => {
        e && (s.current = "enter");
      }, [e]), Y(() => {
        let e = J();
        l.add(e.dispose);
        let n = t.current;
        if (n && "idle" !== s.current && i.current) return e.dispose(), a.current(s.current), e.add(zn(n, r.current, "enter" === s.current, () => {
          e.dispose(), o.current(s.current);
        })), e.dispose;
      }, [n]);
    }({
      immediate: D,
      container: x,
      classes: C,
      direction: L,
      onStart: G(e => {
        B.current = !0, z.onStart(x, e, _);
      }),
      onStop: G(e => {
        B.current = !1, z.onStop(x, e, $), "leave" === e && !qn(z) && (P("hidden"), j(x));
      })
    });
    let H = w,
      U = {
        ref: k
      };
    return D ? H = {
      ...H,
      className: Te(w.className, ...C.current.enter, ...C.current.enterFrom)
    } : B.current && (H.className = Te(w.className, null == (i = x.current) ? void 0 : i.className), "" === H.className && delete H.className), t.createElement(Wn.Provider, {
      value: z
    }, t.createElement(qe, {
      value: ne(A, {
        visible: Ue.Open,
        hidden: Ue.Closed
      }) | M.flags
    }, Re({
      ourProps: U,
      theirProps: H,
      defaultTag: "div",
      features: Xn,
      visible: "visible" === A,
      name: "Transition.Child"
    })));
  }),
  Zn = Me(function (e, n) {
    let r = null !== a(Hn),
      o = null !== We();
    return t.createElement(t.Fragment, null, !r && o ? t.createElement(Jn, {
      ref: n,
      ...e
    }) : t.createElement(Qn, {
      ref: n,
      ...e
    }));
  }),
  er = Object.assign(Jn, {
    Child: Zn,
    Root: Jn
  });
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function tr(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t);
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function nr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? nr(Object(n), !0).forEach(function (t) {
      tr(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nr(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
const ar = () => {};
let or = {},
  ir = {},
  lr = null,
  sr = {
    mark: ar,
    measure: ar
  };
try {
  "undefined" != typeof window && (or = window), "undefined" != typeof document && (ir = document), "undefined" != typeof MutationObserver && (lr = MutationObserver), "undefined" != typeof performance && (sr = performance);
} catch (Ti) {}
const {
    userAgent: cr = ""
  } = or.navigator || {},
  ur = or,
  dr = ir,
  fr = lr,
  pr = sr;
ur.document;
const mr = !!dr.documentElement && !!dr.head && "function" == typeof dr.addEventListener && "function" == typeof dr.createElement,
  gr = ~cr.indexOf("MSIE") || ~cr.indexOf("Trident/");
var vr = {
    classic: {
      fa: "solid",
      fas: "solid",
      "fa-solid": "solid",
      far: "regular",
      "fa-regular": "regular",
      fal: "light",
      "fa-light": "light",
      fat: "thin",
      "fa-thin": "thin",
      fab: "brands",
      "fa-brands": "brands"
    },
    duotone: {
      fa: "solid",
      fad: "solid",
      "fa-solid": "solid",
      "fa-duotone": "solid",
      fadr: "regular",
      "fa-regular": "regular",
      fadl: "light",
      "fa-light": "light",
      fadt: "thin",
      "fa-thin": "thin"
    },
    sharp: {
      fa: "solid",
      fass: "solid",
      "fa-solid": "solid",
      fasr: "regular",
      "fa-regular": "regular",
      fasl: "light",
      "fa-light": "light",
      fast: "thin",
      "fa-thin": "thin"
    },
    "sharp-duotone": {
      fa: "solid",
      fasds: "solid",
      "fa-solid": "solid",
      fasdr: "regular",
      "fa-regular": "regular",
      fasdl: "light",
      "fa-light": "light",
      fasdt: "thin",
      "fa-thin": "thin"
    }
  },
  hr = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"],
  br = "classic",
  yr = "duotone",
  wr = [br, yr, "sharp", "sharp-duotone"],
  xr = new Map([["classic", {
    defaultShortPrefixId: "fas",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin", "brands"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["sharp", {
    defaultShortPrefixId: "fass",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["duotone", {
    defaultShortPrefixId: "fad",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["sharp-duotone", {
    defaultShortPrefixId: "fasds",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }]]),
  kr = ["fak", "fa-kit", "fakd", "fa-kit-duotone"],
  Er = {
    fak: "kit",
    "fa-kit": "kit"
  },
  Sr = {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  },
  Or = ["fak", "fakd"],
  Nr = {
    kit: "fak"
  },
  Ar = {
    "kit-duotone": "fakd"
  },
  Pr = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
  },
  Fr = ["fak", "fa-kit", "fakd", "fa-kit-duotone"],
  Tr = {
    classic: {
      fab: "fa-brands",
      fad: "fa-duotone",
      fal: "fa-light",
      far: "fa-regular",
      fas: "fa-solid",
      fat: "fa-thin"
    },
    duotone: {
      fadr: "fa-regular",
      fadl: "fa-light",
      fadt: "fa-thin"
    },
    sharp: {
      fass: "fa-solid",
      fasr: "fa-regular",
      fasl: "fa-light",
      fast: "fa-thin"
    },
    "sharp-duotone": {
      fasds: "fa-solid",
      fasdr: "fa-regular",
      fasdl: "fa-light",
      fasdt: "fa-thin"
    }
  },
  jr = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", "fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone", "fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"],
  Cr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  Rr = Cr.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
  Ir = [...Object.keys({
    classic: ["fas", "far", "fal", "fat", "fad"],
    duotone: ["fadr", "fadl", "fadt"],
    sharp: ["fass", "fasr", "fasl", "fast"],
    "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
  }), "solid", "regular", "light", "thin", "duotone", "brands", "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Pr.GROUP, Pr.SWAP_OPACITY, Pr.PRIMARY, Pr.SECONDARY].concat(Cr.map(e => "".concat(e, "x"))).concat(Rr.map(e => "w-".concat(e)));
const Dr = "___FONT_AWESOME___",
  Lr = 16,
  Mr = "fa",
  _r = "svg-inline--fa",
  $r = "data-fa-i2svg",
  zr = "data-fa-pseudo-element",
  Br = "data-fa-pseudo-element-pending",
  Hr = "data-prefix",
  Ur = "data-icon",
  Wr = "fontawesome-i2svg",
  qr = "async",
  Vr = ["HTML", "HEAD", "STYLE", "SCRIPT"],
  Yr = (() => {
    try {
      return "production" === process.env.NODE_ENV;
    } catch (e) {
      return !1;
    }
  })();
function Gr(e) {
  return new Proxy(e, {
    get: (e, t) => t in e ? e[t] : e[br]
  });
}
const Kr = rr({}, vr);
Kr[br] = rr(rr(rr(rr({}, {
  "fa-duotone": "duotone"
}), vr[br]), Er), Sr);
const Xr = Gr(Kr),
  Jr = rr({}, {
    classic: {
      solid: "fas",
      regular: "far",
      light: "fal",
      thin: "fat",
      brands: "fab"
    },
    duotone: {
      solid: "fad",
      regular: "fadr",
      light: "fadl",
      thin: "fadt"
    },
    sharp: {
      solid: "fass",
      regular: "fasr",
      light: "fasl",
      thin: "fast"
    },
    "sharp-duotone": {
      solid: "fasds",
      regular: "fasdr",
      light: "fasdl",
      thin: "fasdt"
    }
  });
Jr[br] = rr(rr(rr(rr({}, {
  duotone: "fad"
}), Jr[br]), Nr), Ar);
const Qr = Gr(Jr),
  Zr = rr({}, Tr);
Zr[br] = rr(rr({}, Zr[br]), {
  fak: "fa-kit"
});
const ea = Gr(Zr),
  ta = rr({}, {
    classic: {
      "fa-brands": "fab",
      "fa-duotone": "fad",
      "fa-light": "fal",
      "fa-regular": "far",
      "fa-solid": "fas",
      "fa-thin": "fat"
    },
    duotone: {
      "fa-regular": "fadr",
      "fa-light": "fadl",
      "fa-thin": "fadt"
    },
    sharp: {
      "fa-solid": "fass",
      "fa-regular": "fasr",
      "fa-light": "fasl",
      "fa-thin": "fast"
    },
    "sharp-duotone": {
      "fa-solid": "fasds",
      "fa-regular": "fasdr",
      "fa-light": "fasdl",
      "fa-thin": "fasdt"
    }
  });
ta[br] = rr(rr({}, ta[br]), {
  "fa-kit": "fak"
}), Gr(ta);
const na = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/,
  ra = "fa-layers-text",
  aa = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
Gr(rr({}, {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}));
const oa = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"],
  ia = {
    GROUP: "duotone-group",
    PRIMARY: "primary",
    SECONDARY: "secondary"
  },
  la = ["kit", ...Ir],
  sa = ur.FontAwesomeConfig || {};
if (dr && "function" == typeof dr.querySelector) {
  [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(e => {
    let [t, n] = e;
    const r = function (e) {
      return "" === e || "false" !== e && ("true" === e || e);
    }(function (e) {
      var t = dr.querySelector("script[" + e + "]");
      if (t) return t.getAttribute(e);
    }(t));
    null != r && (sa[n] = r);
  });
}
const ca = {
  styleDefault: "solid",
  familyDefault: br,
  cssPrefix: Mr,
  replacementClass: _r,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
sa.familyPrefix && (sa.cssPrefix = sa.familyPrefix);
const ua = rr(rr({}, ca), sa);
ua.autoReplaceSvg || (ua.observeMutations = !1);
const da = {};
Object.keys(ca).forEach(e => {
  Object.defineProperty(da, e, {
    enumerable: !0,
    set: function (t) {
      ua[e] = t, fa.forEach(e => e(da));
    },
    get: function () {
      return ua[e];
    }
  });
}), Object.defineProperty(da, "familyPrefix", {
  enumerable: !0,
  set: function (e) {
    ua.cssPrefix = e, fa.forEach(e => e(da));
  },
  get: function () {
    return ua.cssPrefix;
  }
}), ur.FontAwesomeConfig = da;
const fa = [];
const pa = Lr,
  ma = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: !1,
    flipY: !1
  };
const ga = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function va() {
  let e = 12,
    t = "";
  for (; e-- > 0;) t += ga[62 * Math.random() | 0];
  return t;
}
function ha(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--;) t[n] = e[n];
  return t;
}
function ba(e) {
  return e.classList ? ha(e.classList) : (e.getAttribute("class") || "").split(" ").filter(e => e);
}
function ya(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function wa(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function xa(e) {
  return e.size !== ma.size || e.x !== ma.x || e.y !== ma.y || e.rotate !== ma.rotate || e.flipX || e.flipY;
}
var ka = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}';
function Ea() {
  const e = Mr,
    t = _r,
    n = da.cssPrefix,
    r = da.replacementClass;
  let a = ka;
  if (n !== e || r !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"),
      i = new RegExp("\\--".concat(e, "\\-"), "g"),
      l = new RegExp("\\.".concat(t), "g");
    a = a.replace(o, ".".concat(n, "-")).replace(i, "--".concat(n, "-")).replace(l, ".".concat(r));
  }
  return a;
}
let Sa = !1;
function Oa() {
  da.autoAddCss && !Sa && (!function (e) {
    if (!e || !mr) return;
    const t = dr.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    const n = dr.head.childNodes;
    let r = null;
    for (let e = n.length - 1; e > -1; e--) {
      const t = n[e],
        a = (t.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(a) > -1 && (r = t);
    }
    dr.head.insertBefore(t, r);
  }(Ea()), Sa = !0);
}
var Na = {
  mixout: () => ({
    dom: {
      css: Ea,
      insertCss: Oa
    }
  }),
  hooks: () => ({
    beforeDOMElementCreation() {
      Oa();
    },
    beforeI2svg() {
      Oa();
    }
  })
};
const Aa = ur || {};
Aa[Dr] || (Aa[Dr] = {}), Aa[Dr].styles || (Aa[Dr].styles = {}), Aa[Dr].hooks || (Aa[Dr].hooks = {}), Aa[Dr].shims || (Aa[Dr].shims = []);
var Pa = Aa[Dr];
const Fa = [],
  Ta = function () {
    dr.removeEventListener("DOMContentLoaded", Ta), ja = 1, Fa.map(e => e());
  };
let ja = !1;
function Ca(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return "string" == typeof e ? ya(e) : "<".concat(t, " ").concat(function (e) {
    return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(ya(e[n]), '" '), "").trim();
  }(n), ">").concat(r.map(Ca).join(""), "</").concat(t, ">");
}
function Ra(e, t, n) {
  if (e && e[t] && e[t][n]) return {
    prefix: t,
    iconName: n,
    icon: e[t][n]
  };
}
mr && (ja = (dr.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(dr.readyState), ja || dr.addEventListener("DOMContentLoaded", Ta));
var Ia = function (e, t, n, r) {
  var a,
    o,
    i,
    l = Object.keys(e),
    s = l.length,
    c = t;
  for (void 0 === n ? (a = 1, i = e[l[0]]) : (a = 0, i = n); a < s; a++) i = c(i, e[o = l[a]], o, e);
  return i;
};
function Da(e) {
  const t = function (e) {
    const t = [];
    let n = 0;
    const r = e.length;
    for (; n < r;) {
      const a = e.charCodeAt(n++);
      if (a >= 55296 && a <= 56319 && n < r) {
        const r = e.charCodeAt(n++);
        56320 == (64512 & r) ? t.push(((1023 & a) << 10) + (1023 & r) + 65536) : (t.push(a), n--);
      } else t.push(a);
    }
    return t;
  }(e);
  return 1 === t.length ? t[0].toString(16) : null;
}
function La(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function Ma(e, t) {
  let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  const {
      skipHooks: r = !1
    } = n,
    a = La(t);
  "function" != typeof Pa.hooks.addPack || r ? Pa.styles[e] = rr(rr({}, Pa.styles[e] || {}), a) : Pa.hooks.addPack(e, La(t)), "fas" === e && Ma("fa", t);
}
const {
    styles: _a,
    shims: $a
  } = Pa,
  za = Object.keys(ea),
  Ba = za.reduce((e, t) => (e[t] = Object.keys(ea[t]), e), {});
let Ha = null,
  Ua = {},
  Wa = {},
  qa = {},
  Va = {},
  Ya = {};
function Ga(e, t) {
  const n = t.split("-"),
    r = n[0],
    a = n.slice(1).join("-");
  return r !== e || "" === a || (o = a, ~la.indexOf(o)) ? null : a;
  var o;
}
const Ka = () => {
  const e = e => Ia(_a, (t, n, r) => (t[r] = Ia(n, e, {}), t), {});
  Ua = e((e, t, n) => {
    if (t[3] && (e[t[3]] = n), t[2]) {
      t[2].filter(e => "number" == typeof e).forEach(t => {
        e[t.toString(16)] = n;
      });
    }
    return e;
  }), Wa = e((e, t, n) => {
    if (e[n] = n, t[2]) {
      t[2].filter(e => "string" == typeof e).forEach(t => {
        e[t] = n;
      });
    }
    return e;
  }), Ya = e((e, t, n) => {
    const r = t[2];
    return e[n] = n, r.forEach(t => {
      e[t] = n;
    }), e;
  });
  const t = "far" in _a || da.autoFetchSvg,
    n = Ia($a, (e, n) => {
      const r = n[0];
      let a = n[1];
      const o = n[2];
      return "far" !== a || t || (a = "fas"), "string" == typeof r && (e.names[r] = {
        prefix: a,
        iconName: o
      }), "number" == typeof r && (e.unicodes[r.toString(16)] = {
        prefix: a,
        iconName: o
      }), e;
    }, {
      names: {},
      unicodes: {}
    });
  qa = n.names, Va = n.unicodes, Ha = no(da.styleDefault, {
    family: da.familyDefault
  });
};
var Xa;
function Ja(e, t) {
  return (Ua[e] || {})[t];
}
function Qa(e, t) {
  return (Ya[e] || {})[t];
}
function Za(e) {
  return qa[e] || {
    prefix: null,
    iconName: null
  };
}
function eo() {
  return Ha;
}
Xa = e => {
  Ha = no(e.styleDefault, {
    family: da.familyDefault
  });
}, fa.push(Xa), Ka();
const to = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function no(e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  const {
      family: n = br
    } = t,
    r = Xr[n][e];
  if (n === yr && !e) return "fad";
  const a = Qr[n][e] || Qr[n][r],
    o = e in Pa.styles ? e : null;
  return a || o || null;
}
function ro(e) {
  return e.sort().filter((e, t, n) => n.indexOf(e) === t);
}
function ao(e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const a = jr.concat(Fr),
    o = ro(e.filter(e => a.includes(e))),
    i = ro(e.filter(e => !jr.includes(e))),
    l = o.filter(e => (r = e, !hr.includes(e))),
    [s = null] = l,
    c = function (e) {
      let t = br;
      const n = za.reduce((e, t) => (e[t] = "".concat(da.cssPrefix, "-").concat(t), e), {});
      return wr.forEach(r => {
        (e.includes(n[r]) || e.some(e => Ba[r].includes(e))) && (t = r);
      }), t;
    }(o),
    u = rr(rr({}, function (e) {
      let t = [],
        n = null;
      return e.forEach(e => {
        const r = Ga(da.cssPrefix, e);
        r ? n = r : e && t.push(e);
      }), {
        iconName: n,
        rest: t
      };
    }(i)), {}, {
      prefix: no(s, {
        family: c
      })
    });
  return rr(rr(rr({}, u), function (e) {
    const {
        values: t,
        family: n,
        canonical: r,
        givenPrefix: a = "",
        styles: o = {},
        config: i = {}
      } = e,
      l = n === yr,
      s = t.includes("fa-duotone") || t.includes("fad"),
      c = "duotone" === i.familyDefault,
      u = "fad" === r.prefix || "fa-duotone" === r.prefix;
    !l && (s || c || u) && (r.prefix = "fad");
    (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab");
    if (!r.prefix && oo.includes(n)) {
      if (Object.keys(o).find(e => io.includes(e)) || i.autoFetchSvg) {
        const e = xr.get(n).defaultShortPrefixId;
        r.prefix = e, r.iconName = Qa(r.prefix, r.iconName) || r.iconName;
      }
    }
    "fa" !== r.prefix && "fa" !== a || (r.prefix = eo() || "fas");
    return r;
  }({
    values: e,
    family: c,
    styles: _a,
    config: da,
    canonical: u,
    givenPrefix: r
  })), function (e, t, n) {
    let {
      prefix: r,
      iconName: a
    } = n;
    if (e || !r || !a) return {
      prefix: r,
      iconName: a
    };
    const o = "fa" === t ? Za(a) : {},
      i = Qa(r, a);
    a = o.iconName || i || a, r = o.prefix || r, "far" !== r || _a.far || !_a.fas || da.autoFetchSvg || (r = "fas");
    return {
      prefix: r,
      iconName: a
    };
  }(n, r, u));
}
const oo = wr.filter(e => e !== br || e !== yr),
  io = Object.keys(Tr).filter(e => e !== br).map(e => Object.keys(Tr[e])).flat();
let lo = [],
  so = {};
const co = {},
  uo = Object.keys(co);
function fo(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++) r[a - 2] = arguments[a];
  return (so[e] || []).forEach(e => {
    t = e.apply(null, [t, ...r]);
  }), t;
}
function po(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  (so[e] || []).forEach(e => {
    e.apply(null, n);
  });
}
function mo() {
  const e = arguments[0],
    t = Array.prototype.slice.call(arguments, 1);
  return co[e] ? co[e].apply(null, t) : void 0;
}
function go(e) {
  "fa" === e.prefix && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || eo();
  if (t) return t = Qa(n, t) || t, Ra(vo.definitions, n, t) || Ra(Pa.styles, n, t);
}
const vo = new class {
    constructor() {
      this.definitions = {};
    }
    add() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
      const r = t.reduce(this._pullDefinitions, {});
      Object.keys(r).forEach(e => {
        this.definitions[e] = rr(rr({}, this.definitions[e] || {}), r[e]), Ma(e, r[e]);
        const t = ea[br][e];
        t && Ma(t, r[e]), Ka();
      });
    }
    reset() {
      this.definitions = {};
    }
    _pullDefinitions(e, t) {
      const n = t.prefix && t.iconName && t.icon ? {
        0: t
      } : t;
      return Object.keys(n).map(t => {
        const {
            prefix: r,
            iconName: a,
            icon: o
          } = n[t],
          i = o[2];
        e[r] || (e[r] = {}), i.length > 0 && i.forEach(t => {
          "string" == typeof t && (e[r][t] = o);
        }), e[r][a] = o;
      }), e;
    }
  }(),
  ho = {
    i2svg: function () {
      let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return mr ? (po("beforeI2svg", e), mo("pseudoElements2svg", e), mo("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
    },
    watch: function () {
      let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      const {
        autoReplaceSvgRoot: t
      } = e;
      var n;
      !1 === da.autoReplaceSvg && (da.autoReplaceSvg = !0), da.observeMutations = !0, n = () => {
        wo({
          autoReplaceSvgRoot: t
        }), po("watch", e);
      }, mr && (ja ? setTimeout(n, 0) : Fa.push(n));
    }
  },
  bo = {
    icon: e => {
      if (null === e) return null;
      if ("object" == typeof e && e.prefix && e.iconName) return {
        prefix: e.prefix,
        iconName: Qa(e.prefix, e.iconName) || e.iconName
      };
      if (Array.isArray(e) && 2 === e.length) {
        const t = 0 === e[1].indexOf("fa-") ? e[1].slice(3) : e[1],
          n = no(e[0]);
        return {
          prefix: n,
          iconName: Qa(n, t) || t
        };
      }
      if ("string" == typeof e && (e.indexOf("".concat(da.cssPrefix, "-")) > -1 || e.match(na))) {
        const t = ao(e.split(" "), {
          skipLookups: !0
        });
        return {
          prefix: t.prefix || eo(),
          iconName: Qa(t.prefix, t.iconName) || t.iconName
        };
      }
      if ("string" == typeof e) {
        const t = eo();
        return {
          prefix: t,
          iconName: Qa(t, e) || e
        };
      }
    }
  },
  yo = {
    noAuto: () => {
      da.autoReplaceSvg = !1, da.observeMutations = !1, po("noAuto");
    },
    config: da,
    dom: ho,
    parse: bo,
    library: vo,
    findIconDefinition: go,
    toHtml: Ca
  },
  wo = function () {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t = dr
    } = e;
    (Object.keys(Pa.styles).length > 0 || da.autoFetchSvg) && mr && da.autoReplaceSvg && yo.dom.i2svg({
      node: t
    });
  };
function xo(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function () {
      return e.abstract.map(e => Ca(e));
    }
  }), Object.defineProperty(e, "node", {
    get: function () {
      if (!mr) return;
      const t = dr.createElement("div");
      return t.innerHTML = e.html, t.children;
    }
  }), e;
}
function ko(e) {
  const {
      icons: {
        main: t,
        mask: n
      },
      prefix: r,
      iconName: a,
      transform: o,
      symbol: i,
      title: l,
      maskId: s,
      titleId: c,
      extra: u,
      watchable: d = !1
    } = e,
    {
      width: f,
      height: p
    } = n.found ? n : t,
    m = Or.includes(r),
    g = [da.replacementClass, a ? "".concat(da.cssPrefix, "-").concat(a) : ""].filter(e => -1 === u.classes.indexOf(e)).filter(e => "" !== e || !!e).concat(u.classes).join(" ");
  let v = {
    children: [],
    attributes: rr(rr({}, u.attributes), {}, {
      "data-prefix": r,
      "data-icon": a,
      class: g,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(f, " ").concat(p)
    })
  };
  const h = m && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(f / p * 16 * .0625, "em")
  } : {};
  d && (v.attributes[$r] = ""), l && (v.children.push({
    tag: "title",
    attributes: {
      id: v.attributes["aria-labelledby"] || "title-".concat(c || va())
    },
    children: [l]
  }), delete v.attributes.title);
  const b = rr(rr({}, v), {}, {
      prefix: r,
      iconName: a,
      main: t,
      mask: n,
      maskId: s,
      transform: o,
      symbol: i,
      styles: rr(rr({}, h), u.styles)
    }),
    {
      children: y,
      attributes: w
    } = n.found && t.found ? mo("generateAbstractMask", b) || {
      children: [],
      attributes: {}
    } : mo("generateAbstractIcon", b) || {
      children: [],
      attributes: {}
    };
  return b.children = y, b.attributes = w, i ? function (e) {
    let {
      prefix: t,
      iconName: n,
      children: r,
      attributes: a,
      symbol: o
    } = e;
    const i = !0 === o ? "".concat(t, "-").concat(da.cssPrefix, "-").concat(n) : o;
    return [{
      tag: "svg",
      attributes: {
        style: "display: none;"
      },
      children: [{
        tag: "symbol",
        attributes: rr(rr({}, a), {}, {
          id: i
        }),
        children: r
      }]
    }];
  }(b) : function (e) {
    let {
      children: t,
      main: n,
      mask: r,
      attributes: a,
      styles: o,
      transform: i
    } = e;
    if (xa(i) && n.found && !r.found) {
      const {
          width: e,
          height: t
        } = n,
        r = {
          x: e / t / 2,
          y: .5
        };
      a.style = wa(rr(rr({}, o), {}, {
        "transform-origin": "".concat(r.x + i.x / 16, "em ").concat(r.y + i.y / 16, "em")
      }));
    }
    return [{
      tag: "svg",
      attributes: a,
      children: t
    }];
  }(b);
}
function Eo(e) {
  const {
      content: t,
      width: n,
      height: r,
      transform: a,
      title: o,
      extra: i,
      watchable: l = !1
    } = e,
    s = rr(rr(rr({}, i.attributes), o ? {
      title: o
    } : {}), {}, {
      class: i.classes.join(" ")
    });
  l && (s[$r] = "");
  const c = rr({}, i.styles);
  xa(a) && (c.transform = function (e) {
    let {
        transform: t,
        width: n = Lr,
        height: r = Lr,
        startCentered: a = !1
      } = e,
      o = "";
    return o += a && gr ? "translate(".concat(t.x / pa - n / 2, "em, ").concat(t.y / pa - r / 2, "em) ") : a ? "translate(calc(-50% + ".concat(t.x / pa, "em), calc(-50% + ").concat(t.y / pa, "em)) ") : "translate(".concat(t.x / pa, "em, ").concat(t.y / pa, "em) "), o += "scale(".concat(t.size / pa * (t.flipX ? -1 : 1), ", ").concat(t.size / pa * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
  }({
    transform: a,
    startCentered: !0,
    width: n,
    height: r
  }), c["-webkit-transform"] = c.transform);
  const u = wa(c);
  u.length > 0 && (s.style = u);
  const d = [];
  return d.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), o && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), d;
}
const {
  styles: So
} = Pa;
function Oo(e) {
  const t = e[0],
    n = e[1],
    [r] = e.slice(4);
  let a = null;
  return a = Array.isArray(r) ? {
    tag: "g",
    attributes: {
      class: "".concat(da.cssPrefix, "-").concat(ia.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(da.cssPrefix, "-").concat(ia.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(da.cssPrefix, "-").concat(ia.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: a
  };
}
const No = {
  found: !1,
  width: 512,
  height: 512
};
function Ao(e, t) {
  let n = t;
  return "fa" === t && null !== da.styleDefault && (t = eo()), new Promise((r, a) => {
    if ("fa" === n) {
      const n = Za(e) || {};
      e = n.iconName || e, t = n.prefix || t;
    }
    if (e && t && So[t] && So[t][e]) {
      return r(Oo(So[t][e]));
    }
    !function (e, t) {
      Yr || da.showMissingIcons || !e || console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
    }(e, t), r(rr(rr({}, No), {}, {
      icon: da.showMissingIcons && e && mo("missingIconAbstract") || {}
    }));
  });
}
const Po = () => {},
  Fo = da.measurePerformance && pr && pr.mark && pr.measure ? pr : {
    mark: Po,
    measure: Po
  },
  To = 'FA "6.7.2"',
  jo = e => {
    Fo.mark("".concat(To, " ").concat(e, " ends")), Fo.measure("".concat(To, " ").concat(e), "".concat(To, " ").concat(e, " begins"), "".concat(To, " ").concat(e, " ends"));
  };
var Co = {
  begin: e => (Fo.mark("".concat(To, " ").concat(e, " begins")), () => jo(e)),
  end: jo
};
const Ro = () => {};
function Io(e) {
  return "string" == typeof (e.getAttribute ? e.getAttribute($r) : null);
}
function Do(e) {
  return dr.createElementNS("http://www.w3.org/2000/svg", e);
}
function Lo(e) {
  return dr.createElement(e);
}
function Mo(e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  const {
    ceFn: n = "svg" === e.tag ? Do : Lo
  } = t;
  if ("string" == typeof e) return dr.createTextNode(e);
  const r = n(e.tag);
  Object.keys(e.attributes || []).forEach(function (t) {
    r.setAttribute(t, e.attributes[t]);
  });
  return (e.children || []).forEach(function (e) {
    r.appendChild(Mo(e, {
      ceFn: n
    }));
  }), r;
}
const _o = {
  replace: function (e) {
    const t = e[0];
    if (t.parentNode) if (e[1].forEach(e => {
      t.parentNode.insertBefore(Mo(e), t);
    }), null === t.getAttribute($r) && da.keepOriginalSource) {
      let e = dr.createComment(function (e) {
        let t = " ".concat(e.outerHTML, " ");
        return t = "".concat(t, "Font Awesome fontawesome.com "), t;
      }(t));
      t.parentNode.replaceChild(e, t);
    } else t.remove();
  },
  nest: function (e) {
    const t = e[0],
      n = e[1];
    if (~ba(t).indexOf(da.replacementClass)) return _o.replace(e);
    const r = new RegExp("".concat(da.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const e = n[0].attributes.class.split(" ").reduce((e, t) => (t === da.replacementClass || t.match(r) ? e.toSvg.push(t) : e.toNode.push(t), e), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = e.toSvg.join(" "), 0 === e.toNode.length ? t.removeAttribute("class") : t.setAttribute("class", e.toNode.join(" "));
    }
    const a = n.map(e => Ca(e)).join("\n");
    t.setAttribute($r, ""), t.innerHTML = a;
  }
};
function $o(e) {
  e();
}
function zo(e, t) {
  const n = "function" == typeof t ? t : Ro;
  if (0 === e.length) n();else {
    let t = $o;
    da.mutateApproach === qr && (t = ur.requestAnimationFrame || $o), t(() => {
      const t = !0 === da.autoReplaceSvg ? _o.replace : _o[da.autoReplaceSvg] || _o.replace,
        r = Co.begin("mutate");
      e.map(t), r(), n();
    });
  }
}
let Bo = !1;
function Ho() {
  Bo = !0;
}
function Uo() {
  Bo = !1;
}
let Wo = null;
function qo(e) {
  if (!fr) return;
  if (!da.observeMutations) return;
  const {
    treeCallback: t = Ro,
    nodeCallback: n = Ro,
    pseudoElementsCallback: r = Ro,
    observeMutationsRoot: a = dr
  } = e;
  Wo = new fr(e => {
    if (Bo) return;
    const a = eo();
    ha(e).forEach(e => {
      if ("childList" === e.type && e.addedNodes.length > 0 && !Io(e.addedNodes[0]) && (da.searchPseudoElements && r(e.target), t(e.target)), "attributes" === e.type && e.target.parentNode && da.searchPseudoElements && r(e.target.parentNode), "attributes" === e.type && Io(e.target) && ~oa.indexOf(e.attributeName)) if ("class" === e.attributeName && function (e) {
        const t = e.getAttribute ? e.getAttribute(Hr) : null,
          n = e.getAttribute ? e.getAttribute(Ur) : null;
        return t && n;
      }(e.target)) {
        const {
          prefix: t,
          iconName: n
        } = ao(ba(e.target));
        e.target.setAttribute(Hr, t || a), n && e.target.setAttribute(Ur, n);
      } else (o = e.target) && o.classList && o.classList.contains && o.classList.contains(da.replacementClass) && n(e.target);
      var o;
    });
  }), mr && Wo.observe(a, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function Vo(e) {
  const t = e.getAttribute("data-prefix"),
    n = e.getAttribute("data-icon"),
    r = void 0 !== e.innerText ? e.innerText.trim() : "";
  let a = ao(ba(e));
  return a.prefix || (a.prefix = eo()), t && n && (a.prefix = t, a.iconName = n), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = (o = a.prefix, i = e.innerText, (Wa[o] || {})[i] || Ja(a.prefix, Da(e.innerText)))), !a.iconName && da.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
  var o, i;
}
function Yo(e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
    styleParser: !0
  };
  const {
      iconName: n,
      prefix: r,
      rest: a
    } = Vo(e),
    o = function (e) {
      const t = ha(e.attributes).reduce((e, t) => ("class" !== e.name && "style" !== e.name && (e[t.name] = t.value), e), {}),
        n = e.getAttribute("title"),
        r = e.getAttribute("data-fa-title-id");
      return da.autoA11y && (n ? t["aria-labelledby"] = "".concat(da.replacementClass, "-title-").concat(r || va()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
    }(e),
    i = fo("parseNodeAttributes", {}, e);
  let l = t.styleParser ? function (e) {
    const t = e.getAttribute("style");
    let n = [];
    return t && (n = t.split(";").reduce((e, t) => {
      const n = t.split(":"),
        r = n[0],
        a = n.slice(1);
      return r && a.length > 0 && (e[r] = a.join(":").trim()), e;
    }, {})), n;
  }(e) : [];
  return rr({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: ma,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: l,
      attributes: o
    }
  }, i);
}
const {
  styles: Go
} = Pa;
function Ko(e) {
  const t = "nest" === da.autoReplaceSvg ? Yo(e, {
    styleParser: !1
  }) : Yo(e);
  return ~t.extra.classes.indexOf(ra) ? mo("generateLayersText", e, t) : mo("generateSvgReplacementMutation", e, t);
}
function Xo(e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  if (!mr) return Promise.resolve();
  const n = dr.documentElement.classList,
    r = e => n.add("".concat(Wr, "-").concat(e)),
    a = e => n.remove("".concat(Wr, "-").concat(e)),
    o = da.autoFetchSvg ? [...kr, ...jr] : hr.concat(Object.keys(Go));
  o.includes("fa") || o.push("fa");
  const i = [".".concat(ra, ":not([").concat($r, "])")].concat(o.map(e => ".".concat(e, ":not([").concat($r, "])"))).join(", ");
  if (0 === i.length) return Promise.resolve();
  let l = [];
  try {
    l = ha(e.querySelectorAll(i));
  } catch (e) {}
  if (!(l.length > 0)) return Promise.resolve();
  r("pending"), a("complete");
  const s = Co.begin("onTree"),
    c = l.reduce((e, t) => {
      try {
        const n = Ko(t);
        n && e.push(n);
      } catch (e) {
        Yr || "MissingIcon" === e.name && console.error(e);
      }
      return e;
    }, []);
  return new Promise((e, n) => {
    Promise.all(c).then(n => {
      zo(n, () => {
        r("active"), r("complete"), a("pending"), "function" == typeof t && t(), s(), e();
      });
    }).catch(e => {
      s(), n(e);
    });
  });
}
function Jo(e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  Ko(e).then(e => {
    e && zo([e], t);
  });
}
const Qo = function (e) {
  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  const {
    transform: n = ma,
    symbol: r = !1,
    mask: a = null,
    maskId: o = null,
    title: i = null,
    titleId: l = null,
    classes: s = [],
    attributes: c = {},
    styles: u = {}
  } = t;
  if (!e) return;
  const {
    prefix: d,
    iconName: f,
    icon: p
  } = e;
  return xo(rr({
    type: "icon"
  }, e), () => (po("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), da.autoA11y && (i ? c["aria-labelledby"] = "".concat(da.replacementClass, "-title-").concat(l || va()) : (c["aria-hidden"] = "true", c.focusable = "false")), ko({
    icons: {
      main: Oo(p),
      mask: a ? Oo(a.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: d,
    iconName: f,
    transform: rr(rr({}, ma), n),
    symbol: r,
    title: i,
    maskId: o,
    titleId: l,
    extra: {
      attributes: c,
      styles: u,
      classes: s
    }
  })));
};
var Zo = {
    mixout() {
      return {
        icon: (e = Qo, function (t) {
          let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const r = (t || {}).icon ? t : go(t || {});
          let {
            mask: a
          } = n;
          return a && (a = (a || {}).icon ? a : go(a || {})), e(r, rr(rr({}, n), {}, {
            mask: a
          }));
        })
      };
      var e;
    },
    hooks: () => ({
      mutationObserverCallbacks: e => (e.treeCallback = Xo, e.nodeCallback = Jo, e)
    }),
    provides(e) {
      e.i2svg = function (e) {
        const {
          node: t = dr,
          callback: n = () => {}
        } = e;
        return Xo(t, n);
      }, e.generateSvgReplacementMutation = function (e, t) {
        const {
          iconName: n,
          title: r,
          titleId: a,
          prefix: o,
          transform: i,
          symbol: l,
          mask: s,
          maskId: c,
          extra: u
        } = t;
        return new Promise((t, d) => {
          Promise.all([Ao(n, o), s.iconName ? Ao(s.iconName, s.prefix) : Promise.resolve({
            found: !1,
            width: 512,
            height: 512,
            icon: {}
          })]).then(s => {
            let [d, f] = s;
            t([e, ko({
              icons: {
                main: d,
                mask: f
              },
              prefix: o,
              iconName: n,
              transform: i,
              symbol: l,
              maskId: c,
              title: r,
              titleId: a,
              extra: u,
              watchable: !0
            })]);
          }).catch(d);
        });
      }, e.generateAbstractIcon = function (e) {
        let {
          children: t,
          attributes: n,
          main: r,
          transform: a,
          styles: o
        } = e;
        const i = wa(o);
        let l;
        return i.length > 0 && (n.style = i), xa(a) && (l = mo("generateAbstractTransformGrouping", {
          main: r,
          transform: a,
          containerWidth: r.width,
          iconWidth: r.width
        })), t.push(l || r.icon), {
          children: t,
          attributes: n
        };
      };
    }
  },
  ei = {
    mixout: () => ({
      layer(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return xo({
          type: "layer"
        }, () => {
          po("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e(e => {
            Array.isArray(e) ? e.map(e => {
              r = r.concat(e.abstract);
            }) : r = r.concat(e.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(da.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    })
  },
  ti = {
    mixout: () => ({
      counter(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: a = {},
          styles: o = {}
        } = t;
        return xo({
          type: "counter",
          content: e
        }, () => (po("beforeDOMElementCreation", {
          content: e,
          params: t
        }), function (e) {
          const {
              content: t,
              title: n,
              extra: r
            } = e,
            a = rr(rr(rr({}, r.attributes), n ? {
              title: n
            } : {}), {}, {
              class: r.classes.join(" ")
            }),
            o = wa(r.styles);
          o.length > 0 && (a.style = o);
          const i = [];
          return i.push({
            tag: "span",
            attributes: a,
            children: [t]
          }), n && i.push({
            tag: "span",
            attributes: {
              class: "sr-only"
            },
            children: [n]
          }), i;
        }({
          content: e.toString(),
          title: n,
          extra: {
            attributes: a,
            styles: o,
            classes: ["".concat(da.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    })
  },
  ni = {
    mixout: () => ({
      text(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const {
          transform: n = ma,
          title: r = null,
          classes: a = [],
          attributes: o = {},
          styles: i = {}
        } = t;
        return xo({
          type: "text",
          content: e
        }, () => (po("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Eo({
          content: e,
          transform: rr(rr({}, ma), n),
          title: r,
          extra: {
            attributes: o,
            styles: i,
            classes: ["".concat(da.cssPrefix, "-layers-text"), ...a]
          }
        })));
      }
    }),
    provides(e) {
      e.generateLayersText = function (e, t) {
        const {
          title: n,
          transform: r,
          extra: a
        } = t;
        let o = null,
          i = null;
        if (gr) {
          const t = parseInt(getComputedStyle(e).fontSize, 10),
            n = e.getBoundingClientRect();
          o = n.width / t, i = n.height / t;
        }
        return da.autoA11y && !n && (a.attributes["aria-hidden"] = "true"), Promise.resolve([e, Eo({
          content: e.innerHTML,
          width: o,
          height: i,
          transform: r,
          title: n,
          extra: a,
          watchable: !0
        })]);
      };
    }
  };
const ri = new RegExp('"', "ug"),
  ai = [1105920, 1112319],
  oi = rr(rr(rr(rr({}, {
    FontAwesome: {
      normal: "fas",
      400: "fas"
    }
  }), {
    "Font Awesome 6 Free": {
      900: "fas",
      400: "far"
    },
    "Font Awesome 6 Pro": {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal",
      100: "fat"
    },
    "Font Awesome 6 Brands": {
      400: "fab",
      normal: "fab"
    },
    "Font Awesome 6 Duotone": {
      900: "fad",
      400: "fadr",
      normal: "fadr",
      300: "fadl",
      100: "fadt"
    },
    "Font Awesome 6 Sharp": {
      900: "fass",
      400: "fasr",
      normal: "fasr",
      300: "fasl",
      100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
      900: "fasds",
      400: "fasdr",
      normal: "fasdr",
      300: "fasdl",
      100: "fasdt"
    }
  }), {
    "Font Awesome 5 Free": {
      900: "fas",
      400: "far"
    },
    "Font Awesome 5 Pro": {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal"
    },
    "Font Awesome 5 Brands": {
      400: "fab",
      normal: "fab"
    },
    "Font Awesome 5 Duotone": {
      900: "fad"
    }
  }), {
    "Font Awesome Kit": {
      400: "fak",
      normal: "fak"
    },
    "Font Awesome Kit Duotone": {
      400: "fakd",
      normal: "fakd"
    }
  }),
  ii = Object.keys(oi).reduce((e, t) => (e[t.toLowerCase()] = oi[t], e), {}),
  li = Object.keys(ii).reduce((e, t) => {
    const n = ii[t];
    return e[t] = n[900] || [...Object.entries(n)][0][1], e;
  }, {});
function si(e, t) {
  const n = "".concat(Br).concat(t.replace(":", "-"));
  return new Promise((r, a) => {
    if (null !== e.getAttribute(n)) return r();
    const o = ha(e.children).filter(e => e.getAttribute(zr) === t)[0],
      i = ur.getComputedStyle(e, t),
      l = i.getPropertyValue("font-family"),
      s = l.match(aa),
      c = i.getPropertyValue("font-weight"),
      u = i.getPropertyValue("content");
    if (o && !s) return e.removeChild(o), r();
    if (s && "none" !== u && "" !== u) {
      const u = i.getPropertyValue("content");
      let d = function (e, t) {
        const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(),
          r = parseInt(t),
          a = isNaN(r) ? "normal" : r;
        return (ii[n] || {})[a] || li[n];
      }(l, c);
      const {
          value: f,
          isSecondary: p
        } = function (e) {
          const t = e.replace(ri, ""),
            n = function (e, t) {
              const n = e.length;
              let r,
                a = e.charCodeAt(t);
              return a >= 55296 && a <= 56319 && n > t + 1 && (r = e.charCodeAt(t + 1), r >= 56320 && r <= 57343) ? 1024 * (a - 55296) + r - 56320 + 65536 : a;
            }(t, 0),
            r = n >= ai[0] && n <= ai[1],
            a = 2 === t.length && t[0] === t[1];
          return {
            value: Da(a ? t[0] : t),
            isSecondary: r || a
          };
        }(u),
        m = s[0].startsWith("FontAwesome");
      let g = Ja(d, f),
        v = g;
      if (m) {
        const e = function (e) {
          const t = Va[e],
            n = Ja("fas", e);
          return t || (n ? {
            prefix: "fas",
            iconName: n
          } : null) || {
            prefix: null,
            iconName: null
          };
        }(f);
        e.iconName && e.prefix && (g = e.iconName, d = e.prefix);
      }
      if (!g || p || o && o.getAttribute(Hr) === d && o.getAttribute(Ur) === v) r();else {
        e.setAttribute(n, v), o && e.removeChild(o);
        const i = {
            iconName: null,
            title: null,
            titleId: null,
            prefix: null,
            transform: ma,
            symbol: !1,
            mask: {
              iconName: null,
              prefix: null,
              rest: []
            },
            maskId: null,
            extra: {
              classes: [],
              styles: {},
              attributes: {}
            }
          },
          {
            extra: l
          } = i;
        l.attributes[zr] = t, Ao(g, d).then(a => {
          const o = ko(rr(rr({}, i), {}, {
              icons: {
                main: a,
                mask: to()
              },
              prefix: d,
              iconName: v,
              extra: l,
              watchable: !0
            })),
            s = dr.createElementNS("http://www.w3.org/2000/svg", "svg");
          "::before" === t ? e.insertBefore(s, e.firstChild) : e.appendChild(s), s.outerHTML = o.map(e => Ca(e)).join("\n"), e.removeAttribute(n), r();
        }).catch(a);
      }
    } else r();
  });
}
function ci(e) {
  return Promise.all([si(e, "::before"), si(e, "::after")]);
}
function ui(e) {
  return !(e.parentNode === document.head || ~Vr.indexOf(e.tagName.toUpperCase()) || e.getAttribute(zr) || e.parentNode && "svg" === e.parentNode.tagName);
}
function di(e) {
  if (mr) return new Promise((t, n) => {
    const r = ha(e.querySelectorAll("*")).filter(ui).map(ci),
      a = Co.begin("searchPseudoElements");
    Ho(), Promise.all(r).then(() => {
      a(), Uo(), t();
    }).catch(() => {
      a(), Uo(), n();
    });
  });
}
var fi = {
  hooks: () => ({
    mutationObserverCallbacks: e => (e.pseudoElementsCallback = di, e)
  }),
  provides(e) {
    e.pseudoElements2svg = function (e) {
      const {
        node: t = dr
      } = e;
      da.searchPseudoElements && di(t);
    };
  }
};
let pi = !1;
var mi = {
  mixout: () => ({
    dom: {
      unwatch() {
        Ho(), pi = !0;
      }
    }
  }),
  hooks: () => ({
    bootstrap() {
      qo(fo("mutationObserverCallbacks", {}));
    },
    noAuto() {
      Wo && Wo.disconnect();
    },
    watch(e) {
      const {
        observeMutationsRoot: t
      } = e;
      pi ? Uo() : qo(fo("mutationObserverCallbacks", {
        observeMutationsRoot: t
      }));
    }
  })
};
const gi = e => e.toLowerCase().split(" ").reduce((e, t) => {
  const n = t.toLowerCase().split("-"),
    r = n[0];
  let a = n.slice(1).join("-");
  if (r && "h" === a) return e.flipX = !0, e;
  if (r && "v" === a) return e.flipY = !0, e;
  if (a = parseFloat(a), isNaN(a)) return e;
  switch (r) {
    case "grow":
      e.size = e.size + a;
      break;
    case "shrink":
      e.size = e.size - a;
      break;
    case "left":
      e.x = e.x - a;
      break;
    case "right":
      e.x = e.x + a;
      break;
    case "up":
      e.y = e.y - a;
      break;
    case "down":
      e.y = e.y + a;
      break;
    case "rotate":
      e.rotate = e.rotate + a;
  }
  return e;
}, {
  size: 16,
  x: 0,
  y: 0,
  flipX: !1,
  flipY: !1,
  rotate: 0
});
var vi = {
  mixout: () => ({
    parse: {
      transform: e => gi(e)
    }
  }),
  hooks: () => ({
    parseNodeAttributes(e, t) {
      const n = t.getAttribute("data-fa-transform");
      return n && (e.transform = gi(n)), e;
    }
  }),
  provides(e) {
    e.generateAbstractTransformGrouping = function (e) {
      let {
        main: t,
        transform: n,
        containerWidth: r,
        iconWidth: a
      } = e;
      const o = {
          transform: "translate(".concat(r / 2, " 256)")
        },
        i = "translate(".concat(32 * n.x, ", ").concat(32 * n.y, ") "),
        l = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "),
        s = "rotate(".concat(n.rotate, " 0 0)"),
        c = {
          outer: o,
          inner: {
            transform: "".concat(i, " ").concat(l, " ").concat(s)
          },
          path: {
            transform: "translate(".concat(a / 2 * -1, " -256)")
          }
        };
      return {
        tag: "g",
        attributes: rr({}, c.outer),
        children: [{
          tag: "g",
          attributes: rr({}, c.inner),
          children: [{
            tag: t.icon.tag,
            children: t.icon.children,
            attributes: rr(rr({}, t.icon.attributes), c.path)
          }]
        }]
      };
    };
  }
};
const hi = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function bi(e) {
  let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
var yi = {
    hooks: () => ({
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"),
          r = n ? ao(n.split(" ").map(e => e.trim())) : to();
        return r.prefix || (r.prefix = eo()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    }),
    provides(e) {
      e.generateAbstractMask = function (e) {
        let {
          children: t,
          attributes: n,
          main: r,
          mask: a,
          maskId: o,
          transform: i
        } = e;
        const {
            width: l,
            icon: s
          } = r,
          {
            width: c,
            icon: u
          } = a,
          d = function (e) {
            let {
              transform: t,
              containerWidth: n,
              iconWidth: r
            } = e;
            const a = {
                transform: "translate(".concat(n / 2, " 256)")
              },
              o = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
              i = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
              l = "rotate(".concat(t.rotate, " 0 0)");
            return {
              outer: a,
              inner: {
                transform: "".concat(o, " ").concat(i, " ").concat(l)
              },
              path: {
                transform: "translate(".concat(r / 2 * -1, " -256)")
              }
            };
          }({
            transform: i,
            containerWidth: c,
            iconWidth: l
          }),
          f = {
            tag: "rect",
            attributes: rr(rr({}, hi), {}, {
              fill: "white"
            })
          },
          p = s.children ? {
            children: s.children.map(bi)
          } : {},
          m = {
            tag: "g",
            attributes: rr({}, d.inner),
            children: [bi(rr({
              tag: s.tag,
              attributes: rr(rr({}, s.attributes), d.path)
            }, p))]
          },
          g = {
            tag: "g",
            attributes: rr({}, d.outer),
            children: [m]
          },
          v = "mask-".concat(o || va()),
          h = "clip-".concat(o || va()),
          b = {
            tag: "mask",
            attributes: rr(rr({}, hi), {}, {
              id: v,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse"
            }),
            children: [f, g]
          },
          y = {
            tag: "defs",
            children: [{
              tag: "clipPath",
              attributes: {
                id: h
              },
              children: (w = u, "g" === w.tag ? w.children : [w])
            }, b]
          };
        var w;
        return t.push(y, {
          tag: "rect",
          attributes: rr({
            fill: "currentColor",
            "clip-path": "url(#".concat(h, ")"),
            mask: "url(#".concat(v, ")")
          }, hi)
        }), {
          children: t,
          attributes: n
        };
      };
    }
  },
  wi = {
    provides(e) {
      let t = !1;
      ur.matchMedia && (t = ur.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function () {
        const e = [],
          n = {
            fill: "currentColor"
          },
          r = {
            attributeType: "XML",
            repeatCount: "indefinite",
            dur: "2s"
          };
        e.push({
          tag: "path",
          attributes: rr(rr({}, n), {}, {
            d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
          })
        });
        const a = rr(rr({}, r), {}, {
            attributeName: "opacity"
          }),
          o = {
            tag: "circle",
            attributes: rr(rr({}, n), {}, {
              cx: "256",
              cy: "364",
              r: "28"
            }),
            children: []
          };
        return t || o.children.push({
          tag: "animate",
          attributes: rr(rr({}, r), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: rr(rr({}, a), {}, {
            values: "1;0;1;1;0;1;"
          })
        }), e.push(o), e.push({
          tag: "path",
          attributes: rr(rr({}, n), {}, {
            opacity: "1",
            d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
          }),
          children: t ? [] : [{
            tag: "animate",
            attributes: rr(rr({}, a), {}, {
              values: "1;0;0;0;0;1;"
            })
          }]
        }), t || e.push({
          tag: "path",
          attributes: rr(rr({}, n), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: rr(rr({}, a), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        }), {
          tag: "g",
          attributes: {
            class: "missing"
          },
          children: e
        };
      };
    }
  };
!function (e, t) {
  let {
    mixoutsTo: n
  } = t;
  lo = e, so = {}, Object.keys(co).forEach(e => {
    -1 === uo.indexOf(e) && delete co[e];
  }), lo.forEach(e => {
    const t = e.mixout ? e.mixout() : {};
    if (Object.keys(t).forEach(e => {
      "function" == typeof t[e] && (n[e] = t[e]), "object" == typeof t[e] && Object.keys(t[e]).forEach(r => {
        n[e] || (n[e] = {}), n[e][r] = t[e][r];
      });
    }), e.hooks) {
      const t = e.hooks();
      Object.keys(t).forEach(e => {
        so[e] || (so[e] = []), so[e].push(t[e]);
      });
    }
    e.provides && e.provides(co);
  });
}([Na, Zo, ei, ti, ni, fi, mi, vi, yi, wi, {
  hooks: () => ({
    parseNodeAttributes(e, t) {
      const n = t.getAttribute("data-fa-symbol"),
        r = null !== n && ("" === n || n);
      return e.symbol = r, e;
    }
  })
}], {
  mixoutsTo: yo
});
const xi = yo.parse,
  ki = yo.icon;
var Ei = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  Si = {
    exports: {}
  },
  Oi = {
    exports: {}
  },
  Ni = {},
  Ai = "function" == typeof Symbol && Symbol.for,
  Pi = Ai ? Symbol.for("react.element") : 60103,
  Fi = Ai ? Symbol.for("react.portal") : 60106,
  Ti = Ai ? Symbol.for("react.fragment") : 60107,
  ji = Ai ? Symbol.for("react.strict_mode") : 60108,
  Ci = Ai ? Symbol.for("react.profiler") : 60114,
  Ri = Ai ? Symbol.for("react.provider") : 60109,
  Ii = Ai ? Symbol.for("react.context") : 60110,
  Di = Ai ? Symbol.for("react.async_mode") : 60111,
  Li = Ai ? Symbol.for("react.concurrent_mode") : 60111,
  Mi = Ai ? Symbol.for("react.forward_ref") : 60112,
  _i = Ai ? Symbol.for("react.suspense") : 60113,
  $i = Ai ? Symbol.for("react.suspense_list") : 60120,
  zi = Ai ? Symbol.for("react.memo") : 60115,
  Bi = Ai ? Symbol.for("react.lazy") : 60116,
  Hi = Ai ? Symbol.for("react.block") : 60121,
  Ui = Ai ? Symbol.for("react.fundamental") : 60117,
  Wi = Ai ? Symbol.for("react.responder") : 60118,
  qi = Ai ? Symbol.for("react.scope") : 60119;
function Vi(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case Pi:
        switch (e = e.type) {
          case Di:
          case Li:
          case Ti:
          case Ci:
          case ji:
          case _i:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case Ii:
              case Mi:
              case Bi:
              case zi:
              case Ri:
                return e;
              default:
                return t;
            }
        }
      case Fi:
        return t;
    }
  }
}
function Yi(e) {
  return Vi(e) === Li;
}
Ni.AsyncMode = Di, Ni.ConcurrentMode = Li, Ni.ContextConsumer = Ii, Ni.ContextProvider = Ri, Ni.Element = Pi, Ni.ForwardRef = Mi, Ni.Fragment = Ti, Ni.Lazy = Bi, Ni.Memo = zi, Ni.Portal = Fi, Ni.Profiler = Ci, Ni.StrictMode = ji, Ni.Suspense = _i, Ni.isAsyncMode = function (e) {
  return Yi(e) || Vi(e) === Di;
}, Ni.isConcurrentMode = Yi, Ni.isContextConsumer = function (e) {
  return Vi(e) === Ii;
}, Ni.isContextProvider = function (e) {
  return Vi(e) === Ri;
}, Ni.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === Pi;
}, Ni.isForwardRef = function (e) {
  return Vi(e) === Mi;
}, Ni.isFragment = function (e) {
  return Vi(e) === Ti;
}, Ni.isLazy = function (e) {
  return Vi(e) === Bi;
}, Ni.isMemo = function (e) {
  return Vi(e) === zi;
}, Ni.isPortal = function (e) {
  return Vi(e) === Fi;
}, Ni.isProfiler = function (e) {
  return Vi(e) === Ci;
}, Ni.isStrictMode = function (e) {
  return Vi(e) === ji;
}, Ni.isSuspense = function (e) {
  return Vi(e) === _i;
}, Ni.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === Ti || e === Li || e === Ci || e === ji || e === _i || e === $i || "object" == typeof e && null !== e && (e.$$typeof === Bi || e.$$typeof === zi || e.$$typeof === Ri || e.$$typeof === Ii || e.$$typeof === Mi || e.$$typeof === Ui || e.$$typeof === Wi || e.$$typeof === qi || e.$$typeof === Hi);
}, Ni.typeOf = Vi;
var Gi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    a = e ? Symbol.for("react.strict_mode") : 60108,
    o = e ? Symbol.for("react.profiler") : 60114,
    i = e ? Symbol.for("react.provider") : 60109,
    l = e ? Symbol.for("react.context") : 60110,
    s = e ? Symbol.for("react.async_mode") : 60111,
    c = e ? Symbol.for("react.concurrent_mode") : 60111,
    u = e ? Symbol.for("react.forward_ref") : 60112,
    d = e ? Symbol.for("react.suspense") : 60113,
    f = e ? Symbol.for("react.suspense_list") : 60120,
    p = e ? Symbol.for("react.memo") : 60115,
    m = e ? Symbol.for("react.lazy") : 60116,
    g = e ? Symbol.for("react.block") : 60121,
    v = e ? Symbol.for("react.fundamental") : 60117,
    h = e ? Symbol.for("react.responder") : 60118,
    b = e ? Symbol.for("react.scope") : 60119;
  function y(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;
      switch (f) {
        case t:
          var g = e.type;
          switch (g) {
            case s:
            case c:
            case r:
            case o:
            case a:
            case d:
              return g;
            default:
              var v = g && g.$$typeof;
              switch (v) {
                case l:
                case u:
                case m:
                case p:
                case i:
                  return v;
                default:
                  return f;
              }
          }
        case n:
          return f;
      }
    }
  }
  var w = s,
    x = c,
    k = l,
    E = i,
    S = t,
    O = u,
    N = r,
    A = m,
    P = p,
    F = n,
    T = o,
    j = a,
    C = d,
    R = !1;
  function I(e) {
    return y(e) === c;
  }
  Gi.AsyncMode = w, Gi.ConcurrentMode = x, Gi.ContextConsumer = k, Gi.ContextProvider = E, Gi.Element = S, Gi.ForwardRef = O, Gi.Fragment = N, Gi.Lazy = A, Gi.Memo = P, Gi.Portal = F, Gi.Profiler = T, Gi.StrictMode = j, Gi.Suspense = C, Gi.isAsyncMode = function (e) {
    return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(e) || y(e) === s;
  }, Gi.isConcurrentMode = I, Gi.isContextConsumer = function (e) {
    return y(e) === l;
  }, Gi.isContextProvider = function (e) {
    return y(e) === i;
  }, Gi.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, Gi.isForwardRef = function (e) {
    return y(e) === u;
  }, Gi.isFragment = function (e) {
    return y(e) === r;
  }, Gi.isLazy = function (e) {
    return y(e) === m;
  }, Gi.isMemo = function (e) {
    return y(e) === p;
  }, Gi.isPortal = function (e) {
    return y(e) === n;
  }, Gi.isProfiler = function (e) {
    return y(e) === o;
  }, Gi.isStrictMode = function (e) {
    return y(e) === a;
  }, Gi.isSuspense = function (e) {
    return y(e) === d;
  }, Gi.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === c || e === o || e === a || e === d || e === f || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === p || e.$$typeof === i || e.$$typeof === l || e.$$typeof === u || e.$$typeof === v || e.$$typeof === h || e.$$typeof === b || e.$$typeof === g);
  }, Gi.typeOf = y;
}(), "production" === process.env.NODE_ENV ? Oi.exports = Ni : Oi.exports = Gi
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/;
var Ki = Object.getOwnPropertySymbols,
  Xi = Object.prototype.hasOwnProperty,
  Ji = Object.prototype.propertyIsEnumerable;
var Qi = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
      var r = Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      });
      if ("0123456789" !== r.join("")) return !1;
      var a = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        a[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, a = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), o = 1; o < arguments.length; o++) {
      for (var i in n = Object(arguments[o])) Xi.call(n, i) && (a[i] = n[i]);
      if (Ki) {
        r = Ki(n);
        for (var l = 0; l < r.length; l++) Ji.call(n, r[l]) && (a[r[l]] = n[r[l]]);
      }
    }
    return a;
  },
  Zi = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  el = Function.call.bind(Object.prototype.hasOwnProperty),
  tl = function () {};
if ("production" !== process.env.NODE_ENV) {
  var nl = Zi,
    rl = {},
    al = el;
  tl = function (e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);
    try {
      throw new Error(t);
    } catch (e) {}
  };
}
function ol(e, t, n, r, a) {
  if ("production" !== process.env.NODE_ENV) for (var o in e) if (al(e, o)) {
    var i;
    try {
      if ("function" != typeof e[o]) {
        var l = Error((r || "React class") + ": " + n + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
        throw l.name = "Invariant Violation", l;
      }
      i = e[o](t, o, r, n, null, nl);
    } catch (e) {
      i = e;
    }
    if (!i || i instanceof Error || tl((r || "React class") + ": type specification of " + n + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in rl)) {
      rl[i.message] = !0;
      var s = a ? a() : "";
      tl("Failed " + n + " type: " + i.message + (null != s ? s : ""));
    }
  }
}
ol.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (rl = {});
};
var il = ol,
  ll = Oi.exports,
  sl = Qi,
  cl = Zi,
  ul = el,
  dl = il,
  fl = function () {};
function pl() {
  return null;
}
"production" !== process.env.NODE_ENV && (fl = function (e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);
  try {
    throw new Error(t);
  } catch (e) {}
});
var ml = Zi;
function gl() {}
function vl() {}
vl.resetWarningCache = gl;
if ("production" !== process.env.NODE_ENV) {
  var hl = Oi.exports;
  Si.exports = function (e, t) {
    var n = "function" == typeof Symbol && Symbol.iterator,
      r = "@@iterator",
      a = "<<anonymous>>",
      o = {
        array: c("array"),
        bigint: c("bigint"),
        bool: c("boolean"),
        func: c("function"),
        number: c("number"),
        object: c("object"),
        string: c("string"),
        symbol: c("symbol"),
        any: s(pl),
        arrayOf: function (e) {
          return s(function (t, n, r, a, o) {
            if ("function" != typeof e) return new l("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var i = t[n];
            if (!Array.isArray(i)) return new l("Invalid " + a + " `" + o + "` of type `" + f(i) + "` supplied to `" + r + "`, expected an array.");
            for (var s = 0; s < i.length; s++) {
              var c = e(i, s, r, a, o + "[" + s + "]", cl);
              if (c instanceof Error) return c;
            }
            return null;
          });
        },
        element: s(function (t, n, r, a, o) {
          var i = t[n];
          return e(i) ? null : new l("Invalid " + a + " `" + o + "` of type `" + f(i) + "` supplied to `" + r + "`, expected a single ReactElement.");
        }),
        elementType: s(function (e, t, n, r, a) {
          var o = e[t];
          return ll.isValidElementType(o) ? null : new l("Invalid " + r + " `" + a + "` of type `" + f(o) + "` supplied to `" + n + "`, expected a single ReactElement type.");
        }),
        instanceOf: function (e) {
          return s(function (t, n, r, o, i) {
            if (!(t[n] instanceof e)) {
              var s = e.name || a;
              return new l("Invalid " + o + " `" + i + "` of type `" + ((c = t[n]).constructor && c.constructor.name ? c.constructor.name : a) + "` supplied to `" + r + "`, expected instance of `" + s + "`.");
            }
            var c;
            return null;
          });
        },
        node: s(function (e, t, n, r, a) {
          return d(e[t]) ? null : new l("Invalid " + r + " `" + a + "` supplied to `" + n + "`, expected a ReactNode.");
        }),
        objectOf: function (e) {
          return s(function (t, n, r, a, o) {
            if ("function" != typeof e) return new l("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var i = t[n],
              s = f(i);
            if ("object" !== s) return new l("Invalid " + a + " `" + o + "` of type `" + s + "` supplied to `" + r + "`, expected an object.");
            for (var c in i) if (ul(i, c)) {
              var u = e(i, c, r, a, o + "." + c, cl);
              if (u instanceof Error) return u;
            }
            return null;
          });
        },
        oneOf: function (e) {
          return Array.isArray(e) ? s(function (t, n, r, a, o) {
            for (var s = t[n], c = 0; c < e.length; c++) if (i(s, e[c])) return null;
            var u = JSON.stringify(e, function (e, t) {
              return "symbol" === p(t) ? String(t) : t;
            });
            return new l("Invalid " + a + " `" + o + "` of value `" + String(s) + "` supplied to `" + r + "`, expected one of " + u + ".");
          }) : ("production" !== process.env.NODE_ENV && fl(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), pl);
        },
        oneOfType: function (e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && fl("Invalid argument supplied to oneOfType, expected an instance of array."), pl;
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            if ("function" != typeof n) return fl("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + m(n) + " at index " + t + "."), pl;
          }
          return s(function (t, n, r, a, o) {
            for (var i = [], s = 0; s < e.length; s++) {
              var c = (0, e[s])(t, n, r, a, o, cl);
              if (null == c) return null;
              c.data && ul(c.data, "expectedType") && i.push(c.data.expectedType);
            }
            return new l("Invalid " + a + " `" + o + "` supplied to `" + r + "`" + (i.length > 0 ? ", expected one of type [" + i.join(", ") + "]" : "") + ".");
          });
        },
        shape: function (e) {
          return s(function (t, n, r, a, o) {
            var i = t[n],
              s = f(i);
            if ("object" !== s) return new l("Invalid " + a + " `" + o + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
            for (var c in e) {
              var d = e[c];
              if ("function" != typeof d) return u(r, a, o, c, p(d));
              var m = d(i, c, r, a, o + "." + c, cl);
              if (m) return m;
            }
            return null;
          });
        },
        exact: function (e) {
          return s(function (t, n, r, a, o) {
            var i = t[n],
              s = f(i);
            if ("object" !== s) return new l("Invalid " + a + " `" + o + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
            var c = sl({}, t[n], e);
            for (var d in c) {
              var m = e[d];
              if (ul(e, d) && "function" != typeof m) return u(r, a, o, d, p(m));
              if (!m) return new l("Invalid " + a + " `" + o + "` key `" + d + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var g = m(i, d, r, a, o + "." + d, cl);
              if (g) return g;
            }
            return null;
          });
        }
      };
    function i(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }
    function l(e, t) {
      this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
    }
    function s(e) {
      if ("production" !== process.env.NODE_ENV) var n = {},
        r = 0;
      function o(o, i, s, c, u, d, f) {
        if (c = c || a, d = d || s, f !== cl) {
          if (t) {
            var p = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw p.name = "Invariant Violation", p;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var m = c + ":" + s;
            !n[m] && r < 3 && (fl("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[m] = !0, r++);
          }
        }
        return null == i[s] ? o ? null === i[s] ? new l("The " + u + " `" + d + "` is marked as required in `" + c + "`, but its value is `null`.") : new l("The " + u + " `" + d + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(i, s, c, u, d);
      }
      var i = o.bind(null, !1);
      return i.isRequired = o.bind(null, !0), i;
    }
    function c(e) {
      return s(function (t, n, r, a, o, i) {
        var s = t[n];
        return f(s) !== e ? new l("Invalid " + a + " `" + o + "` of type `" + p(s) + "` supplied to `" + r + "`, expected `" + e + "`.", {
          expectedType: e
        }) : null;
      });
    }
    function u(e, t, n, r, a) {
      return new l((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + a + "`.");
    }
    function d(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t;
        case "object":
          if (Array.isArray(t)) return t.every(d);
          if (null === t || e(t)) return !0;
          var a = function (e) {
            var t = e && (n && e[n] || e[r]);
            if ("function" == typeof t) return t;
          }(t);
          if (!a) return !1;
          var o,
            i = a.call(t);
          if (a !== t.entries) {
            for (; !(o = i.next()).done;) if (!d(o.value)) return !1;
          } else for (; !(o = i.next()).done;) {
            var l = o.value;
            if (l && !d(l[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function f(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }
    function p(e) {
      if (null == e) return "" + e;
      var t = f(e);
      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }
      return t;
    }
    function m(e) {
      var t = p(e);
      switch (t) {
        case "array":
        case "object":
          return "an " + t;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;
        default:
          return t;
      }
    }
    return l.prototype = Error.prototype, o.checkPropTypes = dl, o.resetWarningCache = dl.resetWarningCache, o.PropTypes = o, o;
  }(hl.isElement, !0);
} else Si.exports = function () {
  function e(e, t, n, r, a, o) {
    if (o !== ml) {
      var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw i.name = "Invariant Violation", i;
    }
  }
  function t() {
    return e;
  }
  e.isRequired = e;
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: vl,
    resetWarningCache: gl
  };
  return n.PropTypes = n, n;
}();
var bl = Si.exports;
function yl(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function wl(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t);
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function xl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? xl(Object(n), !0).forEach(function (t) {
      wl(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xl(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function El(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        a,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (n = n.call(e)).next, 0 === t) ;else for (; !(s = (r = o.call(n)).done) && (l.push(r.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, a = e;
      } finally {
        try {
          if (!s && null != n.return && (i = n.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw a;
        }
      }
      return l;
    }
  }(e, t) || Nl(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Sl(e) {
  return function (e) {
    if (Array.isArray(e)) return yl(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Nl(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Ol(e) {
  return Ol = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ol(e);
}
function Nl(e, t) {
  if (e) {
    if ("string" == typeof e) return yl(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? yl(e, t) : void 0;
  }
}
var Al;
try {
  var Pl = require("@fortawesome/fontawesome-svg-core/package.json");
  Al = Pl.version;
} catch (Ti) {
  Al = "undefined" != typeof process && process.env.FA_VERSION || "7.0.0";
}
function Fl(e) {
  var t = e.beat,
    n = e.fade,
    r = e.beatFade,
    a = e.bounce,
    o = e.shake,
    i = e.flash,
    l = e.spin,
    s = e.spinPulse,
    c = e.spinReverse,
    u = e.pulse,
    d = e.fixedWidth,
    f = e.inverse,
    p = e.border,
    m = e.listItem,
    g = e.flip,
    v = e.size,
    h = e.rotation,
    b = e.pull,
    y = e.swapOpacity,
    w = e.rotateBy,
    x = e.widthAuto,
    k = function (e, t) {
      for (var n = El(e.split("-"), 2), r = n[0], a = n[1], o = El(t.split("-"), 2), i = o[0], l = o[1], s = r.split("."), c = i.split("."), u = 0; u < Math.max(s.length, c.length); u++) {
        var d = s[u] || "0",
          f = c[u] || "0",
          p = parseInt(d, 10),
          m = parseInt(f, 10);
        if (p !== m) return p > m;
      }
      for (var g = 0; g < Math.max(s.length, c.length); g++) {
        var v = s[g] || "0",
          h = c[g] || "0";
        if (v !== h && v.length !== h.length) return v.length < h.length;
      }
      return !(a && !l);
    }(Al, "7.0.0"),
    E = wl(wl(wl(wl(wl(wl({
      "fa-beat": t,
      "fa-fade": n,
      "fa-beat-fade": r,
      "fa-bounce": a,
      "fa-shake": o,
      "fa-flash": i,
      "fa-spin": l,
      "fa-spin-reverse": c,
      "fa-spin-pulse": s,
      "fa-pulse": u,
      "fa-fw": d,
      "fa-inverse": f,
      "fa-border": p,
      "fa-li": m,
      "fa-flip": !0 === g,
      "fa-flip-horizontal": "horizontal" === g || "both" === g,
      "fa-flip-vertical": "vertical" === g || "both" === g
    }, "fa-".concat(v), null != v), "fa-rotate-".concat(h), null != h && 0 !== h), "fa-pull-".concat(b), null != b), "fa-swap-opacity", y), "fa-rotate-by", k && w), "fa-width-auto", k && x);
  return Object.keys(E).map(function (e) {
    return E[e] ? e : null;
  }).filter(function (e) {
    return e;
  });
}
function Tl(e) {
  return t = e, (t -= 0) == t ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
    return t ? t.toUpperCase() : "";
  })).substr(0, 1).toLowerCase() + e.substr(1);
  var t;
}
var jl = ["style"];
var Cl = !1;
try {
  Cl = "production" === process.env.NODE_ENV;
} catch (Ti) {}
function Rl(e) {
  return e && "object" === Ol(e) && e.prefix && e.iconName && e.icon ? e : xi.icon ? xi.icon(e) : null === e ? null : e && "object" === Ol(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
    prefix: e[0],
    iconName: e[1]
  } : "string" == typeof e ? {
    prefix: "fas",
    iconName: e
  } : void 0;
}
function Il(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? wl({}, e, t) : {};
}
var Dl = {
    border: !1,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: !1,
    inverse: !1,
    flip: !1,
    icon: null,
    listItem: !1,
    pull: null,
    pulse: !1,
    rotation: null,
    rotateBy: !1,
    size: null,
    spin: !1,
    spinPulse: !1,
    spinReverse: !1,
    beat: !1,
    fade: !1,
    beatFade: !1,
    bounce: !1,
    shake: !1,
    symbol: !1,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: !1,
    widthAuto: !1
  },
  Ll = t.forwardRef(function (e, t) {
    var n = kl(kl({}, Dl), e),
      r = n.icon,
      a = n.mask,
      o = n.symbol,
      i = n.className,
      l = n.title,
      s = n.titleId,
      c = n.maskId,
      u = Rl(r),
      d = Il("classes", [].concat(Sl(Fl(n)), Sl((i || "").split(" ")))),
      f = Il("transform", "string" == typeof n.transform ? xi.transform(n.transform) : n.transform),
      p = Il("mask", Rl(a)),
      m = ki(u, kl(kl(kl(kl({}, d), f), p), {}, {
        symbol: o,
        title: l,
        titleId: s,
        maskId: c
      }));
    if (!m) return function () {
      var e;
      !Cl && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
    }("Could not find icon", u), null;
    var g = m.abstract,
      v = {
        ref: t
      };
    return Object.keys(n).forEach(function (e) {
      Dl.hasOwnProperty(e) || (v[e] = n[e]);
    }), Ml(g[0], v);
  });
Ll.displayName = "FontAwesomeIcon", Ll.propTypes = {
  beat: bl.bool,
  border: bl.bool,
  beatFade: bl.bool,
  bounce: bl.bool,
  className: bl.string,
  fade: bl.bool,
  flash: bl.bool,
  mask: bl.oneOfType([bl.object, bl.array, bl.string]),
  maskId: bl.string,
  fixedWidth: bl.bool,
  inverse: bl.bool,
  flip: bl.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: bl.oneOfType([bl.object, bl.array, bl.string]),
  listItem: bl.bool,
  pull: bl.oneOf(["right", "left"]),
  pulse: bl.bool,
  rotation: bl.oneOf([0, 90, 180, 270]),
  rotateBy: bl.bool,
  shake: bl.bool,
  size: bl.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: bl.bool,
  spinPulse: bl.bool,
  spinReverse: bl.bool,
  symbol: bl.oneOfType([bl.bool, bl.string]),
  title: bl.string,
  titleId: bl.string,
  transform: bl.oneOfType([bl.string, bl.object]),
  swapOpacity: bl.bool,
  widthAuto: bl.bool
};
var Ml = function e(t, n) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  if ("string" == typeof n) return n;
  var a = (n.children || []).map(function (n) {
      return e(t, n);
    }),
    o = Object.keys(n.attributes || {}).reduce(function (e, t) {
      var r = n.attributes[t];
      switch (t) {
        case "class":
          e.attrs.className = r, delete n.attributes.class;
          break;
        case "style":
          e.attrs.style = r.split(";").map(function (e) {
            return e.trim();
          }).filter(function (e) {
            return e;
          }).reduce(function (e, t) {
            var n,
              r = t.indexOf(":"),
              a = Tl(t.slice(0, r)),
              o = t.slice(r + 1).trim();
            return a.startsWith("webkit") ? e[(n = a, n.charAt(0).toUpperCase() + n.slice(1))] = o : e[a] = o, e;
          }, {});
          break;
        default:
          0 === t.indexOf("aria-") || 0 === t.indexOf("data-") ? e.attrs[t.toLowerCase()] = r : e.attrs[Tl(t)] = r;
      }
      return e;
    }, {
      attrs: {}
    }),
    i = r.style,
    l = void 0 === i ? {} : i,
    s = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        a = function (e, t) {
          if (null == e) return {};
          var n = {};
          for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
            if (-1 !== t.indexOf(r)) continue;
            n[r] = e[r];
          }
          return n;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++) n = o[r], -1 === t.indexOf(n) && {}.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
      }
      return a;
    }(r, jl);
  return o.attrs.style = kl(kl({}, o.attrs.style), l), t.apply(void 0, [n.tag, kl(kl({}, o.attrs), s)].concat(Sl(a)));
}.bind(null, t.createElement);
const _l = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
  },
  $l = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
  },
  zl = {
    prefix: "fas",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
  },
  Bl = {
    prefix: "fas",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
  },
  Hl = r({
    menuButtonRef: t.createRef()
  }),
  Ul = "list-none bg-foreground-secondary text-center border-1 border-solid border-background-quaternary focus:outline-transparent origin-top-right absolute w-full min-w-max py-1 px-0 z-10",
  Wl = Ul + " transform -translate-y-full top-0",
  ql = "cursor-pointer border-3 border-solid w-full flex items-center justify-center text-center touch-manipulation bg-background-quaternary text-foreground-secondary px-3 py-1.5 mt-[0.5px] relative hover:bg-foreground-secondary hover:text-background-secondary border-foreground-secondary ",
  Vl = t.forwardRef((_ref32, r) => {
    let {
      children: e,
      className: n
    } = _ref32;
    const {
        dropup: o,
        menuButtonRef: i
      } = a(Hl),
      l = [n, o ? Wl : Ul].join(" ");
    return t.createElement(wn.Items, {
      className: l,
      ref: r,
      onClick: () => {
        var e;
        null === (e = i.current) || void 0 === e || e.focus();
      }
    }, e);
  }),
  Yl = _ref33 => {
    let {
      children: e,
      id: n,
      dropup: r
    } = _ref33;
    const a = {
      dropup: r,
      menuButtonRef: l(null)
    };
    return t.createElement(Hl.Provider, {
      value: a
    }, t.createElement(wn, {
      className: "relative w-full",
      as: "div",
      id: n
    }, e));
  };
Yl.Menu = Vl, Yl.Toggle = e => {
  var {
      children: n,
      className: r
    } = e,
    o = b(e, ["children", "className"]);
  const {
      dropup: i,
      menuButtonRef: l
    } = a(Hl),
    s = [r, ql].join(" ");
  return t.createElement(wn.Button, Object.assign({
    ref: l,
    className: s
  }, o), n, t.createElement(Ll, {
    icon: i ? _l : $l,
    className: "mx-2 h-3",
    "aria-hidden": "true"
  }));
}, Vl.displayName = "MenuItems", Yl.displayName = "Dropdown";
let Gl;
const Kl = "outline-0 block w-full py-1.5 px-2.5 text-md text-foreground-primary bg-background-primary bg-none rounded-none border-1 border-solid border-background-quaternary shadow-none transition ease-in-out duration-150 focus:border-foreground-tertiary",
  Xl = e => {
    var {
        componentClass: n
      } = e,
      r = b(e, ["componentClass"]);
    const {
        controlId: o
      } = a($),
      {
        id: i,
        className: l
      } = r,
      s = n || "input";
    "textarea" !== s && (Gl = " h-8");
    const c = [l, Kl, Gl].join(" ");
    return t.createElement(s, Object.assign({
      id: i || o,
      className: c
    }, r));
  };
Xl.Feedback = e => {
  var {
      children: n,
      className: r
    } = e,
    a = b(e, ["children", "className"]);
  const o = [r, "absolute top-[30px] right-0 z-2 block w-8 h-8 leading-8 text-center pointer-events-none text-green-700"].join(" ");
  return t.createElement("span", Object.assign({
    className: o
  }, a), n);
}, Xl.Static = e => {
  var {
      className: n,
      children: r
    } = e,
    a = b(e, ["className", "children"]);
  const o = ["py-1.5 mb-0 min-h-43-px text-foreground-secondary", n].join(" ");
  return t.createElement("p", Object.assign({
    className: o
  }, a), r);
};
const Jl = "block mt-1 mb-2",
  Ql = {
    success: "text-background-info",
    warning: "text-background-warning",
    error: "text-background-danger"
  },
  Zl = t.forwardRef((e, n) => {
    var {
        className: r,
        children: o
      } = e,
      i = b(e, ["className", "children"]);
    const {
        validationState: l
      } = a($),
      s = [r, Jl, l ? Ql[l] : "text-foreground-quaternary"].join(" ");
    return t.createElement("span", Object.assign({
      ref: n,
      "data-testid": "help-block",
      className: s
    }, i), o);
  });
Zl.displayName = "HelpBlock";
const es = t.forwardRef((e, n) => {
  var {
      alt: r,
      src: a,
      responsive: o,
      className: i
    } = e,
    l = b(e, ["alt", "src", "responsive", "className"]);
  const s = o ? i : [i, "max-w-none"].join(" ");
  return t.createElement("img", Object.assign({
    ref: n,
    alt: r,
    src: a,
    className: s
  }, l));
});
es.displayName = "Image";
const ts = "block text-center no-underline border-none px-4 py-1.5 focus:bg-background-secondary focus:text-foreground-secondary hover:text-foreground-secondary hover:bg-background-secondary w-full",
  ns = e => {
    var {
        children: n,
        className: r
      } = e,
      a = b(e, ["children", "className"]);
    return t.createElement(wn.Item, null, _ref34 => {
      let {
        active: e
      } = _ref34;
      const o = [ts, r, e ? "text-foreground-secondary bg-background-secondary outline outline-3 outline-blue-500 outline-offset-[-3px]" : "text-background-secondary bg-foreground-secondary"].join(" ");
      return t.createElement(S, Object.assign({
        className: o
      }, a), n);
    });
  },
  rs = r({
    onClose: () => {},
    variant: "default"
  }),
  as = _ref35 => {
    let {
      children: e,
      open: n,
      onClose: r,
      onKeyDown: a,
      size: o = "medium",
      variant: i = "default"
    } = _ref35;
    let l = "flex flex-col border-solid border-1 border-foreground-secondary bg-background-secondary";
    return "medium" === o ? l = l.concat(" ", "w-[600px]") : "large" === o ? l = l.concat(" ", "w-[900px]") : "xLarge" === o && (l = l.concat(" ", "w-[95vw] md:w-[90vw]")), "default" === i ? l = l.concat(" ", "text-foreground-secondary") : "danger" === i && (l = l.concat(" ", "text-background-danger")), t.createElement(rs.Provider, {
      value: {
        onClose: r,
        variant: i
      }
    }, t.createElement(er.Root, {
      show: n,
      as: u
    }, t.createElement(en, {
      onClose: r,
      className: "relative z-1050 w-screen h-screen",
      onKeyDown: a
    }, t.createElement("div", {
      "aria-hidden": !0,
      className: "fixed inset-0 bg-gray-900 opacity-50"
    }), t.createElement("div", {
      className: "fixed inset-0 flex items-start justify-center p-[10px] md:pt-[30px] md:pb-[30px] overflow-scroll"
    }, t.createElement(er.Child, {
      as: u,
      enter: "transition-all duration-300 ease-out",
      enterFrom: "opacity-0 -translate-y-1/4",
      enterTo: "opacity-100 translate-y-0",
      leave: "transition-all duration-300 ease-out",
      leaveFrom: "opacity-100 translate-y-0",
      leaveTo: "opacity-0 -translate-y-1/4"
    }, t.createElement(en.Panel, {
      className: l
    }, e))))));
  };
as.Header = _ref36 => {
  let {
    children: e,
    showCloseButton: n = !0,
    closeButtonClassNames: r,
    borderless: o
  } = _ref36;
  const {
    onClose: i,
    variant: l
  } = a(rs);
  let s = "p-[15px]";
  return "danger" === l && (s = s.concat(" ", "bg-foreground-danger")), o || (s = s.concat(" ", "border-b-1 border-solid border-foreground-secondary")), n ? (s = s.concat(" ", "flex items-center justify-between"), t.createElement("div", {
    className: s
  }, t.createElement(en.Title, {
    className: "m-0 pl-[24px] flex-1 text-md text-center"
  }, e), t.createElement(P, {
    onClick: i,
    className: r
  }))) : t.createElement("div", {
    className: s
  }, t.createElement(en.Title, {
    className: "m-0 text-md text-center"
  }, e));
}, as.Body = _ref37 => {
  let {
    children: e,
    alignment: n = "center",
    borderless: r,
    className: a
  } = _ref37;
  const o = r ? "" : "border-b-1 border-solid border-foreground-secondary";
  return t.createElement("div", {
    className: "p-[15px] text-".concat(n, " ").concat(o, " ").concat(a)
  }, e);
}, as.Footer = _ref38 => {
  let {
    children: e,
    alignment: n = "center"
  } = _ref38;
  return "end" === n ? t.createElement("div", {
    className: "p-[15px] flex justify-end"
  }, e) : t.createElement("div", {
    className: "p-[15px] flex flex-col justify-center"
  }, e);
};
const os = r({}),
  is = {
    primary: "border-foreground-primary",
    danger: "border-foreground-danger",
    info: "border-foreground-info"
  },
  ls = {
    primary: "outline-[1px] outline outline-foreground-primary text-foreground-primary",
    danger: "bg-foreground-danger text-background-danger",
    info: "bg-foreground-info text-background-info"
  },
  ss = e => {
    var {
        children: n,
        className: r,
        variant: a
      } = e,
      o = b(e, ["children", "className", "variant"]);
    const i = ["border-1 border-solid shadow-sm mb-6", a ? is[a] : "border-background-tertiary", r].join(" ");
    return t.createElement(os.Provider, {
      value: {
        variant: a
      }
    }, t.createElement("div", Object.assign({
      className: i
    }, o), n));
  };
ss.Body = e => {
  var {
      children: n,
      className: r
    } = e,
    a = b(e, ["children", "className"]);
  const o = [r, "p-3.5"].join(" ");
  return t.createElement("div", Object.assign({
    className: o
  }, a), n);
}, ss.Heading = e => {
  var {
      children: n,
      className: r
    } = e,
    o = b(e, ["children", "className"]);
  const {
      variant: i
    } = a(os),
    l = [r, i ? ls[i] : "outline outline-[1px] outline-background-tertiary", "px-3.5 py-2.5"].join(" ");
  return t.createElement("div", Object.assign({
    className: l
  }, o), n);
}, ss.Title = e => {
  var {
      children: n
    } = e,
    r = b(e, ["children"]);
  return t.createElement("h3", Object.assign({
    className: "text-inherit mb-0 text-xl"
  }, r), n);
};
var cs = {
  exports: {}
};
!function (e) {
  var t = function (e) {
    var t = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i,
      n = 0,
      r = {},
      a = {
        manual: e.Prism && e.Prism.manual,
        disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
        util: {
          encode: function e(t) {
            return t instanceof o ? new o(t.type, e(t.content), t.alias) : Array.isArray(t) ? t.map(e) : t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          },
          type: function (e) {
            return Object.prototype.toString.call(e).slice(8, -1);
          },
          objId: function (e) {
            return e.__id || Object.defineProperty(e, "__id", {
              value: ++n
            }), e.__id;
          },
          clone: function e(t, n) {
            var r, o;
            switch (n = n || {}, a.util.type(t)) {
              case "Object":
                if (o = a.util.objId(t), n[o]) return n[o];
                for (var i in r = {}, n[o] = r, t) t.hasOwnProperty(i) && (r[i] = e(t[i], n));
                return r;
              case "Array":
                return o = a.util.objId(t), n[o] ? n[o] : (r = [], n[o] = r, t.forEach(function (t, a) {
                  r[a] = e(t, n);
                }), r);
              default:
                return t;
            }
          },
          getLanguage: function (e) {
            for (; e;) {
              var n = t.exec(e.className);
              if (n) return n[1].toLowerCase();
              e = e.parentElement;
            }
            return "none";
          },
          setLanguage: function (e, n) {
            e.className = e.className.replace(RegExp(t, "gi"), ""), e.classList.add("language-" + n);
          },
          currentScript: function () {
            if ("undefined" == typeof document) return null;
            if (document.currentScript && "SCRIPT" === document.currentScript.tagName) return document.currentScript;
            try {
              throw new Error();
            } catch (r) {
              var e = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(r.stack) || [])[1];
              if (e) {
                var t = document.getElementsByTagName("script");
                for (var n in t) if (t[n].src == e) return t[n];
              }
              return null;
            }
          },
          isActive: function (e, t, n) {
            for (var r = "no-" + t; e;) {
              var a = e.classList;
              if (a.contains(t)) return !0;
              if (a.contains(r)) return !1;
              e = e.parentElement;
            }
            return !!n;
          }
        },
        languages: {
          plain: r,
          plaintext: r,
          text: r,
          txt: r,
          extend: function (e, t) {
            var n = a.util.clone(a.languages[e]);
            for (var r in t) n[r] = t[r];
            return n;
          },
          insertBefore: function (e, t, n, r) {
            var o = (r = r || a.languages)[e],
              i = {};
            for (var l in o) if (o.hasOwnProperty(l)) {
              if (l == t) for (var s in n) n.hasOwnProperty(s) && (i[s] = n[s]);
              n.hasOwnProperty(l) || (i[l] = o[l]);
            }
            var c = r[e];
            return r[e] = i, a.languages.DFS(a.languages, function (t, n) {
              n === c && t != e && (this[t] = i);
            }), i;
          },
          DFS: function e(t, n, r, o) {
            o = o || {};
            var i = a.util.objId;
            for (var l in t) if (t.hasOwnProperty(l)) {
              n.call(t, l, t[l], r || l);
              var s = t[l],
                c = a.util.type(s);
              "Object" !== c || o[i(s)] ? "Array" !== c || o[i(s)] || (o[i(s)] = !0, e(s, n, l, o)) : (o[i(s)] = !0, e(s, n, null, o));
            }
          }
        },
        plugins: {},
        highlightAll: function (e, t) {
          a.highlightAllUnder(document, e, t);
        },
        highlightAllUnder: function (e, t, n) {
          var r = {
            callback: n,
            container: e,
            selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
          };
          a.hooks.run("before-highlightall", r), r.elements = Array.prototype.slice.apply(r.container.querySelectorAll(r.selector)), a.hooks.run("before-all-elements-highlight", r);
          for (var o, i = 0; o = r.elements[i++];) a.highlightElement(o, !0 === t, r.callback);
        },
        highlightElement: function (t, n, r) {
          var o = a.util.getLanguage(t),
            i = a.languages[o];
          a.util.setLanguage(t, o);
          var l = t.parentElement;
          l && "pre" === l.nodeName.toLowerCase() && a.util.setLanguage(l, o);
          var s = {
            element: t,
            language: o,
            grammar: i,
            code: t.textContent
          };
          function c(e) {
            s.highlightedCode = e, a.hooks.run("before-insert", s), s.element.innerHTML = s.highlightedCode, a.hooks.run("after-highlight", s), a.hooks.run("complete", s), r && r.call(s.element);
          }
          if (a.hooks.run("before-sanity-check", s), (l = s.element.parentElement) && "pre" === l.nodeName.toLowerCase() && !l.hasAttribute("tabindex") && l.setAttribute("tabindex", "0"), !s.code) return a.hooks.run("complete", s), void (r && r.call(s.element));
          if (a.hooks.run("before-highlight", s), s.grammar) {
            if (n && e.Worker) {
              var u = new Worker(a.filename);
              u.onmessage = function (e) {
                c(e.data);
              }, u.postMessage(JSON.stringify({
                language: s.language,
                code: s.code,
                immediateClose: !0
              }));
            } else c(a.highlight(s.code, s.grammar, s.language));
          } else c(a.util.encode(s.code));
        },
        highlight: function (e, t, n) {
          var r = {
            code: e,
            grammar: t,
            language: n
          };
          if (a.hooks.run("before-tokenize", r), !r.grammar) throw new Error('The language "' + r.language + '" has no grammar.');
          return r.tokens = a.tokenize(r.code, r.grammar), a.hooks.run("after-tokenize", r), o.stringify(a.util.encode(r.tokens), r.language);
        },
        tokenize: function (e, t) {
          var n = t.rest;
          if (n) {
            for (var r in n) t[r] = n[r];
            delete t.rest;
          }
          var a = new s();
          return c(a, a.head, e), l(e, a, t, a.head, 0), function (e) {
            var t = [],
              n = e.head.next;
            for (; n !== e.tail;) t.push(n.value), n = n.next;
            return t;
          }(a);
        },
        hooks: {
          all: {},
          add: function (e, t) {
            var n = a.hooks.all;
            n[e] = n[e] || [], n[e].push(t);
          },
          run: function (e, t) {
            var n = a.hooks.all[e];
            if (n && n.length) for (var r, o = 0; r = n[o++];) r(t);
          }
        },
        Token: o
      };
    function o(e, t, n, r) {
      this.type = e, this.content = t, this.alias = n, this.length = 0 | (r || "").length;
    }
    function i(e, t, n, r) {
      e.lastIndex = t;
      var a = e.exec(n);
      if (a && r && a[1]) {
        var o = a[1].length;
        a.index += o, a[0] = a[0].slice(o);
      }
      return a;
    }
    function l(e, t, n, r, s, d) {
      for (var f in n) if (n.hasOwnProperty(f) && n[f]) {
        var p = n[f];
        p = Array.isArray(p) ? p : [p];
        for (var m = 0; m < p.length; ++m) {
          if (d && d.cause == f + "," + m) return;
          var g = p[m],
            v = g.inside,
            h = !!g.lookbehind,
            b = !!g.greedy,
            y = g.alias;
          if (b && !g.pattern.global) {
            var w = g.pattern.toString().match(/[imsuy]*$/)[0];
            g.pattern = RegExp(g.pattern.source, w + "g");
          }
          for (var x = g.pattern || g, k = r.next, E = s; k !== t.tail && !(d && E >= d.reach); E += k.value.length, k = k.next) {
            var S = k.value;
            if (t.length > e.length) return;
            if (!(S instanceof o)) {
              var O,
                N = 1;
              if (b) {
                if (!(O = i(x, E, e, h)) || O.index >= e.length) break;
                var A = O.index,
                  P = O.index + O[0].length,
                  F = E;
                for (F += k.value.length; A >= F;) F += (k = k.next).value.length;
                if (E = F -= k.value.length, k.value instanceof o) continue;
                for (var T = k; T !== t.tail && (F < P || "string" == typeof T.value); T = T.next) N++, F += T.value.length;
                N--, S = e.slice(E, F), O.index -= E;
              } else if (!(O = i(x, 0, S, h))) continue;
              A = O.index;
              var j = O[0],
                C = S.slice(0, A),
                R = S.slice(A + j.length),
                I = E + S.length;
              d && I > d.reach && (d.reach = I);
              var D = k.prev;
              if (C && (D = c(t, D, C), E += C.length), u(t, D, N), k = c(t, D, new o(f, v ? a.tokenize(j, v) : j, y, j)), R && c(t, k, R), N > 1) {
                var L = {
                  cause: f + "," + m,
                  reach: I
                };
                l(e, t, n, k.prev, E, L), d && L.reach > d.reach && (d.reach = L.reach);
              }
            }
          }
        }
      }
    }
    function s() {
      var e = {
          value: null,
          prev: null,
          next: null
        },
        t = {
          value: null,
          prev: e,
          next: null
        };
      e.next = t, this.head = e, this.tail = t, this.length = 0;
    }
    function c(e, t, n) {
      var r = t.next,
        a = {
          value: n,
          prev: t,
          next: r
        };
      return t.next = a, r.prev = a, e.length++, a;
    }
    function u(e, t, n) {
      for (var r = t.next, a = 0; a < n && r !== e.tail; a++) r = r.next;
      t.next = r, r.prev = t, e.length -= a;
    }
    if (e.Prism = a, o.stringify = function e(t, n) {
      if ("string" == typeof t) return t;
      if (Array.isArray(t)) {
        var r = "";
        return t.forEach(function (t) {
          r += e(t, n);
        }), r;
      }
      var o = {
          type: t.type,
          content: e(t.content, n),
          tag: "span",
          classes: ["token", t.type],
          attributes: {},
          language: n
        },
        i = t.alias;
      i && (Array.isArray(i) ? Array.prototype.push.apply(o.classes, i) : o.classes.push(i)), a.hooks.run("wrap", o);
      var l = "";
      for (var s in o.attributes) l += " " + s + '="' + (o.attributes[s] || "").replace(/"/g, "&quot;") + '"';
      return "<" + o.tag + ' class="' + o.classes.join(" ") + '"' + l + ">" + o.content + "</" + o.tag + ">";
    }, !e.document) return e.addEventListener ? (a.disableWorkerMessageHandler || e.addEventListener("message", function (t) {
      var n = JSON.parse(t.data),
        r = n.language,
        o = n.code,
        i = n.immediateClose;
      e.postMessage(a.highlight(o, a.languages[r], r)), i && e.close();
    }, !1), a) : a;
    var d = a.util.currentScript();
    function f() {
      a.manual || a.highlightAll();
    }
    if (d && (a.filename = d.src, d.hasAttribute("data-manual") && (a.manual = !0)), !a.manual) {
      var p = document.readyState;
      "loading" === p || "interactive" === p && d && d.defer ? document.addEventListener("DOMContentLoaded", f) : window.requestAnimationFrame ? window.requestAnimationFrame(f) : window.setTimeout(f, 16);
    }
    return a;
  }("undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {});
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  e.exports && (e.exports = t), void 0 !== Ei && (Ei.Prism = t), t.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [{
              pattern: /^=/,
              alias: "attr-equals"
            }, {
              pattern: /^(\s*)["']|["']$/,
              lookbehind: !0
            }]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [{
      pattern: /&[\da-z]{1,8};/i,
      alias: "named-entity"
    }, /&#x?[\da-f]{1,8};/i]
  }, t.languages.markup.tag.inside["attr-value"].inside.entity = t.languages.markup.entity, t.languages.markup.doctype.inside["internal-subset"].inside = t.languages.markup, t.hooks.add("wrap", function (e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(t.languages.markup.tag, "addInlined", {
    value: function (e, n) {
      var r = {};
      r["language-" + n] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: t.languages[n]
      }, r.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var a = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: r
        }
      };
      a["language-" + n] = {
        pattern: /[\s\S]+/,
        inside: t.languages[n]
      };
      var o = {};
      o[e] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () {
          return e;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: a
      }, t.languages.insertBefore("markup", "cdata", o);
    }
  }), Object.defineProperty(t.languages.markup.tag, "addAttribute", {
    value: function (e, n) {
      t.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [n, "language-" + n],
                inside: t.languages[n]
              },
              punctuation: [{
                pattern: /^=/,
                alias: "attr-equals"
              }, /"|'/]
            }
          }
        }
      });
    }
  }), t.languages.html = t.languages.markup, t.languages.mathml = t.languages.markup, t.languages.svg = t.languages.markup, t.languages.xml = t.languages.extend("markup", {}), t.languages.ssml = t.languages.xml, t.languages.atom = t.languages.xml, t.languages.rss = t.languages.xml, function (e) {
    var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    e.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + t.source + ")*?" + /(?:;|(?=\s*\{))/.source),
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
        }
      },
      url: {
        pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + t.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + t.source + ")*(?=\\s*\\{)"),
        lookbehind: !0
      },
      string: {
        pattern: t,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css;
    var n = e.languages.markup;
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
  }(t), t.languages.clike = {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      greedy: !0
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  }, t.languages.javascript = t.languages.extend("clike", {
    "class-name": [t.languages.clike["class-name"], {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
      lookbehind: !0
    }],
    keyword: [{
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: !0
    }, {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: !0
    }],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), t.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, t.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: t.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [{
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: !0,
      inside: t.languages.javascript
    }, {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: !0,
      inside: t.languages.javascript
    }, {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: !0,
      inside: t.languages.javascript
    }, {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: !0,
      inside: t.languages.javascript
    }],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), t.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: t.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), t.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), t.languages.markup && (t.languages.markup.tag.addInlined("script", "javascript"), t.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), t.languages.js = t.languages.javascript, function () {
    if (void 0 !== t && "undefined" != typeof document) {
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
      var e = {
          js: "javascript",
          py: "python",
          rb: "ruby",
          ps1: "powershell",
          psm1: "powershell",
          sh: "bash",
          bat: "batch",
          h: "c",
          tex: "latex"
        },
        n = "data-src-status",
        r = "loading",
        a = "loaded",
        o = "pre[data-src]:not([" + n + '="' + a + '"]):not([' + n + '="' + r + '"])';
      t.hooks.add("before-highlightall", function (e) {
        e.selector += ", " + o;
      }), t.hooks.add("before-sanity-check", function (i) {
        var l = i.element;
        if (l.matches(o)) {
          i.code = "", l.setAttribute(n, r);
          var s = l.appendChild(document.createElement("CODE"));
          s.textContent = "Loading…";
          var c = l.getAttribute("data-src"),
            u = i.language;
          if ("none" === u) {
            var d = (/\.(\w+)$/.exec(c) || [, "none"])[1];
            u = e[d] || d;
          }
          t.util.setLanguage(s, u), t.util.setLanguage(l, u);
          var f = t.plugins.autoloader;
          f && f.loadLanguages(u), function (e, t, n) {
            var r = new XMLHttpRequest();
            r.open("GET", e, !0), r.onreadystatechange = function () {
              4 == r.readyState && (r.status < 400 && r.responseText ? t(r.responseText) : r.status >= 400 ? n("✖ Error " + r.status + " while fetching file: " + r.statusText) : n("✖ Error: File does not exist or is empty"));
            }, r.send(null);
          }(c, function (e) {
            l.setAttribute(n, a);
            var r = function (e) {
              var t = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(e || "");
              if (t) {
                var n = Number(t[1]),
                  r = t[2],
                  a = t[3];
                return r ? a ? [n, Number(a)] : [n, void 0] : [n, n];
              }
            }(l.getAttribute("data-range"));
            if (r) {
              var o = e.split(/\r\n?|\n/g),
                i = r[0],
                c = null == r[1] ? o.length : r[1];
              i < 0 && (i += o.length), i = Math.max(0, Math.min(i - 1, o.length)), c < 0 && (c += o.length), c = Math.max(0, Math.min(c, o.length)), e = o.slice(i, c).join("\n"), l.hasAttribute("data-start") || l.setAttribute("data-start", String(i + 1));
            }
            s.textContent = e, t.highlightElement(s);
          }, function (e) {
            l.setAttribute(n, "failed"), s.textContent = e;
          });
        }
      }), t.plugins.fileHighlight = {
        highlight: function (e) {
          for (var n, r = (e || document).querySelectorAll(o), a = 0; n = r[a++];) t.highlightElement(n);
        }
      };
      var i = !1;
      t.fileHighlight = function () {
        i || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), i = !0), t.plugins.fileHighlight.highlight.apply(this, arguments);
      };
    }
  }();
}(cs);
var us = cs.exports;
function ds(e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}
ds('/** \n  * This file houses styles that are shared between Prism themes.\n\t* Rules that are specific to a theme should be kept in the corresponding file (prism-light.css or prism-dark.css).\n  */\n\npre[class*="language-"] {\n\tpadding: 1em;\n\tmargin: 0.5em 0;\n\toverflow: auto;\n}\n\n[class*="language-"].line-numbers {\n\tposition: relative;\n\tpadding-left: 3.8em;\n\tcounter-reset: linenumber;\n}\n\n/* remove horizontal scrollbars for text-only code */\n\ncode[class="language-markup"] {\n\twhite-space: normal;\n}\n\npre[class*="language-"],\ncode[class*="language-"] {\n\ttext-shadow: none !important; /* Override prism\'s text-shadow style */\n}\n');
ds(':root {\n\t--gray00: #ffffff;\n\t--gray05: #f5f6f7;\n\t--gray10: #dfdfe2;\n\t--gray15: #d0d0d5;\n\t--gray45: #858591;\n\t--gray75: #3b3b4f;\n\t--gray80: #2a2a40;\n\t--gray85: #1b1b32;\n\t--gray90: #0a0a23;\n\n\t--purple10: #dbb8ff;\n\t--purple50: #9400d3;\n\t--purple90: #5a01a7;\n\n\t--yellow05: #fcf8e3;\n\t--yellow10: #faebcc;\n\t--yellow40: #ffc300;\n\t--yellow45: #ffbf00;\n\t--yellow50: #f1be32;\n\t--yellow70: #8a6d3b;\n\t--yellow80: #66512c;\n\t--yellow90: #4d3800;\n\n\t--blue05: #d9edf7;\n\t--blue10: #bce8f1;\n\t--blue30: #99c9ff;\n\t--blue50: #198eee;\n\t--blue70: #31708f;\n\t--blue90: #002ead;\n\n\t/* These are blue30 and blue90 with an alpha value.\n\t\t The colors are in RGBA format instead of #RRGGBBAA\n\t\t in order to be compatible with older browsers. */\n\t--blue30-translucent: rgba(153, 201, 255, 0.3);\n\t--blue90-translucent: rgba(0, 46, 173, 0.3);\n\n\t--green05: #dff0d8;\n\t--green10: #d6e9c6;\n\t--green40: #acd157;\n\t--green70: #3c763d;\n\t--green80: #19562a;\n\t--green90: #00471b;\n\n\t--red05: #f2dede;\n\t--red10: #ebccd1;\n\t--red15: #ffadad;\n\t--red30: #f8577c;\n\t--red70: #a94442;\n\t--red80: #f82153;\n\t--red90: #850000;\n\t--red100: #5a3535;\n\n\t--orange30: #eda971;\n}\n\n/* Export the variables in order to use them on the Color System Storybook page */\n\n:export {\n\t--gray00: var(--gray00);\n\t--gray05: var(--gray05);\n\t--gray10: var(--gray10);\n\t--gray15: var(--gray15);\n\t--gray45: var(--gray45);\n\t--gray75: var(--gray75);\n\t--gray80: var(--gray80);\n\t--gray85: var(--gray85);\n\t--gray90: var(--gray90);\n\n\t--purple10: var(--purple10);\n\t--purple50: var(--purple50);\n\t--purple90: var(--purple90);\n\n\t--yellow05: var(--yellow05);\n\t--yellow10: var(--yellow10);\n\t--yellow40: var(--yellow40);\n\t--yellow45: var(--yellow45);\n\t--yellow50: var(--yellow50);\n\t--yellow70: var(--yellow70);\n\t--yellow80: var(--yellow80);\n\t--yellow90: var(--yellow90);\n\n\t--blue05: var(--blue05);\n\t--blue10: var(--blue10);\n\t--blue30: var(--blue30);\n\t--blue50: var(--blue50);\n\t--blue70: var(--blue70);\n\t--blue90: var(--blue90);\n\n\t--green05: var(--green05);\n\t--green10: var(--green10);\n\t--green40: var(--green40);\n\t--green70: var(--green70);\n\t--green80: var(--green80);\n\t--green90: var(--green90);\n\n\t--red05: var(--red05);\n\t--red10: var(--red10);\n\t--red15: var(--red15);\n\t--red30: var(--red30);\n\t--red70: var(--red70);\n\t--red80: var(--red80);\n\t--red90: var(--red90);\n\t--red100: var(--red100);\n\n\t--orange30: var(--orange30);\n}\n\n.light-palette {\n\t--foreground-primary: var(--gray90);\n\t--foreground-secondary: var(--gray85);\n\t--foreground-tertiary: var(--gray80);\n\t--foreground-quaternary: var(--gray75);\n\t--foreground-danger: var(--red15);\n\t--foreground-danger-disabled: var(--red100);\n\t--foreground-success: var(--green40);\n\t--foreground-info: var(--blue30);\n\t--foreground-warning: var(--yellow45);\n\n\t--background-primary: var(--gray00);\n\t--background-secondary: var(--gray05);\n\t--background-tertiary: var(--gray10);\n\t--background-quaternary: var(--gray15);\n\t--background-danger: var(--red90);\n\t--background-danger-disabled: var(--red05);\n\t--background-success: var(--green90);\n\t--background-info: var(--blue90);\n\t--background-selection: var(--blue90-translucent);\n\n\t--focus-outline-color: var(--blue50);\n}\n\n.dark-palette {\n\t--foreground-primary: var(--gray00);\n\t--foreground-secondary: var(--gray05);\n\t--foreground-tertiary: var(--gray10);\n\t--foreground-quaternary: var(--gray15);\n\t--foreground-danger: var(--red90);\n\t--foreground-danger-disabled: var(--red05);\n\t--foreground-success: var(--green90);\n\t--foreground-info: var(--blue90);\n\t--foreground-warning: var(--yellow40);\n\n\t--background-primary: var(--gray90);\n\t--background-secondary: var(--gray85);\n\t--background-tertiary: var(--gray80);\n\t--background-quaternary: var(--gray75);\n\t--background-danger: var(--red15);\n\t--background-danger-disabled: var(--red100);\n\t--background-success: var(--green40);\n\t--background-info: var(--blue30);\n\t--background-selection: var(--blue30-translucent);\n\n\t--focus-outline-color: var(--blue50);\n}\n\n.light-palette pre[class*="language-"]::-moz-selection, .light-palette pre[class*="language-"] ::-moz-selection, .light-palette code[class*="language-"]::-moz-selection, .light-palette code[class*="language-"] ::-moz-selection {\n\tbackground: var(--background-selection);\n}\n\n.light-palette pre[class*="language-"]::selection,\n.light-palette pre[class*="language-"] ::selection,\n.light-palette code[class*="language-"]::selection,\n.light-palette code[class*="language-"] ::selection {\n\tbackground: var(--background-selection);\n}\n\n/* a11y color adjustments */\n\n.light-palette .token.comment,\n.light-palette .token.prolog,\n.light-palette .token.doctype,\n.light-palette .token.cdata {\n\tcolor: #62707f;\n}\n\n.light-palette .token.punctuation {\n\tcolor: #38425c;\n}\n\n.light-palette .token.property,\n.light-palette .token.tag,\n.light-palette .token.constant,\n.light-palette .token.symbol,\n.light-palette .token.deleted {\n\tcolor: #e00000;\n}\n\n.light-palette .token.number {\n\tcolor: #9932cc;\n}\n\n.light-palette .token.boolean {\n\tcolor: #1f3a93;\n}\n\n.light-palette .token.selector,\n.light-palette .token.attr-name,\n.light-palette .token.string,\n.light-palette .token.char,\n.light-palette .token.builtin,\n.light-palette .token.inserted {\n\tcolor: #008040;\n}\n\n.light-palette code .token.operator {\n\tbackground: none;\n}\n\n.light-palette .token.operator,\n.light-palette .token.entity,\n.light-palette .token.url,\n.light-palette .language-css .token.string,\n.light-palette .style .token.string {\n\tcolor: #38425c;\n}\n\n.light-palette .token.atrule,\n.light-palette .token.attr-value,\n.light-palette .token.keyword {\n\tcolor: #2574a9;\n}\n\n.light-palette .token.function,\n.light-palette .token.class-name {\n\tcolor: #992900;\n}\n\n.light-palette .token.regex,\n.light-palette .token.important,\n.light-palette .token.variable {\n\tcolor: #856514;\n}\n\n.light-palette .line-numbers-rows > span::before {\n\tcolor: #62707f;\n}\n');
ds(':root {\n\t--gray00: #ffffff;\n\t--gray05: #f5f6f7;\n\t--gray10: #dfdfe2;\n\t--gray15: #d0d0d5;\n\t--gray45: #858591;\n\t--gray75: #3b3b4f;\n\t--gray80: #2a2a40;\n\t--gray85: #1b1b32;\n\t--gray90: #0a0a23;\n\n\t--purple10: #dbb8ff;\n\t--purple50: #9400d3;\n\t--purple90: #5a01a7;\n\n\t--yellow05: #fcf8e3;\n\t--yellow10: #faebcc;\n\t--yellow40: #ffc300;\n\t--yellow45: #ffbf00;\n\t--yellow50: #f1be32;\n\t--yellow70: #8a6d3b;\n\t--yellow80: #66512c;\n\t--yellow90: #4d3800;\n\n\t--blue05: #d9edf7;\n\t--blue10: #bce8f1;\n\t--blue30: #99c9ff;\n\t--blue50: #198eee;\n\t--blue70: #31708f;\n\t--blue90: #002ead;\n\n\t/* These are blue30 and blue90 with an alpha value.\n\t\t The colors are in RGBA format instead of #RRGGBBAA\n\t\t in order to be compatible with older browsers. */\n\t--blue30-translucent: rgba(153, 201, 255, 0.3);\n\t--blue90-translucent: rgba(0, 46, 173, 0.3);\n\n\t--green05: #dff0d8;\n\t--green10: #d6e9c6;\n\t--green40: #acd157;\n\t--green70: #3c763d;\n\t--green80: #19562a;\n\t--green90: #00471b;\n\n\t--red05: #f2dede;\n\t--red10: #ebccd1;\n\t--red15: #ffadad;\n\t--red30: #f8577c;\n\t--red70: #a94442;\n\t--red80: #f82153;\n\t--red90: #850000;\n\t--red100: #5a3535;\n\n\t--orange30: #eda971;\n}\n\n/* Export the variables in order to use them on the Color System Storybook page */\n\n:export {\n\t--gray00: var(--gray00);\n\t--gray05: var(--gray05);\n\t--gray10: var(--gray10);\n\t--gray15: var(--gray15);\n\t--gray45: var(--gray45);\n\t--gray75: var(--gray75);\n\t--gray80: var(--gray80);\n\t--gray85: var(--gray85);\n\t--gray90: var(--gray90);\n\n\t--purple10: var(--purple10);\n\t--purple50: var(--purple50);\n\t--purple90: var(--purple90);\n\n\t--yellow05: var(--yellow05);\n\t--yellow10: var(--yellow10);\n\t--yellow40: var(--yellow40);\n\t--yellow45: var(--yellow45);\n\t--yellow50: var(--yellow50);\n\t--yellow70: var(--yellow70);\n\t--yellow80: var(--yellow80);\n\t--yellow90: var(--yellow90);\n\n\t--blue05: var(--blue05);\n\t--blue10: var(--blue10);\n\t--blue30: var(--blue30);\n\t--blue50: var(--blue50);\n\t--blue70: var(--blue70);\n\t--blue90: var(--blue90);\n\n\t--green05: var(--green05);\n\t--green10: var(--green10);\n\t--green40: var(--green40);\n\t--green70: var(--green70);\n\t--green80: var(--green80);\n\t--green90: var(--green90);\n\n\t--red05: var(--red05);\n\t--red10: var(--red10);\n\t--red15: var(--red15);\n\t--red30: var(--red30);\n\t--red70: var(--red70);\n\t--red80: var(--red80);\n\t--red90: var(--red90);\n\t--red100: var(--red100);\n\n\t--orange30: var(--orange30);\n}\n\n.light-palette {\n\t--foreground-primary: var(--gray90);\n\t--foreground-secondary: var(--gray85);\n\t--foreground-tertiary: var(--gray80);\n\t--foreground-quaternary: var(--gray75);\n\t--foreground-danger: var(--red15);\n\t--foreground-danger-disabled: var(--red100);\n\t--foreground-success: var(--green40);\n\t--foreground-info: var(--blue30);\n\t--foreground-warning: var(--yellow45);\n\n\t--background-primary: var(--gray00);\n\t--background-secondary: var(--gray05);\n\t--background-tertiary: var(--gray10);\n\t--background-quaternary: var(--gray15);\n\t--background-danger: var(--red90);\n\t--background-danger-disabled: var(--red05);\n\t--background-success: var(--green90);\n\t--background-info: var(--blue90);\n\t--background-selection: var(--blue90-translucent);\n\n\t--focus-outline-color: var(--blue50);\n}\n\n.dark-palette {\n\t--foreground-primary: var(--gray00);\n\t--foreground-secondary: var(--gray05);\n\t--foreground-tertiary: var(--gray10);\n\t--foreground-quaternary: var(--gray15);\n\t--foreground-danger: var(--red90);\n\t--foreground-danger-disabled: var(--red05);\n\t--foreground-success: var(--green90);\n\t--foreground-info: var(--blue90);\n\t--foreground-warning: var(--yellow40);\n\n\t--background-primary: var(--gray90);\n\t--background-secondary: var(--gray85);\n\t--background-tertiary: var(--gray80);\n\t--background-quaternary: var(--gray75);\n\t--background-danger: var(--red15);\n\t--background-danger-disabled: var(--red100);\n\t--background-success: var(--green40);\n\t--background-info: var(--blue30);\n\t--background-selection: var(--blue30-translucent);\n\n\t--focus-outline-color: var(--blue50);\n}\n\n/**\n * Adapted from:\n * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML\n * Based on https://github.com/chriskempson/tomorrow-theme\n * @author Rose Pritchard\n */\n\n.dark-palette code[class*="language-"],\n.dark-palette pre[class*="language-"] {\n\tcolor: var(--foreground-secondary);\n\tfont-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;\n\tfont-size: 1em;\n\ttext-align: left;\n\twhite-space: pre;\n\tword-spacing: normal;\n\tword-break: normal;\n\tword-wrap: normal;\n\tline-height: 1.5;\n\n\t-moz-tab-size: 4;\n\t-o-tab-size: 4;\n\ttab-size: 4;\n\n\t-webkit-hyphens: none;\n\thyphens: none;\n\ttext-shadow: none;\n}\n\n.dark-palette pre[class*="language-"] code[class*="language-"] {\n\tcolor: var(--foreground-quaternary);\n}\n\n/* Without this, the above selector takes precedence and messes up the answer\n padding in night mode */\n\n.dark-palette .video-quiz-option > pre {\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.dark-palette :not(pre) > code[class*="language-"],\n.dark-palette pre[class*="language-"] {\n\tbackground: var(--background-primary);\n}\n\n.dark-palette pre[class*="language-"]::-moz-selection, .dark-palette pre[class*="language-"] ::-moz-selection, .dark-palette code[class*="language-"]::-moz-selection, .dark-palette code[class*="language-"] ::-moz-selection {\n\tbackground: var(--background-selection);\n}\n\n.dark-palette pre[class*="language-"]::selection,\n.dark-palette pre[class*="language-"] ::selection,\n.dark-palette code[class*="language-"]::selection,\n.dark-palette code[class*="language-"] ::selection {\n\tbackground: var(--background-selection);\n}\n\n/* Inline code */\n\n.dark-palette :not(pre) > code[class*="language-"] {\n\tpadding: 0.1em;\n\tborder-radius: 0.3em;\n\twhite-space: normal;\n}\n\n.dark-palette .token.comment,\n.dark-palette .token.block-comment,\n.dark-palette .token.prolog,\n.dark-palette .token.doctype,\n.dark-palette .token.cdata {\n\tcolor: #608b4e;\n}\n\n.dark-palette .token.punctuation {\n\tcolor: #ffff00;\n}\n\n.dark-palette .token.tag,\n.dark-palette .token.attr-name,\n.dark-palette .token.namespace,\n.dark-palette .token.deleted {\n\tcolor: #e2777a;\n}\n\n.dark-palette .token.function-name {\n\tcolor: #d4d4d4;\n}\n\n.dark-palette .token.boolean,\n.dark-palette .token.number,\n.dark-palette .token.function {\n\tcolor: #569cd6;\n}\n\n.dark-palette .token.property,\n.dark-palette .token.class-name,\n.dark-palette .token.constant,\n.dark-palette .token.symbol {\n\tcolor: #f8c555;\n}\n\n.dark-palette .token.selector,\n.dark-palette .token.important,\n.dark-palette .token.atrule,\n.dark-palette .token.keyword,\n.dark-palette .token.builtin {\n\tcolor: #569cd6;\n}\n\n.dark-palette .token.string,\n.dark-palette .token.char,\n.dark-palette .token.attr-value,\n.dark-palette .token.regex,\n.dark-palette .token.variable {\n\tcolor: #7ec699;\n}\n\n/* CSS code block strings have low contrast in night mode. This attempts to increase contrast above 4.5:1 */\n\n.dark-palette .language-css .token.string,\n.dark-palette .style .token.string {\n\tcolor: #ec9126;\n\tbackground: hsl(0 0% 100% / 0.12);\n}\n\n.dark-palette .token.operator,\n.dark-palette .token.entity,\n.dark-palette .token.url {\n\tcolor: #67cdcc;\n\tbackground: none;\n}\n\n.dark-palette .token.important,\n.dark-palette .token.bold {\n\tfont-weight: bold;\n}\n\n.dark-palette .token.italic {\n\tfont-style: italic;\n}\n\n.dark-palette .token.entity {\n\tcursor: help;\n}\n\n.dark-palette .token.inserted {\n\tcolor: green;\n}\n');
const fs = {
    js: "JavaScript",
    javascript: "JavaScript",
    css: "CSS",
    html: "HTML",
    python: "python",
    py: "python",
    xml: "XML",
    jsx: "JSX",
    scss: "SCSS",
    sql: "SQL",
    http: "HTTP",
    json: "JSON",
    pug: "pug",
    ts: "TypeScript",
    typescript: "TypeScript"
  },
  ps = ["[&>p:last-child]:m-0"],
  ms = _ref39 => {
    let {
      className: e,
      text: n,
      useSpan: r,
      noAria: a,
      getCodeBlockAriaLabel: i,
      hasLineNumbers: s,
      isCollapsible: c,
      disclosureLabel: u
    } = _ref39;
    const d = l(null),
      f = r ? "span" : "div",
      p = e ? [...ps, e] : [...ps];
    return s && p.push("line-numbers"), a && (n = n.replace(/<pre( [^>]+)?>/, '<pre$1 data-no-aria="true">')), o(() => {
      d.current && (us.hooks.add("complete", e => (_ref40 => {
        let {
          prismEnv: e,
          getCodeBlockAriaLabel: t
        } = _ref40;
        var n, r;
        const a = null === (n = null == e ? void 0 : e.element) || void 0 === n ? void 0 : n.parentElement;
        if (!a || "PRE" !== a.nodeName || 0 !== a.tabIndex || "true" === a.dataset.noAria) return;
        a.setAttribute("role", "region");
        const o = null === (r = e.element) || void 0 === r ? void 0 : r.className.replace(/language-(.*)/, "$1").toLowerCase(),
          i = t(fs[o] || "");
        a.setAttribute("aria-label", i);
      })({
        prismEnv: e,
        getCodeBlockAriaLabel: i
      })), c && u && us.hooks.add("complete", e => (_ref41 => {
        let {
          prismEnv: e,
          disclosureLabel: t
        } = _ref41;
        var n;
        const r = null === (n = null == e ? void 0 : e.element) || void 0 === n ? void 0 : n.parentElement,
          a = null == r ? void 0 : r.parentElement;
        if (!r || "PRE" !== r.nodeName || 0 !== r.tabIndex || !a || "SECTION" !== a.nodeName) return;
        const o = document.createElement("details");
        o.classList.add("font-bold", "mb-[0.6rem]");
        const i = document.createElement("summary");
        i.classList.add("cursor-pointer", "text-foreground-primary"), i.innerHTML = t, o.appendChild(i), o.appendChild(r.cloneNode(!0)), o.open = !0, a.replaceChild(o, r);
      })({
        prismEnv: e,
        disclosureLabel: u
      })), us.highlightAllUnder(d.current));
    }, [i, c, u]), t.createElement(f, {
      className: p.join(" "),
      dangerouslySetInnerHTML: {
        __html: n
      },
      ref: d
    });
  },
  gs = e => {
    var {
        className: n,
        children: r,
        orientation: a = "vertical"
      } = e,
      o = b(e, ["className", "children", "orientation"]);
    const i = "horizontal" === a ? "flex flex-row" : "";
    return t.createElement("div", Object.assign({
      className: "mx-[-15px] ".concat(i, " ").concat(null != n ? n : "")
    }, o), r);
  },
  vs = {
    xxs: "h-[5px]",
    xs: "h-[10px]",
    s: "h-[20px]",
    m: "h-[30px]",
    l: "h-[60px]",
    xl: "h-[90px]",
    xxl: "h-[180px]"
  },
  hs = _ref42 => {
    let {
      size: e
    } = _ref42;
    return t.createElement("div", {
      className: vs[e]
    });
  },
  bs = ["table-auto", "w-full", "max-w-full", "border-collapse", "text-start", "text-foreground-tertiary", "[&_th]:font-normal"],
  ys = t.forwardRef((e, n) => {
    var {
        striped: r = !1,
        condensed: a = !1
      } = e,
      o = b(e, ["striped", "condensed"]);
    const i = t.useMemo(() => (_ref43 => {
      let {
        condensed: e,
        striped: t
      } = _ref43;
      const n = [...bs];
      return e ? n.push("[&_td]:p-1 [&_th]:p-1") : n.push("[&_td]:p-2 [&_th]:p-2"), t && n.push("[&>tbody>tr:nth-of-type(odd)]:bg-background-tertiary"), n.join(" ");
    })({
      condensed: a,
      striped: r
    }), [a, r]);
    return t.createElement("table", Object.assign({}, o, {
      ref: n,
      className: i
    }));
  });
function ws(e, t) {
  let {
    checkForDefaultPrevented: n = !0
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (r) {
    if (e !== null && e !== void 0 && e(r), !1 === n || !r.defaultPrevented) return t === null || t === void 0 ? void 0 : t(r);
  };
}
ys.displayName = "Table";
var xs = {
    exports: {}
  },
  ks = {},
  Es = t,
  Ss = 60103;
if (ks.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
  var Os = Symbol.for;
  Ss = Os("react.element"), ks.Fragment = Os("react.fragment");
}
var Ns = Es.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  As = Object.prototype.hasOwnProperty,
  Ps = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function Fs(e, t, n) {
  var r,
    a = {},
    o = null,
    i = null;
  for (r in void 0 !== n && (o = "" + n), void 0 !== t.key && (o = "" + t.key), void 0 !== t.ref && (i = t.ref), t) As.call(t, r) && !Ps.hasOwnProperty(r) && (a[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps) void 0 === a[r] && (a[r] = t[r]);
  return {
    $$typeof: Ss,
    type: e,
    key: o,
    ref: i,
    props: a,
    _owner: Ns.current
  };
}
ks.jsx = Fs, ks.jsxs = Fs;
var Ts,
  js = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Cs(t) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let r = [];
  const a = () => {
    const n = r.map(t => e.createContext(t));
    return function (r) {
      const a = (r === null || r === void 0 ? void 0 : r[t]) || n;
      return e.useMemo(() => ({
        ["__scope".concat(t)]: {
          ...r,
          [t]: a
        }
      }), [r, a]);
    };
  };
  return a.scopeName = t, [function (n, a) {
    const o = e.createContext(a),
      i = r.length;
    r = [...r, a];
    const l = n => {
      var _r$t;
      const {
          scope: r,
          children: a,
          ...l
        } = n,
        s = (r === null || r === void 0 || (_r$t = r[t]) === null || _r$t === void 0 ? void 0 : _r$t[i]) || o,
        c = e.useMemo(() => l, Object.values(l));
      return xs.exports.jsx(s.Provider, {
        value: c,
        children: a
      });
    };
    return l.displayName = n + "Provider", [l, function (r, l) {
      var _l$t;
      const s = (l === null || l === void 0 || (_l$t = l[t]) === null || _l$t === void 0 ? void 0 : _l$t[i]) || o,
        c = e.useContext(s);
      if (c) return c;
      if (void 0 !== a) return a;
      throw new Error("`".concat(r, "` must be used within `").concat(n, "`"));
    }];
  }, Rs(a, ...n)];
}
function Rs() {
  for (var _len13 = arguments.length, t = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    t[_key13] = arguments[_key13];
  }
  const n = t[0];
  if (1 === t.length) return n;
  const r = () => {
    const r = t.map(e => ({
      useScope: e(),
      scopeName: e.scopeName
    }));
    return function (t) {
      const a = r.reduce((e, _ref44) => {
        let {
          useScope: n,
          scopeName: r
        } = _ref44;
        return {
          ...e,
          ...n(t)["__scope".concat(r)]
        };
      }, {});
      return e.useMemo(() => ({
        ["__scope".concat(n.scopeName)]: a
      }), [a]);
    };
  };
  return r.scopeName = n.scopeName, r;
}
function Is(e, t) {
  if ("function" == typeof e) return e(t);
  null != e && (e.current = t);
}
function Ds() {
  for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    e[_key14] = arguments[_key14];
  }
  return t => {
    let n = !1;
    const r = e.map(e => {
      const r = Is(e, t);
      return n || "function" != typeof r || (n = !0), r;
    });
    if (n) return () => {
      for (let t = 0; t < r.length; t++) {
        const n = r[t];
        "function" == typeof n ? n() : Is(e[t], null);
      }
    };
  };
}
function Ls() {
  for (var _len15 = arguments.length, t = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    t[_key15] = arguments[_key15];
  }
  return e.useCallback(Ds(...t), t);
}
function Ms(t) {
  const n = _s(t),
    r = e.forwardRef((t, r) => {
      const {
          children: a,
          ...o
        } = t,
        i = e.Children.toArray(a),
        l = i.find(zs);
      if (l) {
        const t = l.props.children,
          a = i.map(n => n === l ? e.Children.count(t) > 1 ? e.Children.only(null) : e.isValidElement(t) ? t.props.children : null : n);
        return xs.exports.jsx(n, {
          ...o,
          ref: r,
          children: e.isValidElement(t) ? e.cloneElement(t, void 0, a) : null
        });
      }
      return xs.exports.jsx(n, {
        ...o,
        ref: r,
        children: a
      });
    });
  return r.displayName = "".concat(t, ".Slot"), r;
}
function _s(t) {
  const n = e.forwardRef((t, n) => {
    const {
      children: r,
      ...a
    } = t;
    if (e.isValidElement(r)) {
      const t = function (e, _Object$getOwnPropert, _Object$getOwnPropert2) {
          let t = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(e.props, "ref")) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.get,
            n = t && "isReactWarning" in t && t.isReactWarning;
          if (n) return e.ref;
          if (t = (_Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(e, "ref")) === null || _Object$getOwnPropert2 === void 0 ? void 0 : _Object$getOwnPropert2.get, n = t && "isReactWarning" in t && t.isReactWarning, n) return e.props.ref;
          return e.props.ref || e.ref;
        }(r),
        o = function (e, t) {
          const n = {
            ...t
          };
          for (const r in t) {
            const a = e[r],
              o = t[r];
            /^on[A-Z]/.test(r) ? a && o ? n[r] = function () {
              const t = o(...arguments);
              return a(...arguments), t;
            } : a && (n[r] = a) : "style" === r ? n[r] = {
              ...a,
              ...o
            } : "className" === r && (n[r] = [a, o].filter(Boolean).join(" "));
          }
          return {
            ...e,
            ...n
          };
        }(a, r.props);
      return r.type !== e.Fragment && (o.ref = n ? Ds(n, t) : t), e.cloneElement(r, o);
    }
    return e.Children.count(r) > 1 ? e.Children.only(null) : null;
  });
  return n.displayName = "".concat(t, ".SlotClone"), n;
}
Ts = js, "production" !== process.env.NODE_ENV && function () {
  var e = t,
    n = 60103,
    r = 60106;
  Ts.Fragment = 60107;
  var a = 60108,
    o = 60114,
    i = 60109,
    l = 60110,
    s = 60112,
    c = 60113,
    u = 60120,
    d = 60115,
    f = 60116,
    p = 60121,
    m = 60122,
    g = 60117,
    v = 60129,
    h = 60131;
  if ("function" == typeof Symbol && Symbol.for) {
    var b = Symbol.for;
    n = b("react.element"), r = b("react.portal"), Ts.Fragment = b("react.fragment"), a = b("react.strict_mode"), o = b("react.profiler"), i = b("react.provider"), l = b("react.context"), s = b("react.forward_ref"), c = b("react.suspense"), u = b("react.suspense_list"), d = b("react.memo"), f = b("react.lazy"), p = b("react.block"), m = b("react.server.block"), g = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), v = b("react.debug_trace_mode"), b("react.offscreen"), h = b("react.legacy_hidden");
  }
  var y = "function" == typeof Symbol && Symbol.iterator,
    w = "@@iterator",
    x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  function k(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
    !function (e, t, n) {
      var r = x.ReactDebugCurrentFrame,
        a = "";
      if (P) {
        var o = N(P.type),
          i = P._owner;
        a += function (e, t, n) {
          var r = "";
          if (t) {
            var a = t.fileName,
              o = a.replace(S, "");
            if (/^index\./.test(o)) {
              var i = a.match(S);
              if (i) {
                var l = i[1];
                l && (o = l.replace(S, "") + "/" + o);
              }
            }
            r = " (at " + o + ":" + t.lineNumber + ")";
          } else n && (r = " (created by " + n + ")");
          return "\n    in " + (e || "Unknown") + r;
        }(o, P._source, i && N(i.type));
      }
      "" !== (a += r.getStackAddendum()) && (t += "%s", n = n.concat([a]));
      var l = n.map(function (e) {
        return "" + e;
      });
      l.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, l);
    }("error", e, n);
  }
  var E = !1,
    S = /^(.*)[\\\/]/,
    O = 1;
  function N(e) {
    if (null == e) return null;
    if ("number" == typeof e.tag && k("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), "function" == typeof e) return e.displayName || e.name || null;
    if ("string" == typeof e) return e;
    switch (e) {
      case Ts.Fragment:
        return "Fragment";
      case r:
        return "Portal";
      case o:
        return "Profiler";
      case a:
        return "StrictMode";
      case c:
        return "Suspense";
      case u:
        return "SuspenseList";
    }
    if ("object" == typeof e) switch (e.$$typeof) {
      case l:
        return "Context.Consumer";
      case i:
        return "Context.Provider";
      case s:
        return m = e, g = e.render, v = "ForwardRef", h = g.displayName || g.name || "", m.displayName || ("" !== h ? v + "(" + h + ")" : v);
      case d:
        return N(e.type);
      case p:
        return N(e.render);
      case f:
        var t = (n = e)._status === O ? n._result : null;
        if (t) return N(t);
    }
    var n, m, g, v, h;
    return null;
  }
  var A = {};
  x.ReactDebugCurrentFrame;
  var P = null;
  function F(e) {
    P = e;
  }
  var T,
    j,
    C = x.ReactCurrentOwner,
    R = Object.prototype.hasOwnProperty,
    I = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    },
    D = function (e, t, r, a, o, i, l) {
      var s = {
        $$typeof: n,
        type: e,
        key: t,
        ref: r,
        props: l,
        _owner: i,
        _store: {}
      };
      return Object.defineProperty(s._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(s, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(s, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.freeze && (Object.freeze(s.props), Object.freeze(s)), s;
    };
  function L(e, t, n, r, a) {
    var o,
      i = {},
      l = null,
      s = null;
    for (o in void 0 !== n && (l = "" + n), function (e) {
      if (R.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning) return !1;
      }
      return void 0 !== e.key;
    }(t) && (l = "" + t.key), function (e) {
      if (R.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning) return !1;
      }
      return void 0 !== e.ref;
    }(t) && (s = t.ref, function (e, t) {
      "string" == typeof e.ref && C.current;
    }(t)), t) R.call(t, o) && !I.hasOwnProperty(o) && (i[o] = t[o]);
    if (e && e.defaultProps) {
      var c = e.defaultProps;
      for (o in c) void 0 === i[o] && (i[o] = c[o]);
    }
    if (l || s) {
      var u = "function" == typeof e ? e.displayName || e.name || "Unknown" : e;
      l && function (e, t) {
        var n = function () {
          T || (T = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }(i, u), s && function (e, t) {
        var n = function () {
          j || (j = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }(i, u);
    }
    return D(e, l, s, a, r, C.current, i);
  }
  var M,
    _ = x.ReactCurrentOwner;
  function $(e) {
    P = e;
  }
  function z(e) {
    return "object" == typeof e && null !== e && e.$$typeof === n;
  }
  function B() {
    if (_.current) {
      var e = N(_.current.type);
      if (e) return "\n\nCheck the render method of `" + e + "`.";
    }
    return "";
  }
  x.ReactDebugCurrentFrame, M = !1;
  var H = {};
  function U(e, t) {
    if (e._store && !e._store.validated && null == e.key) {
      e._store.validated = !0;
      var n = function (e) {
        var t = B();
        if (!t) {
          var n = "string" == typeof e ? e : e.displayName || e.name;
          n && (t = "\n\nCheck the top-level render call using <" + n + ">.");
        }
        return t;
      }(t);
      if (!H[n]) {
        H[n] = !0;
        var r = "";
        e && e._owner && e._owner !== _.current && (r = " It was passed a child from " + N(e._owner.type) + "."), $(e), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, r), $(null);
      }
    }
  }
  function W(e, t) {
    if ("object" == typeof e) if (Array.isArray(e)) for (var n = 0; n < e.length; n++) {
      var r = e[n];
      z(r) && U(r, t);
    } else if (z(e)) e._store && (e._store.validated = !0);else if (e) {
      var a = function (e) {
        if (null === e || "object" != typeof e) return null;
        var t = y && e[y] || e[w];
        return "function" == typeof t ? t : null;
      }(e);
      if ("function" == typeof a && a !== e.entries) for (var o, i = a.call(e); !(o = i.next()).done;) z(o.value) && U(o.value, t);
    }
  }
  function q(e) {
    var t,
      n = e.type;
    if (null != n && "string" != typeof n) {
      if ("function" == typeof n) t = n.propTypes;else {
        if ("object" != typeof n || n.$$typeof !== s && n.$$typeof !== d) return;
        t = n.propTypes;
      }
      if (t) {
        var r = N(n);
        !function (e, t, n, r, a) {
          var o = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var i in e) if (o(e, i)) {
            var l = void 0;
            try {
              if ("function" != typeof e[i]) {
                var s = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw s.name = "Invariant Violation", s;
              }
              l = e[i](t, i, r, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (e) {
              l = e;
            }
            !l || l instanceof Error || (F(a), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", r || "React class", n, i, typeof l), F(null)), l instanceof Error && !(l.message in A) && (A[l.message] = !0, F(a), k("Failed %s type: %s", n, l.message), F(null));
          }
        }(t, e.props, "prop", r, e);
      } else void 0 === n.PropTypes || M || (M = !0, k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", N(n) || "Unknown"));
      "function" != typeof n.getDefaultProps || n.getDefaultProps.isReactClassApproved || k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function V(e, t, r, b, y, w) {
    var x = function (e) {
      return "string" == typeof e || "function" == typeof e || !(e !== Ts.Fragment && e !== o && e !== v && e !== a && e !== c && e !== u && e !== h && !E) || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === d || e.$$typeof === i || e.$$typeof === l || e.$$typeof === s || e.$$typeof === g || e.$$typeof === p || e[0] === m);
    }(e);
    if (!x) {
      var S,
        O = "";
      (void 0 === e || "object" == typeof e && null !== e && 0 === Object.keys(e).length) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), O += B(), null === e ? S = "null" : Array.isArray(e) ? S = "array" : void 0 !== e && e.$$typeof === n ? (S = "<" + (N(e.type) || "Unknown") + " />", O = " Did you accidentally export a JSX literal instead of a component?") : S = typeof e, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", S, O);
    }
    var A = L(e, t, r, y, w);
    if (null == A) return A;
    if (x) {
      var P = t.children;
      if (void 0 !== P) if (b) {
        if (Array.isArray(P)) {
          for (var F = 0; F < P.length; F++) W(P[F], e);
          Object.freeze && Object.freeze(P);
        } else k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
      } else W(P, e);
    }
    return e === Ts.Fragment ? function (e) {
      for (var t = Object.keys(e.props), n = 0; n < t.length; n++) {
        var r = t[n];
        if ("children" !== r && "key" !== r) {
          $(e), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", r), $(null);
          break;
        }
      }
      null !== e.ref && ($(e), k("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
    }(A) : q(A), A;
  }
  var Y = function (e, t, n) {
      return V(e, t, n, !1);
    },
    G = function (e, t, n) {
      return V(e, t, n, !0);
    };
  Ts.jsx = Y, Ts.jsxs = G;
}(), "production" === process.env.NODE_ENV ? xs.exports = ks : xs.exports = js;
var $s = Symbol("radix.slottable");
function zs(t) {
  return e.isValidElement(t) && "function" == typeof t.type && "__radixId" in t.type && t.type.__radixId === $s;
}
var Bs = globalThis !== null && globalThis !== void 0 && globalThis.document ? e.useLayoutEffect : () => {},
  Hs = e[" useId ".trim().toString()] || (() => {}),
  Us = 0;
function Ws(t) {
  const [n, r] = e.useState(Hs());
  return Bs(() => {
    r(e => e !== null && e !== void 0 ? e : String(Us++));
  }, [t]), n ? "radix-".concat(n) : "";
}
var qs = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "select", "span", "svg", "ul"].reduce((t, n) => {
  const r = Ms("Primitive.".concat(n)),
    a = e.forwardRef((e, t) => {
      const {
          asChild: a,
          ...o
        } = e,
        i = a ? r : n;
      return "undefined" != typeof window && (window[Symbol.for("radix-ui")] = !0), xs.exports.jsx(i, {
        ...o,
        ref: t
      });
    });
  return a.displayName = "Primitive.".concat(n), {
    ...t,
    [n]: a
  };
}, {});
var Vs = e[" useInsertionEffect ".trim().toString()] || Bs;
function Ys(_ref45) {
  let {
    prop: t,
    defaultProp: n,
    onChange: r = () => {},
    caller: a
  } = _ref45;
  const [o, i, l] = function (_ref46) {
      let {
        defaultProp: t,
        onChange: n
      } = _ref46;
      const [r, a] = e.useState(t),
        o = e.useRef(r),
        i = e.useRef(n);
      return Vs(() => {
        i.current = n;
      }, [n]), e.useEffect(() => {
        var _i$current;
        o.current !== r && ((_i$current = i.current) !== null && _i$current !== void 0 && _i$current.call(i, r), o.current = r);
      }, [r, o]), [r, a, i];
    }({
      defaultProp: n,
      onChange: r
    }),
    s = void 0 !== t,
    c = s ? t : o;
  {
    const n = e.useRef(void 0 !== t);
    e.useEffect(() => {
      const e = n.current;
      if (e !== s) {
        const t = e ? "controlled" : "uncontrolled",
          n = s ? "controlled" : "uncontrolled";
        console.warn("".concat(a, " is changing from ").concat(t, " to ").concat(n, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
      }
      n.current = s;
    }, [s, a]);
  }
  const u = e.useCallback(e => {
    if (s) {
      var _l$current;
      const n = function (e) {
        return "function" == typeof e;
      }(e) ? e(t) : e;
      n !== t && ((_l$current = l.current) === null || _l$current === void 0 ? void 0 : _l$current.call(l, n));
    } else i(e);
  }, [s, t, i, l]);
  return [c, u];
}
var Gs = e.createContext(void 0);
function Ks(t) {
  const n = e.useContext(Gs);
  return t || n || "ltr";
}
var Xs = "rovingFocusGroup.onEntryFocus",
  Js = {
    bubbles: !1,
    cancelable: !0
  },
  Qs = "RovingFocusGroup",
  [Zs, ec, tc] = function (e) {
    const n = e + "CollectionProvider",
      [r, a] = Cs(n),
      [o, i] = r(n, {
        collectionRef: {
          current: null
        },
        itemMap: new Map()
      }),
      l = e => {
        const {
            scope: n,
            children: r
          } = e,
          a = t.useRef(null),
          i = t.useRef(new Map()).current;
        return xs.exports.jsx(o, {
          scope: n,
          itemMap: i,
          collectionRef: a,
          children: r
        });
      };
    l.displayName = n;
    const s = e + "CollectionSlot",
      c = Ms(s),
      u = t.forwardRef((e, t) => {
        const {
            scope: n,
            children: r
          } = e,
          a = Ls(t, i(s, n).collectionRef);
        return xs.exports.jsx(c, {
          ref: a,
          children: r
        });
      });
    u.displayName = s;
    const d = e + "CollectionItemSlot",
      f = "data-radix-collection-item",
      p = Ms(d),
      m = t.forwardRef((e, n) => {
        const {
            scope: r,
            children: a,
            ...o
          } = e,
          l = t.useRef(null),
          s = Ls(n, l),
          c = i(d, r);
        return t.useEffect(() => (c.itemMap.set(l, {
          ref: l,
          ...o
        }), () => {
          c.itemMap.delete(l);
        })), xs.exports.jsx(p, {
          [f]: "",
          ref: s,
          children: a
        });
      });
    return m.displayName = d, [{
      Provider: l,
      Slot: u,
      ItemSlot: m
    }, function (n) {
      const r = i(e + "CollectionConsumer", n),
        a = t.useCallback(() => {
          const e = r.collectionRef.current;
          if (!e) return [];
          const t = Array.from(e.querySelectorAll("[".concat(f, "]"))),
            n = Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
          return n;
        }, [r.collectionRef, r.itemMap]);
      return a;
    }, a];
  }(Qs),
  [nc, rc] = Cs(Qs, [tc]),
  [ac, oc] = nc(Qs),
  ic = e.forwardRef((e, t) => xs.exports.jsx(Zs.Provider, {
    scope: e.__scopeRovingFocusGroup,
    children: xs.exports.jsx(Zs.Slot, {
      scope: e.__scopeRovingFocusGroup,
      children: xs.exports.jsx(lc, {
        ...e,
        ref: t
      })
    })
  }));
ic.displayName = Qs;
var lc = e.forwardRef((t, n) => {
    const {
        __scopeRovingFocusGroup: r,
        orientation: a,
        loop: o = !1,
        dir: i,
        currentTabStopId: l,
        defaultCurrentTabStopId: s,
        onCurrentTabStopIdChange: c,
        onEntryFocus: u,
        preventScrollOnEntryFocus: d = !1,
        ...f
      } = t,
      p = e.useRef(null),
      m = Ls(n, p),
      g = Ks(i),
      [v, h] = Ys({
        prop: l,
        defaultProp: s !== null && s !== void 0 ? s : null,
        onChange: c,
        caller: Qs
      }),
      [b, y] = e.useState(!1),
      w = function (t) {
        const n = e.useRef(t);
        return e.useEffect(() => {
          n.current = t;
        }), e.useMemo(() => function () {
          var _n$current;
          for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
            e[_key16] = arguments[_key16];
          }
          return (_n$current = n.current) === null || _n$current === void 0 ? void 0 : _n$current.call(n, ...e);
        }, []);
      }(u),
      x = ec(r),
      k = e.useRef(!1),
      [E, S] = e.useState(0);
    return e.useEffect(() => {
      const e = p.current;
      if (e) return e.addEventListener(Xs, w), () => e.removeEventListener(Xs, w);
    }, [w]), xs.exports.jsx(ac, {
      scope: r,
      orientation: a,
      dir: g,
      loop: o,
      currentTabStopId: v,
      onItemFocus: e.useCallback(e => h(e), [h]),
      onItemShiftTab: e.useCallback(() => y(!0), []),
      onFocusableItemAdd: e.useCallback(() => S(e => e + 1), []),
      onFocusableItemRemove: e.useCallback(() => S(e => e - 1), []),
      children: xs.exports.jsx(qs.div, {
        tabIndex: b || 0 === E ? -1 : 0,
        "data-orientation": a,
        ...f,
        ref: m,
        style: {
          outline: "none",
          ...t.style
        },
        onMouseDown: ws(t.onMouseDown, () => {
          k.current = !0;
        }),
        onFocus: ws(t.onFocus, e => {
          const t = !k.current;
          if (e.target === e.currentTarget && t && !b) {
            const t = new CustomEvent(Xs, Js);
            if (e.currentTarget.dispatchEvent(t), !t.defaultPrevented) {
              const e = x().filter(e => e.focusable);
              dc([e.find(e => e.active), e.find(e => e.id === v), ...e].filter(Boolean).map(e => e.ref.current), d);
            }
          }
          k.current = !1;
        }),
        onBlur: ws(t.onBlur, () => y(!1))
      })
    });
  }),
  sc = "RovingFocusGroupItem",
  cc = e.forwardRef((t, n) => {
    const {
        __scopeRovingFocusGroup: r,
        focusable: a = !0,
        active: o = !1,
        tabStopId: i,
        children: l,
        ...s
      } = t,
      c = Ws(),
      u = i || c,
      d = oc(sc, r),
      f = d.currentTabStopId === u,
      p = ec(r),
      {
        onFocusableItemAdd: m,
        onFocusableItemRemove: g,
        currentTabStopId: v
      } = d;
    return e.useEffect(() => {
      if (a) return m(), () => g();
    }, [a, m, g]), xs.exports.jsx(Zs.ItemSlot, {
      scope: r,
      id: u,
      focusable: a,
      active: o,
      children: xs.exports.jsx(qs.span, {
        tabIndex: f ? 0 : -1,
        "data-orientation": d.orientation,
        ...s,
        ref: n,
        onMouseDown: ws(t.onMouseDown, e => {
          a ? d.onItemFocus(u) : e.preventDefault();
        }),
        onFocus: ws(t.onFocus, () => d.onItemFocus(u)),
        onKeyDown: ws(t.onKeyDown, e => {
          if ("Tab" === e.key && e.shiftKey) return void d.onItemShiftTab();
          if (e.target !== e.currentTarget) return;
          const t = function (e, t, n) {
            const r = function (e, t) {
              return "rtl" !== t ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
            }(e.key, n);
            return "vertical" === t && ["ArrowLeft", "ArrowRight"].includes(r) || "horizontal" === t && ["ArrowUp", "ArrowDown"].includes(r) ? void 0 : uc[r];
          }(e, d.orientation, d.dir);
          if (void 0 !== t) {
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
            e.preventDefault();
            let a = p().filter(e => e.focusable).map(e => e.ref.current);
            if ("last" === t) a.reverse();else if ("prev" === t || "next" === t) {
              "prev" === t && a.reverse();
              const o = a.indexOf(e.currentTarget);
              a = d.loop ? (r = o + 1, (n = a).map((e, t) => n[(r + t) % n.length])) : a.slice(o + 1);
            }
            setTimeout(() => dc(a));
          }
          var n, r;
        }),
        children: "function" == typeof l ? l({
          isCurrentTabStop: f,
          hasTabStop: null != v
        }) : l
      })
    });
  });
cc.displayName = sc;
var uc = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function dc(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  const n = document.activeElement;
  for (const r of e) {
    if (r === n) return;
    if (r.focus({
      preventScroll: t
    }), document.activeElement !== n) return;
  }
}
var fc = ic,
  pc = cc;
var mc = t => {
  const {
      present: n,
      children: r
    } = t,
    a = function (t) {
      const [n, r] = e.useState(),
        a = e.useRef(null),
        o = e.useRef(t),
        i = e.useRef("none"),
        l = t ? "mounted" : "unmounted",
        [s, c] = function (t, n) {
          return e.useReducer((e, t) => {
            var _n$e$t;
            return (_n$e$t = n[e][t]) !== null && _n$e$t !== void 0 ? _n$e$t : e;
          }, t);
        }(l, {
          mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
          },
          unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
          },
          unmounted: {
            MOUNT: "mounted"
          }
        });
      return e.useEffect(() => {
        const e = gc(a.current);
        i.current = "mounted" === s ? e : "none";
      }, [s]), Bs(() => {
        const e = a.current,
          n = o.current;
        if (n !== t) {
          const r = i.current,
            a = gc(e);
          if (t) c("MOUNT");else if ("none" === a || "none" === (e === null || e === void 0 ? void 0 : e.display)) c("UNMOUNT");else {
            c(n && r !== a ? "ANIMATION_OUT" : "UNMOUNT");
          }
          o.current = t;
        }
      }, [t, c]), Bs(() => {
        if (n) {
          var _n$ownerDocument$defa;
          let e;
          const t = (_n$ownerDocument$defa = n.ownerDocument.defaultView) !== null && _n$ownerDocument$defa !== void 0 ? _n$ownerDocument$defa : window,
            r = r => {
              const i = gc(a.current).includes(CSS.escape(r.animationName));
              if (r.target === n && i && (c("ANIMATION_END"), !o.current)) {
                const r = n.style.animationFillMode;
                n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
                  "forwards" === n.style.animationFillMode && (n.style.animationFillMode = r);
                });
              }
            },
            l = e => {
              e.target === n && (i.current = gc(a.current));
            };
          return n.addEventListener("animationstart", l), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
            t.clearTimeout(e), n.removeEventListener("animationstart", l), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
          };
        }
        c("ANIMATION_END");
      }, [n, c]), {
        isPresent: ["mounted", "unmountSuspended"].includes(s),
        ref: e.useCallback(e => {
          a.current = e ? getComputedStyle(e) : null, r(e);
        }, [])
      };
    }(n),
    o = "function" == typeof r ? r({
      present: a.isPresent
    }) : e.Children.only(r),
    i = Ls(a.ref, function (e, _Object$getOwnPropert3, _Object$getOwnPropert4) {
      let t = (_Object$getOwnPropert3 = Object.getOwnPropertyDescriptor(e.props, "ref")) === null || _Object$getOwnPropert3 === void 0 ? void 0 : _Object$getOwnPropert3.get,
        n = t && "isReactWarning" in t && t.isReactWarning;
      if (n) return e.ref;
      if (t = (_Object$getOwnPropert4 = Object.getOwnPropertyDescriptor(e, "ref")) === null || _Object$getOwnPropert4 === void 0 ? void 0 : _Object$getOwnPropert4.get, n = t && "isReactWarning" in t && t.isReactWarning, n) return e.props.ref;
      return e.props.ref || e.ref;
    }(o));
  return "function" == typeof r || a.isPresent ? e.cloneElement(o, {
    ref: i
  }) : null;
};
function gc(e) {
  return (e === null || e === void 0 ? void 0 : e.animationName) || "none";
}
mc.displayName = "Presence";
var vc = "Tabs",
  [hc, bc] = Cs(vc, [rc]),
  yc = rc(),
  [wc, xc] = hc(vc),
  kc = e.forwardRef((e, t) => {
    const {
        __scopeTabs: n,
        value: r,
        onValueChange: a,
        defaultValue: o,
        orientation: i = "horizontal",
        dir: l,
        activationMode: s = "automatic",
        ...c
      } = e,
      u = Ks(l),
      [d, f] = Ys({
        prop: r,
        onChange: a,
        defaultProp: o !== null && o !== void 0 ? o : "",
        caller: vc
      });
    return xs.exports.jsx(wc, {
      scope: n,
      baseId: Ws(),
      value: d,
      onValueChange: f,
      orientation: i,
      dir: u,
      activationMode: s,
      children: xs.exports.jsx(qs.div, {
        dir: u,
        "data-orientation": i,
        ...c,
        ref: t
      })
    });
  });
kc.displayName = vc;
var Ec = "TabsList",
  Sc = e.forwardRef((e, t) => {
    const {
        __scopeTabs: n,
        loop: r = !0,
        ...a
      } = e,
      o = xc(Ec, n),
      i = yc(n);
    return xs.exports.jsx(fc, {
      asChild: !0,
      ...i,
      orientation: o.orientation,
      dir: o.dir,
      loop: r,
      children: xs.exports.jsx(qs.div, {
        role: "tablist",
        "aria-orientation": o.orientation,
        ...a,
        ref: t
      })
    });
  });
Sc.displayName = Ec;
var Oc = "TabsTrigger",
  Nc = e.forwardRef((e, t) => {
    const {
        __scopeTabs: n,
        value: r,
        disabled: a = !1,
        ...o
      } = e,
      i = xc(Oc, n),
      l = yc(n),
      s = Fc(i.baseId, r),
      c = Tc(i.baseId, r),
      u = r === i.value;
    return xs.exports.jsx(pc, {
      asChild: !0,
      ...l,
      focusable: !a,
      active: u,
      children: xs.exports.jsx(qs.button, {
        type: "button",
        role: "tab",
        "aria-selected": u,
        "aria-controls": c,
        "data-state": u ? "active" : "inactive",
        "data-disabled": a ? "" : void 0,
        disabled: a,
        id: s,
        ...o,
        ref: t,
        onMouseDown: ws(e.onMouseDown, e => {
          a || 0 !== e.button || !1 !== e.ctrlKey ? e.preventDefault() : i.onValueChange(r);
        }),
        onKeyDown: ws(e.onKeyDown, e => {
          [" ", "Enter"].includes(e.key) && i.onValueChange(r);
        }),
        onFocus: ws(e.onFocus, () => {
          const e = "manual" !== i.activationMode;
          u || a || !e || i.onValueChange(r);
        })
      })
    });
  });
Nc.displayName = Oc;
var Ac = "TabsContent",
  Pc = e.forwardRef((t, n) => {
    const {
        __scopeTabs: r,
        value: a,
        forceMount: o,
        children: i,
        ...l
      } = t,
      s = xc(Ac, r),
      c = Fc(s.baseId, a),
      u = Tc(s.baseId, a),
      d = a === s.value,
      f = e.useRef(d);
    return e.useEffect(() => {
      const e = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(e);
    }, []), xs.exports.jsx(mc, {
      present: o || d,
      children: _ref47 => {
        let {
          present: e
        } = _ref47;
        return xs.exports.jsx(qs.div, {
          "data-state": d ? "active" : "inactive",
          "data-orientation": s.orientation,
          role: "tabpanel",
          "aria-labelledby": c,
          hidden: !e,
          id: u,
          tabIndex: 0,
          ...l,
          ref: n,
          style: {
            ...t.style,
            animationDuration: f.current ? "0s" : void 0
          },
          children: e && i
        });
      }
    });
  });
function Fc(e, t) {
  return "".concat(e, "-trigger-").concat(t);
}
function Tc(e, t) {
  return "".concat(e, "-content-").concat(t);
}
Pc.displayName = Ac;
var jc = kc,
  Cc = Sc,
  Rc = Nc,
  Ic = Pc;
const Dc = "flex-1 block relative px-2.5 py-[5px] text-sm text-foreground-secondary border-none aria-selected:font-bold aria-selected:bg-foreground-quaternary aria-selected:text-background-secondary hover:bg-background-quaternary",
  Lc = "flex mb-0 pl-0 mt-0 border-b-[1px] border-solid border-foreground-quaternary",
  Mc = t.forwardRef((e, n) => {
    var {
        className: r
      } = e,
      a = b(e, ["className"]);
    const o = [Dc, r].join(" ");
    return t.createElement(Rc, Object.assign({
      ref: n,
      className: o
    }, a));
  }),
  _c = t.forwardRef((e, n) => {
    var {
        className: r
      } = e,
      a = b(e, ["className"]);
    const o = [Lc, r].join(" ");
    return t.createElement(Cc, Object.assign({
      ref: n,
      className: o
    }, a));
  }),
  $c = jc,
  zc = Ic;
zc.displayName = Ic.displayName, Mc.displayName = Rc.displayName, _c.displayName = Cc.displayName;
const Bc = ["block", "relative", "w-[20px]", "h-[20px]", "bg-background-secondary", "rounded-full", "border-2", "border-foreground-primary", "me-[15px]", "shrink-0"],
  Hc = ["outline", "outline-3", "outline-focus-outline-color", "outline-offset-2"],
  Uc = ["before:absolute", "before:w-[10px]", "before:h-[10px]", "before:bg-foreground-primary", "before:rounded-full", "before:top-1/2", "before:start-1/2", "before:-translate-x-1/2", "before:-translate-y-1/2"],
  Wc = ["focus:outline-none", "cursor-pointer", "p-[20px]", "flex", "items-center"],
  qc = ["flex", "flex-col", "border-x-4", "border-t-4", "last:border-b-4", "border-background-tertiary", "bg-background-primary"],
  Vc = _ref48 => {
    let {
      active: e,
      checked: n
    } = _ref48;
    let r = [...Bc];
    return e && (r = r.concat(Hc)), n && (r = r.concat(Uc)), t.createElement("span", {
      className: r.join(" ")
    });
  },
  Yc = _ref49 => {
    let {
      state: e,
      message: n
    } = _ref49;
    return "correct" === e ? t.createElement("p", {
      className: "text-background-success"
    }, t.createElement(Ll, {
      icon: Bl,
      className: "text-background-success me-[8px]"
    }), n) : t.createElement("p", {
      className: "text-background-danger"
    }, t.createElement(Ll, {
      icon: zl,
      className: "text-background-danger me-[8px]"
    }), n);
  },
  Gc = _ref50 => {
    let {
      value: e,
      label: n,
      disabled: r,
      checked: a,
      validation: o,
      feedback: i
    } = _ref50;
    return t.createElement("div", {
      className: (() => {
        const e = [...qc];
        return "correct" === (null == o ? void 0 : o.state) && e.push("border-l-background-success"), "incorrect" === (null == o ? void 0 : o.state) && e.push("border-l-background-danger"), e.join(" ");
      })()
    }, t.createElement(Mn.Option, {
      key: e,
      value: e,
      "data-value": e,
      className: (() => {
        const e = [...Wc];
        return r && e.push("aria-disabled:cursor-not-allowed", "aria-disabled:opacity-80"), e.join(" ");
      })()
    }, _ref51 => {
      let {
        active: e
      } = _ref51;
      return t.createElement(t.Fragment, null, t.createElement(Vc, {
        active: e,
        checked: !!a
      }), t.createElement(Mn.Label, {
        className: "m-0 text-foreground-primary overflow-auto"
      }, n));
    }), (!!o || !!i) && t.createElement("div", {
      className: "ps-[20px] pb-[20px] [&>p:last-child]:m-0"
    }, o && t.createElement(Yc, {
      state: o.state,
      message: o.message
    }), i && t.createElement("div", {
      className: "text-foreground-primary"
    }, i)));
  },
  Kc = _ref52 => {
    let {
      question: e,
      position: n
    } = _ref52;
    return null == n ? t.createElement("span", {
      className: "text-foreground-primary"
    }, e) : t.createElement("span", {
      className: "text-foreground-primary flex"
    }, t.createElement("span", null, n, "."), " ", e);
  },
  Xc = _ref53 => {
    let {
      question: e,
      answers: n,
      required: r,
      disabled: a,
      selectedAnswer: o,
      onChange: i,
      position: l
    } = _ref53;
    return t.createElement(Mn, {
      onChange: e => {
        i && i(e);
      },
      "aria-required": r,
      disabled: a,
      value: null != o ? o : null
    }, t.createElement(Mn.Label, {
      className: "block mb-[20px]"
    }, t.createElement(Kc, {
      question: e,
      position: l
    })), n.map(_ref54 => {
      let {
        value: e,
        label: n,
        feedback: r,
        validation: i
      } = _ref54;
      const l = o === e;
      return t.createElement(Gc, {
        key: e,
        value: e,
        label: n,
        feedback: l && i && r,
        checked: l,
        disabled: a,
        validation: i
      });
    }));
  },
  Jc = _ref55 => {
    let {
      questions: e,
      disabled: n,
      required: r
    } = _ref55;
    return t.createElement("ul", {
      className: "flex flex-col gap-y-[48px] list-none"
    }, e.map((e, a) => t.createElement("li", {
      key: a
    }, t.createElement(Xc, Object.assign({}, e, {
      position: a + 1,
      disabled: n,
      required: r
    })))));
  },
  Qc = _ref56 => {
    let {
      initialQuestions: e,
      validationMessages: t,
      onSuccess: n,
      onFailure: r,
      passingPercent: a,
      showCorrectAnswersOnSuccess: o
    } = _ref56;
    const [i, l] = s(e),
      [c, u] = s({
        validated: !1
      }),
      d = i.map((e, t) => Object.assign(Object.assign({}, e), {
        onChange: e => {
          l(n => n.map((n, r) => r === t ? Object.assign(Object.assign({}, n), {
            selectedAnswer: e
          }) : n));
        }
      }));
    return Object.assign({
      questions: d,
      validateAnswers: () => {
        l(i => {
          const l = i.filter(_ref57 => {
              let {
                selectedAnswer: e,
                correctAnswer: t
              } = _ref57;
              return e === t;
            }).length,
            s = parseFloat((l / e.length * 100).toFixed(2)),
            c = i.map(e => {
              const n = e.answers.map(n => {
                let r;
                return n.value === e.selectedAnswer ? r = n.value === e.correctAnswer ? {
                  state: "correct",
                  message: t.correct
                } : {
                  state: "incorrect",
                  message: t.incorrect
                } : n.value === e.correctAnswer && s >= a && o && (r = {
                  state: "correct",
                  message: t.correct
                }), Object.assign(Object.assign({}, n), {
                  validation: r
                });
              });
              return Object.assign(Object.assign({}, e), {
                answers: n
              });
            });
          return u({
            validated: !0,
            grade: s,
            correctAnswerCount: l
          }), s >= a ? n && n() : r && r(), c;
        });
      }
    }, c);
  },
  Zc = e => e ? "dark" === e ? "dark-palette" : "light-palette" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark-palette" : "light-palette";
export { w as Alert, O as Button, A as Callout, P as CloseButton, M as Col, _ as Container, U as ControlLabel, Yl as Dropdown, Xl as FormControl, B as FormGroup, Zl as HelpBlock, es as Image, ns as MenuItem, as as Modal, ss as Panel, ms as PrismFormatted, Jc as Quiz, Xc as QuizQuestion, gs as Row, hs as Spacer, ys as Table, $c as Tabs, zc as TabsContent, _c as TabsList, Mc as TabsTrigger, Zc as getThemingClass, Qc as useQuiz };